export default {
  homeDashboard: {
    // Header
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    live: 'Live',
    updated: 'updated',
    customize: 'Customize',
    sampleData: 'Sample data',
    sample: 'Sample',
    // Needs your review
    reviewTitle: 'Needs your review',
    // Learning plans
    learningPlansTitle: 'Learning plans',
    plansThisWeek: 'This week',
    plansNextWeek: 'Next week',
    plansApproved: 'approved',
    plansAwaiting: 'awaiting',
    plansOfGroups: 'of {total} groups',
    plansMissing: '{count} with no plan',
    noGroups: 'No groups set up yet.',
    openLearn: 'Learning',
    // RSVP
    rsvpTitle: 'RSVPs today',
    rsvpAway: 'Away today',
    rsvpNoSchoolPickup: 'No school pickup needed',
    noRsvpsToday: 'No RSVPs for today.',
    openRsvp: 'RSVP',
    reviewIncidents: 'Incidents and health to approve',
    reviewPlans: 'Lessons and plans to approve',
    reviewExpiries: 'Expiring in the next 30 days',
    reviewInfoChanges: 'Family info changes to review',
    reviewSpaceSetup: 'Rooms with incomplete setup',
    reviewUnacknowledged: 'Not yet seen by parents',
    reviewAssessments: 'Assessments to approve',
    reviewOpen: 'Open',
    reviewClear: 'Nothing waiting on you',
    reviewNoAccess: 'Approvals need admin access',
    // Stat strip
    childrenPresent: 'Children present',
    staffOnFloor: 'Staff on floor',
    overdueBalances: 'Overdue balances',
    occupancyThisWeek: 'Occupancy · this week',
    onTrack: 'on track',
    ofCount: 'of {total}',
    families: '{count} families',
    // Widget titles
    briefingTitle: "Today's briefing",
    needsAttentionTitle: 'Needs attention',
    rhythmTitle: "Today's rhythm",
    pipelineTitle: 'Pipeline',
    financeTitle: 'Finance',
    rightNowTitle: 'Right now',
    todayTitle: 'Today',
    celebrationsTitle: 'Celebrations',
    quickActionsTitle: 'Quick actions',
    // Links
    openTasks: 'Open tasks',
    openAttendance: 'Attendance',
    openAdmissions: 'Admissions',
    openFinances: 'Finances',
    openCalendar: 'Calendar',
    openBilling: 'Open billing',
    // Needs attention
    allCaughtUp: 'All caught up',
    allCaughtUpSub: 'Nothing needs your attention right now.',
    showMore: 'more',
    noCelebrations: 'No upcoming celebrations.',
    nothingToday: 'Nothing scheduled today.',
    // Right now
    ofExpected: 'of {total} expected',
    staffOnFloorCount: '{count} staff on floor · {out} out today',
    childrenSignedIn: 'children signed in',
    ofCapacity: 'of {total} capacity',
    staffRooms: '{count} staff on floor · {rooms} rooms',
    noneSignedIn: 'No children are signed in right now.',
    onRatio: 'On ratio',
    stateOk: 'On ratio',
    stateTight: 'Needs attention',
    // Rhythm
    staffingCoverage: 'Staffing coverage',
    legendChildrenIn: 'children in (actual)',
    legendExpected: 'expected',
    legendStaffed: 'staffed to ratio',
    legendTight: 'tight / short',
    // Pipeline / admissions
    inquiries: 'Inquiries',
    toursThisWeek: 'Tours this week',
    newInquiriesThisWeek: 'New inquiries this week',
    // Stage boxes mirror the Admissions sub-tabs
    stageInquiries: 'Inquiries',
    stageTours: 'Tours',
    stageWaitlist: 'Waitlist',
    stageOnboarding: 'Onboarding',
    stageLeaving: 'Leaving',
    noAdmissions: 'No admissions activity yet.',
    // Finance
    collectedMonth: 'Collected · {month}',
    overThirty: '{amount} over 30d',
    outstandingTotal: 'Outstanding',
    personalSponsors: 'Families',
    thirdPartySponsors: 'Third parties',
    thirdParties: '{count} third parties',
    noFinanceData: 'No balances to show.',
    // Quick actions
    recordPayment: 'Record payment',
    addEvent: 'Add event',
    sendEmail: 'Send email',
    addChild: 'Add child',
    messageFamilies: 'Message families',
    newActivity: 'New activity',
    // Customize / edit mode
    done: 'Done',
    reset: 'Reset to default',
    editHint:
      'Drag cards to rearrange them. Hide a card with the eye, or drop it in the tray below.',
    hiddenWidgets: 'Hidden widgets',
    dragToHide: 'Drag a card here to hide it.',
    hideWidget: 'Hide {name}',
    addWidget: 'Add {name}',
    // Customize panel
    yourDashboard: 'Your dashboard',
    widgetsShown: '{shown} of {total} widgets shown',
    customizeDesc:
      'Turn widgets on or off — changes save automatically, and you can re-add them here anytime.',
    dragHint:
      'Drag a card into another area to move it — changes save automatically.',
    catOperations: 'Operations',
    catFamily: 'Family & staff',
    catEnrollment: 'Enrollment & finance',
    catPlanning: 'Planning',
  },
  'Expected Fee Collection (1%)': 'Expected Fee Collection (1%)',
  'Organization Name': 'Organization Name',
  'Organization Setup': 'Organization Setup',
  'Super Admin': 'Super Admin',
  'Total Fee Collection (Approved)': 'Total Fee Collection (Approved)',
  'Total Fee Collection (Declined)': 'Total Fee Collection (Declined)',
  'Total Fee Collection (Pending)': 'Total Fee Collection (Pending)',
  'Total Settled Payments': 'Total Settled Payments',
  abbreviation: 'Abbreviation',
  absence: 'Absence',
  absenceReason: 'Reason for Absence',
  absencesReported: 'Absences Reported',
  absencesToVerify: 'Absences to Verify',
  absent: 'Absent',
  absentDates: 'Absent Dates',
  accept: 'Accept',
  accessibility: 'Accessibility',
  accessibilitySettingsDescription: 'Text size and display options',
  accountAndSettings: 'Account and Settings',
  accounting: 'Accounting',
  accountNumber: 'Account Number',
  acknowledge: 'Acknowledge',
  acknowledged: 'Acknowledged',
  acknowledgedDate: 'Acknowledged Date',
  acknowledgedOverridden: 'Acknowledged/Overridden',
  acknowledgedReceiptText: 'acknowledged receipt of this report on',
  acknowledgeReceiptOfReport: 'Acknowledge Receipt of Report',
  acknowledgeReport: 'Acknowledge Report',
  acknowledgingAs: 'Acknowledging as',
  acknowledgmentExplanation:
    'You are acknowledging that you have received and reviewed this report. This does <b>not require agreement</b>—only confirmation that it has been shared with you.',
  action: 'Action',
  actions: 'Actions',
  active: 'Active',
  activeCampaign: 'Active Campaign',
  activeDays: 'Active Days',
  activeGroupsOnly: 'Active groups only',
  activeGroupsHelpText:
    'A group is considered active if it has a staff member currently assigned to it, or a staff member signed into a room that has a student from this group in attendance.',
  activity: 'Activity',
  activityType: 'Activity type',
  actual: 'Actual',
  actualAmount: 'Actual Amount',
  actualSpaceRatio: 'Actual Space Ratio',
  add: 'Add',
  addFavouritePlan: 'Add favourite plan',
  addAddress: 'Add Address',
  addAttachments: 'Add Attachments',
  assign: 'Assign',
  addAuthorization: 'Add Authorization',
  addCalendar: 'Add Calendar',
  addDescription: 'Add Description',
  addDomain: 'Add Domain',
  addDose: 'Add Dose',
  addedAllSpacesMessage: 'You have added all of the spaces.',
  addFile: 'Add file',
  addFramework: 'Add Framework',
  addImmunization: 'Add Immunization',
  additionalChild: 'Additional Child',
  additionalFeesAndDiscounts: 'Additional Fees & Discounts',
  addChild: 'Add Child',
  addMaterial: 'Add Material',
  addMember: 'Add Member',
  addMilestone: 'Add Milestone',
  addNewEvent: 'Add New Event',
  addPaymentInfoBannerMessage:
    'Make sure to add your Preauthorized Payment Information',
  addPendingReportsBannerMessage:
    'You have reports that require acknowledgment',
  addPreauthorizedDebit: 'Add Preauthorized Debit',
  addRecord: 'Add Record',
  addVaccination: 'Add Vaccination',
  attachDoseRecord: 'Attach Dose File',
  attachExemption: 'Attach Exemption File',
  attachImmunizationRecord: 'Attach Record File',
  addRegistration: 'Add Registration',
  address: 'Address',
  accountingCatalog: 'Accounting Catalog',
  agesAndRatios: 'Ages & Ratios',
  addSpace: 'Add Space',
  addStaff: 'Add Staff',
  addStudent: 'Add Student',
  addTitle: 'Add title',
  adjustments: 'Adjustments',
  adjustmentUpdateNotSelectedMessage:
    'If you would like to update existing adjustments, please cancel and select Yes, overwrite.',
  adminScope: 'Admin',
  adminTeam: 'Admin Team',
  admin: {
    learn: {
      dashboard: 'Dashboard',
      plan: 'Plans',
      lesson: 'Lessons',
      report: 'Report',
      setup: 'Setup',
    },
  },
  actualAdminTime: 'Act. Admin Time',
  administered: 'Administered',
  administeredApplied: 'Administered / Applied',
  administeredBy: 'Administered by',
  administrationInstructions: 'Administration Instructions',
  administrationMethod: 'Administration Method',
  administrationMethodOther: 'Other Administration Method',
  administratorOverride: 'Administrator Override',
  adminNote: 'Admin Note',
  adminNotes: 'Notes (visible to admins only)',
  adminOrStaffMember: 'Admin / Staff',
  adminPayments: 'Admin Payments (Temp)',
  adminStaff: 'Administrative Staff',
  adminViewOnly: 'Admin View Only',
  advanced: 'Advanced',
  afterClearCacheMessage:
    'After clearing the cache and reloading this page, you can use the button below to go back to Home.',
  age: 'Age',
  ageAsOfToday: 'Age as of Today',
  ageCheckDate: 'Age Check Date',
  ageCheckDay: 'Day of Month',
  ageDictionaries: 'Age Dictionary',
  ageGroup: 'Age Group',
  ageGroupDictionary: 'Age Group Dictionary',
  ageGroupOptions: {
    zeroToSixMonths: '0–6 M',
    sixToTwelveMonths: '6–12 M',
    twelveToTwentyFourMonths: '12–24 M',
    twentyFourToThirtySixMonths: '2–3 Y',
    thirtySixToFourtyEightMonths: '3–4 Y',
    fourtyEightToSixtyMonths: '4–5 Y',
    kindergarten: 'Kindergarten',
    beforeOrAfterSchool: 'Before/After School',
  },
  ageGroups: 'Age Groups',
  ageOnStartDate: 'Age On Start Date',
  ageRange: 'Age Range',
  ageRangeInMonths: 'Range (in months or grades)',
  ageRangeType: 'Age Range Type',
  ages: 'Ages',
  agreed: 'Agreed',
  agreementAwaitingResponse: 'Awaiting response after reset',
  agreementAwaitingSignature: 'Awaiting signature after reset',
  agreementDocumentPreviewFailed:
    'Unable to preview the agreement document. Please try downloading it instead.',
  agreementFile: 'Agreement File',
  agreementLink: 'Agreement Link',
  agreementMissingFile: 'A PDF file is required.',
  agreement: 'Agreement',
  agreementPolicyName: 'Agreement / Policy Name',
  agreementResetFailed: 'Failed to reset the agreement. Please try again.',
  agreementResetSuccess: 'Agreement response reset.',
  agreementResponseHistory: 'Agreement response history',
  agreements: 'Agreements',
  agreementsAndPolicies: 'Agreements and Policies',
  agreementsInstructions:
    "Please upload finalized, non-fillable PDF versions of any parent agreements you require. Parents will review each document during their online registration and digitally sign to confirm acceptance. A signature page with the parent's name, digital signature, and date will automatically be added to the end of each agreement and a copy of the signed agreement saved to the child's file cabinet. Be sure all uploaded documents are generalized (not personalized or fillable), as parents are signing off on the entire document as-is.",
  agreementsNote:
    'Note: All uploaded agreements must be finalized PDF documents. Parents will sign each agreement digitally during registration.',
  alias: 'Alias',
  alreadyInUse: 'Already in use',
  all: 'All',
  allGroups: 'All Groups',
  allAssessmentsApproved: 'All Assessments Approved',
  allAttendees: 'All Attendees',
  allAttendeesInSpace: 'All attendees present in space',
  allAttendeesPresentInTeam: 'All attendees present in team',
  allCaughtUp: 'All Caught Up!',
  allDay: 'All Day?',
  allergiesMedicalConditions: 'Allergies & Medical Conditions',
  allergiesMedicalConditionsName: 'Name of Allergy or Medical Condition',
  hasAllergiesOrMedicalConditionsQuestion:
    'Does this child have any allergies or medical conditions?',
  allEventsInSeries: 'All events in series',
  allowCreditCards: 'Allow Credit Card Transactions',
  allowParentToRoomStaffMessaging: 'Allow Parent to Room Staff Messaging',
  allowUnauthorizedDeviceAccess: 'Allow Unauthorized Device Access',
  allRoles: 'All Roles',
  allStudents: 'All Students',
  allStudentStatuses: 'All Student Statuses',
  amount: 'Amount',
  amountCharged: 'Amount Charged',
  andXMoreErrors: 'and {count} more errors',
  announcement: 'Announcement',
  announcementHint:
    'Want to message an entire group? Try sending an Announcement from the announcements tab.',
  announcements: 'Announcements',
  annualSalary: 'Annual Salary ($)',
  apply: 'Apply',
  applyCreditsToAccount: 'Apply Credits to Account',
  applyDateFilter: 'Apply Date Filter',
  applyToAmount: 'Based On Amount',
  applyParentSignature: 'Apply Parent Signature',
  appointment: 'Appointment',
  applicationConfirmation: 'Application Confirmation',
  applicationConfirmationDesc:
    'Email sent when a family submits the online registration form',
  appropriateAge: 'Appropriate Age',
  approvalRequested: 'Approval Requested',
  approvalStatus: 'Approval Status',
  approvalPending: 'Approval Pending',
  arAging: 'AR Aging',
  approve: 'Approve',
  approveAttendanceLog: 'Approve attendance log',
  approveAttendanceLogHint:
    'Review the requested value before approving this record.',
  approved: 'Approved',
  editAndApprove: 'Edit and Approve',
  approveTime: 'Edit/Approve Time',
  archive: 'Archive',
  archived: 'Archived',
  archivedRates: 'Archived Rates',
  assessmentNoteTooltip: 'Assessment has a note',
  assignedGroups: 'Assigned Groups',
  assignAsDoseRecord: 'Assign as Dose Record',
  assignAsExemption: 'Assign as Exemption',
  assignAsImmunizationRecord: 'Assign as Immunization Record',
  assignToDose: 'Assign to dose',
  assignToImmunization: 'Assign to immunization',
  associateTask: 'Associate Task',
  asterix: '*',
  atLeastOneAdminTimeRequired:
    'At least one administration time is required for regular medication.',
  attachedDrNotePrescription: 'Attached DR Note/Prescription',
  attatchFiles: 'Attatch Files',
  atteAndJounral: 'Attendance & Journal',
  attemptedContact: 'Attempted Contact',
  attemptedCount: 'Attempted ({count})',
  attendance: 'Attendance',
  attendanceKiosk: 'Kiosk',
  attendanceKioskNotEnabled: 'Attendance Kiosk is not enabled.',
  attendanceLog: {
    moveEntry: 'Move Entry',
    attendanceLog: 'Attendance Log',
    addMove: 'Add a move',
    addEntries: 'Add attendance entries',
    moveHint: 'Place the move between the surrounding records.',
    entriesHint: 'Create the missing sign in/out records in sequence.',
    attendanceDate: 'Attendance Date',
    selectDayHint: 'Select the day for this new log pair.',
    previousEntry: 'Previous Entry',
    nextEntry: 'Next Entry',
    dayLogsHint: 'Review and edit sign in/out records for the selected day.',
  },
  attention: 'Attention',
  authGuard: {
    unauthorizedDevice: {
      title: 'This device is not authorized.',
      message: 'Please contact your Admin to authorize the device.',
    },
    setupAccessDenied: {
      title: 'Access Denied',
      message: 'You do not have permission to access this page.',
    },
  },
  authorization: 'Authorization',
  authorizationInfo: 'Authorization Info',
  authorized: 'Authorized',
  authorizeDeviceErrorMessage: 'Error authorizing device',
  authorizeDeviceLabel: 'Authorize this device',
  authorizeDeviceTooltip:
    'Authorize this device to be able to be used by non-admin users.',
  authorizedSponsor: 'Authorized Sponsor',
  authorizedVolunteer: 'Authorized to Volunteer',
  autoAdjustments: 'Auto Adjustments',
  automatedEmails: 'Automated Emails',
  autoBillingSummary: 'Auto Billing Summary',
  autoBilling: 'Auto Billing',
  automation: 'Automation',
  autoPaymentDate: 'Auto Payment Date',
  autoPayments: 'Auto Payments',
  autoPaymentEnabled: 'Auto payment enabled',
  autoRegularTuitionInvoicing: 'Auto Regular Tuition Invoicing',
  available: 'Available',
  availableRates: 'Available Rates',
  avatar: 'Avatar',
  averagingPeriod: 'Averaging Period (In Weeks)',
  back: 'Back',
  backToGroupReport: 'Back to Group Report',
  backToLogin: 'Back to log in',
  balance: 'Balance',
  balances: 'Balances',
  bankAccount: 'Bank Account',
  bankInfo: 'Bank Info',
  bankName: 'Bank Name',
  centerBankName: "Center's Bank Name",
  bankStatement: 'Bank Statement',
  bankVerificationDocuments: 'Bank Verification Documents',
  basic: 'Basic',
  basicInfo: 'Basic Info',
  beautifyJson: 'Beautify JSON',
  beautifyJsonFailed: 'Value is not valid JSON',
  bestPhoneNumber: 'Best Phone Number',
  billing: 'Billing',
  billingAmountTooltip:
    'Percentage amounts will be calculated based on the total billing amount including any third party sponsor amounts',
  billingCycle: 'Billing Cycle',
  billingDate: 'Billing Date',
  billingDue: 'Billing Due',
  billingEndDate: 'Billing End Date',
  billings: 'Billings',
  billingStartDate: 'Billing Start Date',
  birthday: 'Birthday',
  birthdayfuturecheck: 'Birthday must be a valid date',
  studentBirthdayFutureCheck:
    'Birthday cannot be more than 10 months in the future',
  bookingDays: 'Booking Days',
  bookingType: 'Booking Type',
  bothRegisteredAndWaitlisted: 'Both registered & waitlisted',
  briefDescription: 'Brief Description',
  broadcast: 'Broadcast',
  broadcastPartialFailure: 'Failed to send to {count} recipient(s)',
  broadcastSentSuccessfully: 'Broadcast sent successfully',
  bulkMessageProcessingMessage: 'Bulk message deliveries may take some time...',
  bulkMessages: 'Bulk Messages',
  bulkMessaging: 'Bulk Messaging',
  bulkRegistrations: 'Bulk Registrations',
  businessInfo: 'Business Info',
  businessName: 'Legal Business Name',
  businessNumber: 'Business Number',
  businessType: 'Business Type',
  businessCategory: 'Business Category',
  businessCategoryOther: 'Describe your business category',
  charityRegistrationNumber: 'Charity registration number',
  operatingAs: 'Operating As',
  solicitsDonations: 'Solicits donations',
  bussing: 'Bussing',
  by: 'By',
  calendar: 'Calendar',
  calendarShare: {
    addGroups: 'Add Groups',
    addPeople: 'Add people and groups',
    addSelected: 'Add Selected',
    allGroups: 'All Groups',
    allMembers: 'All Members',
    allStaff: 'All Staff',
    allMembersHelpText:
      'Share this calendar with all portal members (guardians) with view-only access. Deselect anyone to exclude them.',
    allStaffHelpText:
      'Share this calendar with all room staff. Deselect staff to exclude them, or set individual permissions below.',
    allowGroupStaffToEdit: 'Allow group staff to edit',
    calendarsIncluded: 'Calendars included',
    canEdit: 'Can Edit',
    childStatus: 'Child Status',
    copyLink: 'Copy Link',
    createLink: 'Create Link',
    createShareLink: 'Create Share Link',
    createShareLinkForCalendar: 'Create Share Link',
    deleteLink: 'Delete Link',
    deleteShareLink: 'Delete Share Link',
    deleteShareLinkWarning:
      'Are you sure you want to delete this share link? Any calendars currently subscribed to this URL will no longer receive updates.',
    duplicateLinkWarning:
      'A share link with these exact calendars already exists: "{name}". Creating a new link will give you a separate URL.',
    existingShareLinks: 'Existing Share Links',
    excluded: 'Excluded:',
    group: 'Group',
    groupShareHelpText:
      'Groups share the calendar with all portal members who have children in those groups.',
    guardianAccessNote:
      'This Calendar will be shared with View Only access to all the guardians of the active students within these groups',
    icalDownloadNote:
      'Opening this link will download an ICS file. This file is a snapshot and will not automatically update.',
    icalSubscribeNote:
      'To subscribe to this calendar, import it by URL in your calendar app. Any changes will sync within 24 hours.',
    icalSubscribeNoteShort:
      'Import by URL in your calendar app to subscribe. Changes sync within 24 hours.',
    linkCreatedSuccess: 'Share link created!',
    linkName: 'Link Name',
    linkNamePlaceholder: 'e.g., My Work Calendar',
    membersFound: '{count} members found',
    memberSpecific: 'Member Specific',
    more: 'More',
    noMembersFound: 'No members found',
    noShareLinkForCalendar: 'No share link exists for this calendar.',
    noShareLinks: 'No share links created yet',
    noSharesYet:
      'No shares yet. Click "Add people and groups" to share this calendar.',
    noStaffFound: 'No staff found',
    permission: 'Permission',
    roomStaffHelpText:
      'Room staff in selected groups can view or edit this calendar.',
    searchByName: 'Search by name...',
    searchStaff: 'Search staff...',
    selectCalendarsToShare: 'Select calendars to share',
    selected: '{count} selected',
    selectGroups: 'Select Groups',
    selectMembers: 'Select Members',
    selectStaff: 'Select Staff',
    share: 'Share',
    shareCalendar: 'Share Calendar',
    sharedCalendar: 'Shared Calendar',
    sharedWith: 'Shared With',
    shareLink: 'Share Link',
    shareTokenCreated: 'Share link created successfully',
    shareTokenDeleted: 'Share link deleted successfully',
    shareWithAllMembers: 'Share with all members',
    shareWithAllStaff: 'Share with all staff',
    shareWithRoomStaff: 'Share with room staff in these groups',
    staffAccess: 'Staff Access',
    staffFound: '{count} staff found',
    staffStatus: 'Status',
    unknownCalendar: 'Unknown Calendar',
    unnamedLink: 'Unnamed Link',
    viewOnly: 'View Only',
    viewShareLink: 'View Share Link',
    yourNewShareLink: 'Your New Share Link',
  },
  bookATour: 'Book a Tour',
  contactUs: 'Contact Us',
  cancel: 'Cancel',
  confirmChanges: 'Confirm Changes',
  activityUpdatedSuccessfully: 'Activity updated successfully',
  activityCreatedSuccessfully: 'Activity created successfully',
  cancelEnrollmentButtonLabel: 'Cancel Enrollment',
  cancelEnrollmentConsequences1:
    "The student's slot in the program will be released.",
  cancelEnrollmentConsequences2:
    'This registration group and registration(s) related to the registration group will remain visible but will become read-only.',
  cancelEnrollmentConsequences3:
    'Existing billings related to the registrations will stay and can be updated/allowed to be billed.',
  cancelEnrollmentConsequences4:
    'Registration(s) will no longer appear in the processing page to create billings from but you can still create custom billings and create billings from other non-cancelled registrations.',
  cancelEnrollmentWarning: 'Are you sure you want to cancel this enrollment?',
  cancelNewItem: 'Cancel New Item',
  cancelSync: 'Cancel Sync. Cannot be continued',
  cannotChangeSponsor: 'Can not change sponsor',
  cannotEditMemberTypeTooltipMessage:
    'Cannot change the status of this member because you must always have at least one Legal Guardian and Non-Guardian Emergency Contact on file.',
  cannotEditOthersMessage: 'You can only edit your own messages',
  cannotModifyFieldsSaveWarning:
    'The following fields cannot be modified after saving',
  cannotUseReservedGroupName: 'This name is reserved for unassigned staff',
  capacity: 'Capacity',
  capParentAmount: 'Cap Parent Payment Amount',
  catalog: 'Catalog',
  category: 'Category',
  center: 'Center',
  centerAdmin: 'Center Admin',
  centerAlias: 'Center Alias',
  centerBasic: 'Basic',
  centerConfiguration: 'Center Configuration',
  centerConfigurationDescription:
    'Center specific configuration for how the software will behave in your center',
  centerConfigurationMoved:
    'Center configuration has moved to the Configuration page.',
  centerDepositNumber: 'Center Deposit #',
  centerEmail: 'Center Email',
  centerFinancials: 'Financials',
  centerInfo: 'Center Info',
  centerPlansTab: 'Center Plans',
  centers: 'Centers',
  centerStaff: 'Center Staff',
  centerTimezone: "Center's Timezone",
  certification: 'Certification',
  certifications: 'Certifications',
  certified: 'Certified',
  certify: 'Certify',
  certifyAll: 'Certify All',
  cfDepositNumber: 'Deposit #',
  changeDate: 'Change Date',
  changedOn: 'Changed on',
  changePassword: 'Change Password',
  changeRate: 'Change Rate',
  changeTask: 'Change task',
  charge: 'Charge',
  chargebackFee: 'Chargeback Fee',
  chargeDeposit: 'Charge Deposit',
  chargedPercentage: 'Charged Percentage',
  chargeNow: 'Charge Now',
  checkAvailability: 'Check Availability',
  checkDates: 'Check Date(s)',
  checkedIn: 'Checked In',
  checkedOut: 'Checked Out',
  checkEmailForConfirmation:
    "Please check your email for a confirmation that will contain <span class='text-bold'>IMPORTANT</span> information, including the required next steps in the registration process.",
  checkNumber: 'Check number',
  checkSpamFolderMessage:
    '*If you do not receive an email, please check your SPAM or Promotions folders',
  checkYourEmail: 'Check your email',
  child: 'Child',
  childInformation: 'Child Information',
  children: 'Children',
  childrenInformation: 'Children Information',
  childrenStepInstruction:
    'Enter the information for each child you are registering. You can add more children if needed.',
  chooseDropOffSpace: 'Choose a drop-off space for {firstName} {lastName}',
  chooseStrongPasswordMessage: 'Choose a strong password for your account',
  city: 'City',
  class: 'Class',
  classes: 'Classes',
  classicView: 'Classic view',
  clear: 'Clear',
  clearAll: 'Clear All',
  clearAllFilters: 'Clear All Filters',
  clearFilters: 'Clear filters',
  clearSearch: 'Clear search',
  clickToDownload: 'Click to download',
  clickToUploadAgreement: 'Click to upload PDF',
  clickToOpen: 'Click to open',
  clickToResendPrompt: 'Click to resend',
  clickToViewSeriesMessage: 'Click here to view the entire series.',
  clientMessagingAdminHelp:
    'Messages from center administrators about important matters.',
  clientMessagingRestrictedNotice:
    'Messaging is disabled for this portal account. You can still view message history.',
  clientMessagingAnnouncementsHelp:
    'Announcements and updates from the center for all families.',
  clientMessagingRoomStaffHelp:
    "Messages with your child's room staff and teachers about daily activities.",
  client: {
    onboardingForm: {
      nonPrimaryMemberWaitingMessageBefore:
        'You will be given full access to the portal when the primary member',
      nonPrimaryMemberWaitingMessageAfter: 'fills out the required agreements.',
      nonPrimaryMemberWaitingTitle: 'Limited Access',
      youarealmostthere: 'You are almost there!',
    },
  },
  clientAuthGuardMessage:
    'Please return to the dashboard to complete your registration to view the rest of the portal',
  clientString: 'Client',
  clientView: 'Client View',
  clone: 'Clone',
  clonePlan: 'Clone Plan',
  close: 'Close',
  closeDate: 'Close Date',
  closeMessaging: 'Close messaging',
  closeThread: 'Close thread',
  closeTime: 'Close Time',
  collapseAll: 'Collapse All',
  collapseComponent: 'Collapse component',
  collapseSidebar: 'Collapse sidebar',
  collapseTree: 'Collapse tree',
  collectedInPeriod: 'Payment Collected in Period',
  collectedInPeriodHint:
    'The payments will be calculated based on payments received during the period selected but not necessarily connected to the specific billings.',
  collectionEndDate: 'Collection End Date',
  collectionStartDate: 'Collection Start Date',
  collapse: 'Collapse',
  color: 'Color',
  commonName: 'Common Name',
  communicate: 'Communicate',
  communication: 'Communication',
  companyBankAccount: 'Company Bank Account',
  parentPadAndCreditCardPayments: 'Parent PAD & Credit Card Payments',
  complete: 'Complete',
  completeConfirmation: 'Are you sure you want to complete this enrollment?',
  compose: 'Compose',
  composeBroadcastMessage:
    'Compose a message to send to all selected recipients',
  conductionDate: 'Conduction Date',
  config: 'Config',
  confirmAccuracy: 'Confirm Accuracy',
  confirmAgreementResetMessage:
    'Reset the response for {agreement}? The existing response PDF will remain in the family file cabinet, and the family will need to respond again.',
  confirmAgreementResetOptionalMessage:
    'Reset the response for {agreement}? The existing response PDF will remain in the family file cabinet. Because this agreement is optional, the family can choose whether to respond again.',
  confirmAgreementResetTitle: 'Reset agreement response',
  confirmAndDelete: 'Confirm & Delete',
  confirmArchiveAgreementsMessage:
    'Archive the selected agreement(s)? Existing signed copies will remain in family files, but families will no longer be asked to sign the archived agreement(s).',
  confirmArchiveAgreementsTitle: 'Confirm Archive',
  confirmationEmail: 'Confirmation Email',
  convertedFileTooLarge:
    'This file was converted to a proper format but now exceeds our {fileSize} MB limit',
  comingSoon: 'Coming soon',
  confirmBankInfoMissing: 'Bank Info Missing',
  confirmDelete: 'Are you sure you want to delete this {name}?',
  confirmDeleteTitle: 'Confirm Delete {name}',
  confirmDeletionCalendar: 'Are you sure you want to delete this calendar?',
  confirmDeletionSeries:
    'Are you sure you want to delete all events in this series?',
  confirmDeletionSingle: 'Are you sure you want to delete this event?',
  confirmDeletionTitle: 'Confirm Deletion',
  confirmEnableKiosk: 'Enable Attendance Kiosk',
  confirmEnableKioskMessagePart1:
    'Enabling the Attendance Kiosk feature allows authorized family members to conveniently pick up their children using PIN codes.',
  confirmEnableKioskMessagePart2:
    'Please note that if the kiosk is left unmonitored, there may be potential for misuse.',
  confirmEnableKioskResponsibility:
    'By enabling this feature, you acknowledge that the organization and center assume responsibility for any misuse that may occur.',
  confirmLegalGuardian:
    'I confirm that I am the legal guardian of the child/children.',
  confirmNewPasswordErrorMessage: 'Please confirm your new password',
  confirmPassword: 'Confirm Password',
  confirmSave: 'Confirm Save',
  connectedToBillings: 'Payment Connected to Billings in Period',
  connectedToBillingsHint:
    'The payments will be calculated based on payments received for the specific billings from the period selected but irrespective of the date the payments were made.',
  contactAdminForGroupAssignment:
    'Please contact your administrator to be assigned to a group to view messages.',
  contactAttemptsLog: 'Contact Attempts Log',
  contactInfo: 'Contact Information',
  contactMethod: 'Method',
  contactMethodAppMessage: 'App Message',
  contactMethodEmail: 'Email',
  contactMethodPhoneCall: 'Phone Call',
  contactMethodSms: 'SMS',
  contactOutcome: 'Outcome',
  contactOutcomeLeftVoicemail: 'Left Voicemail',
  contactOutcomeLineBusy: 'Line Busy',
  contactOutcomeNoAnswer: 'No Answer',
  contactOutcomeSent: 'Sent',
  content: 'Content',
  continue: 'Continue',
  continueToPayment: 'Continue to Payment',
  contributors: 'Contributors',
  convertingImageForUpload: 'Converting images to valid format...',
  conversationNoAccessBody:
    "Your current role or group assignments don't include this thread. If you think this is a mistake, try signing into the correct space or contact an administrator.",
  conversationNoAccessTitle: "You don't have access to this conversation",
  conversationsMarkedRead: 'conversations marked as read',
  copiedToClipboardMessage: 'Copied to clipboard',
  copy: 'Copy',
  copyActivity: 'Copy Activity',
  copied: 'Copied',
  copyValueFailed: 'Could not copy that value',
  doubleClickToCopy: 'Double-click to copy',
  copyEmbedCodeTooltipMessage: 'Copy Embed Code',
  copyId: 'Copy Id',
  copyJson: 'Copy JSON',
  copyJsonFailed: 'Failed to copy JSON',
  copyLinkTooltipMessage: 'Copy Link',
  copyResolvedJson: 'Copy resolved JSON',
  copyToMarketplace: 'Copy lesson to marketplace',
  copyToMyLessons: 'Copy to my lessons',
  copyVariableJson: 'Copy variable JSON',
  configuration: 'Configuration',
  configurationJsonCopied: 'Configuration JSON copied to clipboard',
  configurationMessages: {
    setupMode: {
      label: 'Setup Mode',
      confirmTitle: 'Confirm leaving setup mode',
      confirmDescriptionPart1:
        'When this is disabled any previously delayed emails will be sent out. If you manually set passwords for staff or parents they will be overwritten to a random password',
      confirmDescriptionPart2:
        "If you don't want any emails to be sent they can be deleted from the Communicate => Email => Delayed tab.",
    },
    allowRoomStaffEditHours: {
      label: 'Allow Room Staff to Edit Hours',
      hint: 'Allows room staff to edit their own attendance hours, or hours for children',
    },
    requireAdminApprovalStaffEditHours: {
      label: 'Require Admin Approval for Staff Hour Edits',
      hint: 'When enabled, staff attendance edits are held for administrator review before being applied.',
    },
    vaccinationTracking: {
      label: 'Vaccination Tracking',
      hint: 'Track vaccine doses, due dates, exemptions, and attached files. Parents are required to update overdue vaccinations, including overdue doses where either the date or required file is missing.',
    },
    requireStudentMedicalPractitioner: {
      label: 'Require Medical Practitioner',
      hint: 'Require every active child to have a medical practitioner selected before onboarding can be completed.',
    },
    disableParentsPayment: {
      label: 'Disable Parent Payment Processing',
      hint: "If enabled, parents won't be able to create payments for either PAD or credit card through the parent portal for regular invoices. This won't affect deposits that parents pay through the portal for new registrations.",
    },
    familyMemberContactRequirements: {
      title: 'Required Family Member Contact Fields',
      description:
        'Choose the contact fields that must be completed before legal guardians or non-guardian emergency contacts can be saved.',
      legalGuardianLabel: 'Legal Guardians',
      nonGuardianEmergencyContactLabel: 'Non-Guardian Emergency Contacts',
      fieldsSelected: 'selected',
      fields: {
        personalAddress: 'Personal address, city, region, country',
        workAddress: 'Work address, city, region, country',
        personalPhone: 'Personal phone',
        workPhone: 'Work phone',
        personalEmail: 'Personal email',
        workEmail: 'Work email',
      },
    },
    requiredEmergencyContactCount: {
      title: 'Required Emergency Contacts',
      description:
        'Set the minimum number of non-guardian emergency contacts each family must have.',
      inputLabel: 'Minimum emergency contacts',
      validation: 'Enter a whole number of at least 1',
    },
    expiringItemReminderThresholds: {
      clientDescription:
        'Controls family member emails for volunteer authorization expiries.',
      clientTitle: 'Volunteer Authorizations',
      customStaffTrackingDescription:
        'Controls staff reminder emails and admin notifications for custom tracking items.',
      customStaffTrackingTitle: 'Custom Staff Tracking',
      day: 'day',
      days: 'days',
      description:
        'Choose how many days before tracked items and authorizations expire that reminders are sent.',
      duplicate: 'That reminder is already scheduled',
      empty: 'No expiry reminders will be sent.',
      inputLabel: 'Days before expiry',
      limit:
        'Up to {count} reminders can be scheduled, from 1 to {days} days before expiry.',
      removeAria: 'Remove {days} day expiry reminder',
      sponsorDescription:
        'Controls parent emails and email notifications, plus admin notifications, for third-party sponsor expiries.',
      sponsorTitle: 'Third-Party Sponsors',
      staffDescription:
        'Controls staff reminder emails and admin notifications for criminal record checks, intervention checks, and first aid certifications.',
      staffTitle: 'Staff Credentials',
      title: 'Expiry Reminder Schedule',
      vaccinationDescription:
        'Controls parent emails and email notifications for upcoming vaccination due dates.',
      vaccinationTitle: 'Vaccinations',
      validation: 'Enter a whole number from {min} to {max}',
    },
    unsavedChanges: {
      title: 'Unsaved configuration changes',
      description:
        'Save or reset the manual configuration changes on this page.',
    },
    changesSaved: 'Changes saved',
  },
  copyToAllJournals: 'Copy To All Journals',
  coreLearningFocus: {
    cognitiveAcademicSkills: 'Cognitive & Academic Skills',
    physicalDevelopment: 'Physical Development',
    creativeExpressiveArts: 'Creative & Expressive Arts',
    socialLifeSkills: 'Social-Emotional & Life Skills',
    outdoorEnvironmentalLearning: 'Outdoor & Environmental Learning ',
    inquiryHandsOnLearning: 'Inquiry-Based & Hands-On Learning',
    culturalSocialUnderstanding: 'Cultural & Social Understanding',
    earlyLiteracyAndLanguage: 'Early Literacy & Language',
    mathematicalThinking: 'Mathematical Thinking',
    scienceAndDiscovery: 'Science & Discovery',
    engineeringAndBuilding: 'Engineering & Building (STEM)',
    technologyAndDigitalLiteracy: 'Technology & Digital Literacy',
    grossMotorDevelopment: 'Gross Motor Development',
    fineMotorDevelopment: 'Fine Motor Development',
    sensoryExploration: 'Sensory Exploration',
    musicAndMovement: 'Music & Movement',
    artCreativeExpression: 'Art & Creative Expression',
    dramaticImaginativePlay: 'Dramatic & Imaginative Play',
    socialEmotionalLearning: 'Social-Emotional Learning (SEL)',
    mindfulnessAndWellbeing: 'Mindfulness & Well-Being',
    practicalLife: 'Practical Life & Independence',
    graceAndCourtesy: 'Grace & Courtesy',
    outdoorPlay: 'Outdoor Play & Exploration',
    physicalEducation: 'Physical Education & Movement',
    projectBasedLearning: 'Project-Based Learning',
    loosePartsPlay: 'Loose Parts Play & Open-Ended Exploration',
    culturalCommunityStudies: 'Cultural & Community Studies',
    familyCommunityConnections: 'Family & Community Connections',
  },
  couldNotCreatePasscodeMessage: 'Could not generate one time passcode',
  couldNotFetchCentersMessage: 'Could not fetch centers',
  country: 'Country',
  countSelected: '{count} selected',
  create: 'Create',
  createAccount: 'Create Account',
  createAndClose: 'Create and Close',
  created: 'Created',
  createLogin: 'Create Login',
  createRefund: 'Create Refund',
  createLesson: 'Create Lesson',
  creditCard: 'Credit Card',
  creditCardFixed: 'Credit Card Fixed',
  creditCardPercentage: 'Credit Card Percentage',
  creditMemo: 'Credit Memo',
  credits: 'Credits',
  creditsPer: 'Credits Per',
  creditsType: 'Credits Type',
  creditTo: 'Credit To',
  criminalRecord: 'Criminal Record',
  currentAge: 'Current Age',
  currentCenterHasNotEnabledPublicRegistration:
    'Public registration is currently disabled for this center. To enable it, please ensure that Stripe is connected, or set both the registration and waitlist deposits to $0 in all programs.',
  currentFamiliesOnly: 'Showing current student families only',
  currentGroup: 'Current Group',
  currentlyIn: 'Currently in: {spaceName}',
  currentProgram: 'Current Program',
  currentRate: 'Current Rate',
  currentRegistration: 'Current Registration',
  currentRegistrations: 'Current Registrations',
  currentStatus: 'Current Status',
  curriculum: 'Curriculum',
  curriculumAndOutcomes: 'Curriculum & Outcomes',
  appliesTo: 'Applies To',
  curriculumTagFocusAreaReportDescription:
    'Use this curriculum in focus area reports.',
  curriculumTagJournalsDescription:
    'Use this curriculum when staff create and review journals.',
  curriculumTagProgressReportDescription:
    'Use this curriculum in student and group progress reports.',
  curriculums: 'Curriculums',
  curriculumSetUp: 'Curriculum Set Up',
  specificGroups: 'Specific Groups',
  custom: 'Custom',
  customColumns: 'Custom Columns',
  customElements: 'Custom Elements',
  customEmail: 'Custom Email',
  customerSetup: 'Customer Setup',
  customFields: 'Custom Fields',
  customForm: 'Custom Form',
  customGender: 'Custom Gender',
  customInfo: 'Custom Information',
  customization: 'Customizations',
  customizedForms: 'Customized Forms',
  customPosition: 'Custom Position',
  customTracking: 'Custom Tracking',
  customTrackingExpiry: '{name} Expiry Date',
  cycle: 'Cycle',
  dashboard: 'Dashboard',
  Dashboard: 'Dashboard',
  date: 'Date',
  dateFrom: 'Date From',
  dateGiven: 'Date Given',
  dateMustBeAfterTodayErrorMessage: 'Date of Birth cannot be after today',
  dateOfBirth: 'Date of Birth',
  dateRange: 'Date Range',
  dateSelected: 'Date Selected',
  dateSigned: 'Date Signed',
  dateTo: 'Date To',
  day: 'Day',
  days: 'Days',
  daily: 'Daily',
  daysOfWeek: {
    mo: 'Monday',
    tu: 'Tuesday',
    we: 'Wednesday',
    th: 'Thursday',
    fr: 'Friday',
    sa: 'Saturday',
    su: 'Sunday',
  },
  declined: 'Declined',
  declinedOn: 'Declined on',
  defaultInDollars: 'Default ($)',
  defaultVaccinationsRegionWarning:
    'Routine schedules vary by region. Review these defaults against current local public-health guidance before saving.',
  defaultValue: 'Default Value',
  defaultWage: 'Default Wage',
  defaultWageBoost: 'Default Wage Boost',
  delayed: 'Delayed',
  delete: 'Delete',
  deleteAllOccurances: 'Delete All Occurrences',
  deleteConfirmationDialogMessage:
    'Are you sure you want to delete this item? This action cannot be undone.',
  deleteConfirmationDialogTitle: 'Delete Item',
  deleteJournalConfirmationDIalogMessage:
    'Are you sure you want to delete this journal entry? This action cannot be undone.',
  deleteJournalConfirmationDialogTitle: 'Delete Journal Entry',
  deleteRSVP: 'Delete RSVP',
  deleteRSVPMessage:
    'This is part of a recurring series. Would you like to delete only this occurrence or all occurrences in the series?',
  deleteThisInstance: 'Delete This Instance',
  deposit: 'Deposit',
  depositAmount: 'Deposit Amount',
  depositByCreatingInvoice: 'Deposit By Creating Invoice',
  depositDate: 'Deposit Date',
  DepositDate: 'Deposit Date',
  deposited: 'Deposited',
  depositGroup: 'Deposit Group',
  depositNumber: 'Deposit Number',
  depositPayment: 'Deposit Payment',
  depositPaymentProcessing: 'Deposit Payment Processing',
  depositPaymentProcessingMessage:
    "Payment processing. We'll update you when payment is received.",
  depositReceivedMessage:
    'Your deposit has been received. Our team will be in touch soon. We look forward to welcoming you!',
  deposits: 'Deposits',
  description: 'Description',
  designSystem: 'Design System',
  designSystemPage: {
    navTitle: 'Design System',
    navDescription: 'Human-readable pages and AI-ready implementation rules.',
    status: {
      ready: 'Ready',
      draft: 'Draft',
    },
    sections: {
      overview: {
        title: 'Overview',
        description:
          'A map of the design-system contract, docs, examples, and rollout path.',
      },
      foundations: {
        title: 'Foundations',
        description:
          'Tokens, typography, spacing, radii, shadows, motion, and content rules.',
      },
      components: {
        title: 'Components',
        description:
          'Canonical primitives, import paths, props, states, and usage boundaries.',
      },
      recipes: {
        title: 'Recipes',
        description:
          'Composed examples and repeatable paths for page shells, forms, tables, dialogs, and common workflows.',
      },
      skills: {
        title: 'Skills Guidance',
        description:
          'Prompt patterns for using skills to create, refactor, and verify product UI.',
      },
    },
    overviewPage: {
      sectionCards: {
        foundations:
          'Start with tokens, type, spacing, content, and motion rules before choosing component details.',
        components:
          'Use canonical primitives and wrappers with the expected props, states, and import paths.',
        recipes:
          'Copy composed examples for common work such as page shells, filters, forms, tables, and dialogs.',
        skills:
          'Use project skills to create new UI and refactor existing components with clear prompts and checks.',
        workflowTitle: 'Workflow',
        workflow:
          'Use the same decision path for human reviews and AI-assisted implementation.',
      },
      humanWorkflow: {
        title: 'Human Workflow',
        description:
          'Use the design system as the first stop before changing or reviewing UI.',
        steps: {
          pickSurface: {
            title: 'Pick the surface',
            description:
              'Name the product area, user role, and screen density before choosing a recipe.',
          },
          readClosest: {
            title: 'Read the closest section',
            description:
              'Start with the matching foundation, component, recipe, or skills guidance page.',
          },
          copyPattern: {
            title: 'Copy the recipe',
            description:
              'Reuse existing structure, spacing, components, and copy style instead of inventing a variant.',
          },
          validate: {
            title: 'Validate the change',
            description:
              'Check i18n, tokens, responsive behavior, and the relevant lint or type checks.',
          },
        },
      },
      aiWorkflow: {
        title: 'AI Agent Workflow',
        description:
          'Agents should load the local rules, make the smallest useful change, and verify it.',
        steps: {
          loadRules: {
            title: 'Load the rules',
            description:
              'Read AGENTS.md, the relevant design-system docs, and nearby component examples first.',
          },
          chooseExample: {
            title: 'Choose an example',
            description:
              'Anchor the implementation to the closest existing screen or documented recipe.',
          },
          implementNarrowly: {
            title: 'Implement narrowly',
            description:
              'Change only the requested surface and keep new abstractions out until repetition proves the need.',
          },
          verify: {
            title: 'Verify the result',
            description:
              'Run the focused checks, inspect the diff, and call out any checks that could not run.',
          },
        },
      },
      aiPrompt: {
        title: 'AI Prompt Contract',
        description:
          'Paste this contract into UI tasks so agents know the surface, files, rules, and checks before editing.',
      },
      qualityGates: {
        title: 'Quality Gates',
        i18n: {
          title: 'I18n',
          description:
            'Every visible string belongs in locale files and is read with $t() or useI18n().',
        },
        tokens: {
          title: 'Tokens',
          description:
            'Use approved colors, spacing, radius, and shadow utilities instead of raw one-off values.',
        },
        forms: {
          title: 'Forms',
          description:
            'Use project form patterns for labels, errors, required states, and submit behavior.',
        },
        validation: {
          title: 'Validation',
          description:
            'Confirm responsive layout, empty states, loading states, and accessible labels before handoff.',
        },
        accessibility: {
          title: 'Accessibility',
          description:
            'Follow docs/design-system/accessibility.md: label icon-only buttons, let dialogs return focus, keep touch targets at least 44x44px, meet 4.5:1 text contrast, and keep a visible keyboard focus ring.',
        },
      },
      maintenanceRule:
        'When a new UI pattern ships, update the matching design-system page in the same slice or record the follow-up explicitly.',
    },
    recipesPage: {
      title: 'Recipe Catalog',
      description:
        'Copy these composed examples when building or refactoring common ChildFriendly UI workflows.',
      nav: {
        overview: 'Overview',
        form: 'Form',
        layout: 'Layout',
        card: 'Card',
        tabs: 'Tabs',
        table: 'Filter + Table',
      },
      summaries: {
        overview:
          'Choose the closest recipe before composing a new UI from scratch.',
        form: 'Use wrappers, semantic spacing, validation, and clear save actions.',
        layout:
          'Use page-first structure with predictable header, side rail, and content regions.',
        card: 'Use cards for bounded content, not as nested page-section wrappers.',
        tabs: 'Use tabs for real peer sections with stable layout and shareable state when needed.',
        table:
          'Keep filters close to their data and document loading, empty, and status states.',
      },
      badges: {
        map: 'Map',
        copyable: 'Copyable',
      },
      boundaries: {
        title: 'Recipe Boundaries',
        overview: {
          copyClosest:
            'Start from the closest recipe, then adapt copy, data, and component slots.',
          keepContract:
            'Keep the recipe contract intact: i18n, tokens, spacing, states, and imports.',
          verify:
            'Run the focused checks that match the changed surface before handoff.',
        },
        form: {
          useWrappers:
            'Use CfInput and CfSelect when they fit before falling back to raw Quasar inputs.',
          validate:
            'Show required, disabled, loading, and error behavior when the form owns validation.',
          actions:
            'Place primary and secondary actions together after the fields or in the established shell action area.',
        },
        layout: {
          pageFirst:
            'Start from the page shell and content hierarchy before designing individual cards.',
          responsive:
            'Define desktop and tablet behavior for columns, scroll containment, and overflow.',
          noNestedCards:
            'Do not turn every page section into a floating card; reserve cards for bounded items.',
        },
        card: {
          singleLayer:
            'Use one card layer for one bounded item or panel; avoid cards inside cards.',
          actions:
            'Keep actions visible and predictable instead of hover-only for primary work.',
          density:
            'Match admin density with compact headings, restrained padding, and readable body text.',
        },
        tabs: {
          urlState:
            'Persist tab state in the URL when a refresh or shared link should restore it.',
          realSections:
            'Use tabs for peer sections, not as decorative filters or button groups.',
          noOverflow:
            'Check horizontal overflow, label wrapping, and keyboard focus behavior.',
        },
        table: {
          filtersNearData:
            'Place filters directly above or beside the table/list they affect.',
          loadingEmpty:
            'Document loading, empty, error, and filtered-empty states with the table recipe.',
          tableV2:
            'Reach for CustomTable (cf-markup-table) for a simple read-only listing; use TableV2 only when you need selection, inline edit, drag-reorder, virtual scroll, or pagination.',
        },
      },
      preview: {
        ready: 'Ready',
        primaryAction: 'Add item',
      },
      examples: {
        overview: {
          title: 'Choose A Recipe First',
          description:
            'Recipes are intentionally concrete. They give humans and agents a known structure to copy before inventing new layout decisions.',
        },
        form: {
          title: 'Form Recipe',
          description:
            'A compact form block with wrapped inputs, semantic spacing, validation-ready fields, and visible actions.',
          previewTitle: 'Center settings',
          previewDescription:
            'Use this shape for short admin forms that edit one bounded entity.',
          centerName: 'Center name',
          status: 'Status',
        },
        layout: {
          title: 'Layout Recipe',
          description:
            'A page shell with a clear header, optional side rail, and one main workflow region.',
          previewTitle: 'Admin workflow shell',
          previewDescription:
            'Use this structure when a page needs local navigation or filter context beside the main content.',
          sidebarTitle: 'Local navigation',
          activeItem: 'Overview',
          inactiveItem: 'Settings',
        },
        card: {
          title: 'Card Recipe',
          description:
            'A bounded panel pattern for repeated items or focused summaries, with a restrained action area.',
          primaryTitle: 'Enrollment summary',
          primaryDescription:
            'One card should own one clear purpose and one predictable action area.',
          secondaryTitle: 'Payment status',
          secondaryDescription:
            'Use simple structure before adding visual hierarchy or extra controls.',
        },
        tabs: {
          title: 'Tabs Recipe',
          description:
            'A tabbed container for peer sections that need fast switching inside the same workflow.',
          overview: 'Overview',
          settings: 'Settings',
          audit: 'Audit',
          previewDescription:
            'Keep tab labels short and make each panel feel like a real section, not a disguised action button.',
        },
        table: {
          title: 'Filter And Table Recipe',
          description:
            'A dense admin data surface with filters attached to the table/list they control.',
          previewNote:
            'This preview uses the real CustomTable (cf-markup-table) — the canonical choice for a simple, read-only listing. Reach for TableV2 only when you need selection, inline edit, drag-reorder, virtual scroll, or pagination — see the Data Display components.',
          rows: {
            registration: 'Registration workflow',
            registrationDescription:
              'Compact row content with clear status and direct scanning.',
            billing: 'Billing workflow',
            billingDescription:
              'Use nearby filters so the table state is easy to understand.',
          },
        },
      },
    },
    skillsGuidancePage: {
      hero: {
        title: 'Skills Guidance',
        description:
          'Use this page to prompt slash-command skills for new pages, new components, and focused refactors that follow the design system.',
        badge: 'AI-ready workflow',
      },
      workflow: {
        choose: {
          title: 'Choose The Skill And Scope',
          description:
            'Start with the slash command that matches the work: page scaffold, component generation, refactor, or tests.',
        },
        bound: {
          title: 'Give Concrete Context',
          description:
            'Name the target files, nearby examples, expected recipe, preserved behavior, and validation commands before editing.',
        },
        verify: {
          title: 'Verify And Feed Back',
          description:
            'Run the checks required by the changed surface and update the skill or design-system docs when a repeatable rule appears.',
        },
      },
      skills: {
        title: 'Choose The Right Skill',
        description:
          'Skills should make the task clearer and narrower. Use the command that matches the surface you are creating or changing.',
        component: {
          title: 'Component Create Or Refactor',
          description:
            'Use for Vue components, forms, tables, dialogs, inputs, action rows, and local UI cleanup.',
          badge: 'Default',
        },
        page: {
          title: 'Page Or Module Creation',
          description:
            'Use when the work creates or reshapes route-level structure, page shells, tabs, async sections, or module navigation.',
          badge: 'Page',
        },
        service: {
          title: 'API Service And Data',
          description:
            'Use when the work adds or changes an API service, endpoint wiring, or the Vue Query composable that feeds a component.',
          badge: 'Data',
        },
        test: {
          title: 'Logic And Contracts',
          description:
            'Use when creation or refactor work touches composables, validators, formatters, selectors, or behavior that needs focused tests.',
          badge: 'Tests',
        },
        docs: {
          title: 'Design System Reference',
          description:
            'Use foundations, components, and recipes to choose tokens, primitives, spacing, typography, and composed examples.',
          badge: 'Reference',
        },
      },
      ladder: {
        title: 'Skill Task Ladder',
        description:
          'Choose the lowest useful task level before invoking a skill. Move up only when the requested work already needs that scope.',
        levels: {
          surface: {
            title: 'Level 1 - New component',
            description:
              'Create a bounded component such as a form, table, dialog, card, input, or local UI section.',
          },
          primitive: {
            title: 'Level 2 - New page or module',
            description:
              'Create route-level structure, page shell, tabs, async sections, and local navigation with /page-scaffold.',
          },
          recipe: {
            title: 'Level 3 - Existing component refactor',
            description:
              'Move a legacy component toward documented primitives and recipes while preserving behavior and public API.',
          },
          system: {
            title: 'Level 4 - System feedback',
            description:
              'Update a shared component, recipe, or skill only after the work proves a repeatable rule is missing.',
          },
        },
      },
      map: {
        title: 'Refactor Map',
        description:
          'Use this table when the skill is refactoring existing UI instead of creating a new surface.',
        legacy: 'Legacy Pattern',
        standard: 'Standard Replacement',
        rule: 'Skill Rule',
        rules: {
          actions:
            'Use the semantic action row so primary and secondary form actions align consistently.',
          fields:
            'Use field-stack spacing when a field group should be copied across forms.',
          inputs:
            'Use project wrappers for ordinary form controls unless the wrapper cannot express the required behavior.',
          i18n: 'Move visible product copy into locale files and read it through Vue I18n.',
          colors:
            'Use semantic tokens first; Tailwind palette utilities are acceptable for neutral structure and low-risk contextual tints.',
          navigation:
            'Reuse the nearest shared nav primitive instead of creating another local tab or pill style.',
          tailwind:
            'Move ordinary layout, spacing, sizing, typography, border, and responsive rules into tw- utilities.',
          validation:
            'Do not accept visual-only cleanup without checking behavior, states, and the focused project commands.',
          noCaps:
            'Remove manual no-caps on q-btn; the global .q-btn text-transform default already renders sentence-case labels.',
          confirmDialog:
            'Use useConfirmDialog() instead of a raw $q.dialog() confirm so OK/Cancel stay sentence-case and match the Daylight button styling.',
          toggleControls:
            'Use CfToggle, CfCheckbox, or CfRadio instead of raw q-toggle, q-checkbox, or q-radio for booleans and single-choice controls.',
          maximizedDialog:
            'Keep dialogs centered by default; only use :maximized="!$q.screen.gt.sm" for full-screen-on-mobile behavior, never an unconditional maximized.',
        },
      },
      prompts: {
        promptLabel: 'Prompt',
        newComponent: {
          title: 'New Component Prompt',
          description:
            'Use this when creating a bounded component inside an existing page or module.',
          code: `Use /component-gen to create this component.
Read AGENTS.md, nearby sibling components, and the relevant Design System section first.
Build the smallest component that satisfies the requested workflow.
Use existing project primitives, tw- utilities, i18n, and local shared components before inventing new markup.
Include required states such as loading, disabled, empty, error, and validation when the component owns them.
Run yarn type-check and yarn lint, then summarize the files changed and how to use the component.`,
        },
        newPage: {
          title: 'New Page Prompt',
          description:
            'Use this when creating a route-level page, admin module, tabbed page, or page shell.',
          code: `Use /page-scaffold to create this page.
Read AGENTS.md, the closest existing page, and the relevant Design System recipes first.
Create the route/page shell with the established layout, tabs, async component pattern, and URL state when needed.
Use /component-gen for any new bounded child components instead of placing all markup in the page.
Keep visible copy in i18n and use tw- utilities for ordinary layout.
Run yarn type-check and yarn lint, then summarize the route, components, and validation completed.`,
        },
        general: {
          title: 'General Component Refactor Prompt',
          description:
            'Use this when the component type is mixed or you are not sure which recipe applies yet.',
          code: `Use /component-gen to refactor this component to the current design system.
Read AGENTS.md, nearby sibling components, and the relevant Design System page first.
Preserve behavior, props, emits, data flow, and public API.
Do not rewrite unrelated code.
Choose the lowest useful task level from Skills Guidance.
Replace legacy patterns with documented primitives where appropriate.
Run yarn type-check and yarn lint, then summarize the changed surface and remaining risk.`,
        },
        form: {
          title: 'Form Refactor Prompt',
          description:
            'Use this when the legacy component is mainly a form or editable card.',
          code: `Use /component-gen to refactor this form.
Keep the current fields, validation, emits, submit behavior, and API.
Match the Design System form recipe:
- Use CfInput and CfSelect when they fit.
- Use cf-stack-field for copied field-group spacing.
- Use cf-inline-actions for right-aligned form actions.
- Keep visible labels and button text in i18n.
Do not change unrelated layout or business logic.
Run yarn type-check and yarn lint.`,
        },
      },
      done: {
        title: 'Definition Of Done',
        description:
          'A skill-guided UI task is complete only when the result is bounded, consistent with the design system, and verified.',
        items: {
          behavior:
            'Expected behavior, validation, loading, disabled, empty, and error states are handled or intentionally deferred.',
          scope:
            'The diff stays inside the requested surface unless a shared rule had to be updated.',
          primitive:
            'Canonical primitives, semantic classes, and local shared components are used where they fit.',
          i18n: 'Visible product copy is routed through i18n.',
          responsive:
            'Responsive layout, overflow, and touch targets are checked when the UI is browser-visible.',
          validation:
            'The relevant lint, type-check, test, or browser checks are run.',
          skill:
            'The skill, recipe, or component doc is updated if the task revealed a repeatable rule.',
          diff: 'The final summary names what changed and what was intentionally left alone.',
        },
      },
      governance: {
        title: 'Governance',
        description:
          'Every reusable component has a lifecycle status. Promote candidate work to canonical and retire unused components to legacy through the checklist below — full rules in `docs/design-system/governance.md`.',
        statusLegend: {
          title: 'Status Taxonomy',
          canonical: {
            label: 'Canonical',
            description: 'Use it — the recommended choice for new work.',
          },
          candidate: {
            label: 'Candidate',
            description:
              'Usable now; the API may still change. Prefer a canonical component when one exists.',
          },
          needsReview: {
            label: 'Needs Review',
            description:
              'Documented but awaiting a keep-or-deprecate ruling — do not spread it to new surfaces.',
          },
          legacy: {
            label: 'Legacy',
            description:
              'Existing callers only. New code uses the named replacement.',
          },
          internal: {
            label: 'Internal',
            description:
              'Not a public primitive — used to compose other components internally.',
          },
        },
        checklist: {
          title: 'Promotion Checklist',
          registry:
            'A `registry.json` entry with status: canonical — the single source of truth; `yarn registry` regenerates `primitives.md` from it.',
          catalog:
            'A catalog entry in the in-app board, parity-checked against the registry.',
          story: 'A Storybook story.',
          accessibility:
            'An accessibility pass — icon-button labels, focus return, and contrast per `accessibility.md`.',
          usage:
            'Real usage in at least one production surface, not just a demo.',
        },
      },
    },
    foundationPages: {
      title: 'Foundation Pages',
      description:
        'Start here when a UI decision depends on tokens, density, copy, or motion.',
      nav: {
        colors: 'Colors',
        typography: 'Typography',
        spacing: 'Spacing',
        radiiShadows: 'Radii & Shadows',
        content: 'Content',
        motion: 'Motion',
      },
      shared: {
        value: 'Value',
        className: 'Class',
        sass: 'Sass',
        tailwind: 'Tailwind',
        role: 'Role',
        sample: 'Sample',
        size: 'Size',
        usage: 'Usage',
        good: 'Good Examples',
        avoid: 'Avoid',
      },
      colors: {
        title: 'Brand And Semantic Colors',
        description:
          'Use Quasar color props for Quasar components and tw- utilities for ordinary markup.',
        marketingTitle:
          'Marketing Palette - Branding Guidelines (Avoid In App UI)',
        marketingDescription:
          'These colors are available for branded marketing, illustrations, and campaign surfaces. Avoid using them as app UI status, action, or layout colors unless a design-system pattern explicitly allows it.',
        tailwindPaletteTitle: 'Tailwind Palette Usage',
        tailwindPaletteDescription:
          'The default Tailwind palette is allowed for neutral structure and low-risk contextual tints. It should not replace semantic product colors or create one-off brand meanings.',
        foregroundTitle: 'Foreground And Surface Semantics',
        foregroundDescription:
          'Use slate utilities for text and neutral surfaces until dedicated foreground tokens are generated.',
        tokens: {
          primary: {
            label: 'Primary',
            value: '#07b670',
            usage:
              'Primary actions, active navigation, selected states, and links.',
          },
          primaryLight: {
            label: 'Primary Light',
            value: '#2ac487',
            usage: 'Hover treatment and light emphasis near primary actions.',
          },
          primaryDark: {
            label: 'Primary Dark',
            value: '#059d61',
            usage: 'Pressed and active states for primary buttons.',
          },
          positive: {
            label: 'Positive',
            value: '#10b981',
            usage: 'Success states, confirmations, and completed outcomes.',
          },
          negative: {
            label: 'Negative',
            value: '#ef4444',
            usage: 'Errors, failed states, and destructive actions.',
          },
          info: {
            label: 'Info',
            value: '#3b82f6',
            usage: 'Informational states and non-primary links.',
          },
          warning: {
            label: 'Warning',
            value: '#f59e0b',
            usage: 'Caution states and recoverable risks.',
          },
          dark: {
            label: 'Dark',
            value: '#1e293b',
            usage: 'Dark navigation, tooltip backgrounds, and strong surfaces.',
          },
          cfDark: {
            label: 'CF Dark',
            value: '#021b20',
            usage:
              'Brand-dark surfaces where the existing app already uses it.',
          },
        },
        marketingTokens: {
          brandGreen: {
            label: 'brand-green',
            value: '#03d781',
            usage: 'Marketing brand green. App UI should usually use Primary.',
          },
          brandPurple: {
            label: 'brand-purple',
            value: '#8d4896',
            usage: 'Marketing accent for brand artwork and campaign surfaces.',
          },
          brandYellow: {
            label: 'brand-yellow',
            value: '#ffc200',
            usage: 'Marketing accent. Do not use as the warning state color.',
          },
          brandBlue: {
            label: 'brand-blue',
            value: '#3098d1',
            usage:
              'Marketing accent. App informational states should use Info.',
          },
          brandOrange: {
            label: 'brand-orange',
            value: '#e55f1c',
            usage: 'Marketing accent. Avoid using it for operational alerts.',
          },
          brandPink: {
            label: 'brand-pink',
            value: '#e04b6b',
            usage: 'Marketing accent for brand artwork and campaign surfaces.',
          },
          brandGrey: {
            label: 'brand-grey',
            value: '#d2d6d4',
            usage:
              'Marketing neutral. App UI should usually use slate neutrals.',
          },
          brandWhite: {
            label: 'brand-white',
            value: '#ffffff',
            usage:
              'Warm brand white for marketing backgrounds, not default app cards.',
          },
        },
        tailwindPalette: {
          neutral: {
            title: 'Neutral Structure',
            description:
              'Use slate and gray utilities for text, borders, dividers, page backgrounds, and quiet panels.',
          },
          tint: {
            title: 'Contextual Tints',
            description:
              'Use light palette tints for local grouping when they do not create a new product status meaning.',
          },
          warning: {
            title: 'Prefer Semantics For States',
            description:
              'Use semantic tokens for success, error, info, and warning states before reaching for palette colors.',
          },
        },
        foreground: {
          primaryText: 'Primary text for page titles and important values.',
          secondaryText:
            'Secondary text for descriptions and supporting labels.',
          mutedText: 'Muted text for metadata, helper copy, and low emphasis.',
          disabledText:
            'Disabled text for inputs, buttons, and controls that are not interactive.',
          subtleSurface:
            'Subtle surface for grouped guidance and quiet panels.',
        },
      },
      typography: {
        title: 'Typography Scale',
        description:
          'Inter is the UI font. Use cf-type-* semantic classes for product typography instead of Quasar heading classes.',
        densityTitle: 'Typography Rules',
        densityDescription:
          'Typography should make operational screens easy to scan without creating hero-like admin panels.',
        roles: {
          caption: 'Caption',
          smallBody: 'Small Body',
          body: 'Body',
          section: 'Section Label',
          page: 'Page Title',
        },
        samples: {
          caption: 'Registration ID copied',
          smallBody: 'Payment was submitted by center staff',
          body: 'Enrollment application logs are grouped by registration.',
          section: 'Payment Summary',
          page: 'Enrollment Application Logs',
        },
        usage: {
          caption: 'Metadata, compact helpers, and secondary table details.',
          smallBody: 'Dense cards, compact form context, and list metadata.',
          body: 'Default admin body copy and table-adjacent explanations.',
          section: 'Panel headings, card titles, and compact section headers.',
          page: 'Main page headings inside established page shells.',
        },
        rules: {
          inter: {
            title: 'Use Inter',
            description:
              'Do not introduce new UI fonts. Signature fonts are limited to signature surfaces.',
          },
          noViewport: {
            title: 'No Viewport Scaling',
            description:
              'Avoid vw-based font sizing. Use stable text sizes that fit dense screens.',
          },
          noNegative: {
            title: 'Avoid Quasar Heading Classes',
            description:
              'Avoid text-h* for product UI headings because it brings display-style sizing and spacing assumptions.',
          },
        },
      },
      spacing: {
        title: 'Spacing Scale',
        description:
          'Use semantic spacing classes for repeated product structure and tw- utilities for one-off layout composition.',
        layoutTitle: 'Admin Density',
        layoutDescription:
          'Admin screens should show enough information above the fold while preserving readable groups and touch targets.',
        compactTitle: 'Compact By Default',
        compactDescription:
          'Prefer 4, 8, 16, 24, and 32px steps. Use cf-stack-* and cf-card-padding-* when the spacing role should be copied.',
        density: {
          header: {
            title: 'Header',
            description: 'Primary admin chrome is 48px high.',
          },
          drawer: {
            title: 'Drawer',
            description: 'Desktop mini drawer is 57px; mobile drawer is wider.',
          },
          cards: {
            title: 'Cards',
            description: 'Use q-pa-md or q-pa-sm for dense operational cards.',
          },
        },
      },
      radiiShadows: {
        title: 'Radii',
        description:
          'Operational UI uses tight radii. Reserve pill shapes for chips, avatars, and circular buttons.',
        shadowTitle: 'Shadows',
        shadowDescription:
          'Use existing cf-shadow levels for subtle elevation instead of ad hoc shadow values.',
        avoid:
          'Avoid large rounded cards, colored glow shadows, and heavy layered elevation in admin workflows.',
        shadows: {
          one: 'Resting cards, list items.',
          two: 'Hover / mild emphasis.',
          three: 'Active / focused panels.',
          four: 'Floating overlays — dialogs, dropdowns, popovers.',
        },
        focusRing: {
          title: 'Focus Ring',
          description:
            'The shared keyboard-focus ring, sourced from --focus-ring so every interactive element gets the same visible outline.',
          value: '0 0 0 2px rgba(7, 182, 112, 0.35)',
          usage:
            'Applied via :focus-visible only — mouse and touch clicks do not trigger it. Never remove an outline without replacing it with this token.',
          demoLabel: 'Tab to focus me',
        },
      },
      content: {
        title: 'Content Rules',
        description:
          'Copy, iconography, empty states, error handling, and notifications should be concise, consistent, and predictable. This summarizes docs/design-system/content-guidelines.md and docs/design-system/admin-patterns.md.',
        rules: {
          i18n: {
            title: 'Use i18n',
            description:
              'Product UI strings use $t() in templates or useI18n() in script.',
          },
          casing: {
            title: 'Use Clear Casing',
            description:
              'Title Case for navigation and commands; sentence case for body copy and errors.',
          },
          status: {
            title: 'Text Plus Color',
            description:
              'Status labels should be short, concrete, and not rely on color alone.',
          },
          errors: {
            title: 'Recoverable Errors',
            description:
              'Errors should state what failed and what the user can do next when possible.',
          },
          iconography: {
            title: 'Lucide Icons Only',
            description:
              'Lucide for new and touched work, sized 14-48px at 1.75-2 stroke width; icon-only controls need an aria-label or tooltip.',
          },
          emptyStates: {
            title: 'Structured Empty States',
            description:
              'Center a muted icon and one sentence; inside a table, use a full-width row instead of a separate block.',
          },
          errorSurfaces: {
            title: 'Match Failure To Surface',
            description:
              'Failed loads get an inline retry, failed saves get a toast, invalid fields get inline text under the field.',
          },
          notifications: {
            title: 'One Toast Per Operation',
            description:
              'Use success() and fail() with short, verb-first messages; route fixable errors inline instead of into a toast.',
          },
        },
        good: {
          selectCenter: 'Select Center',
          authorizeDevice: 'Authorize Device',
          uploadFailed: 'Upload failed. Try again or choose a different file.',
        },
        avoid: {
          genericError: 'Something went wrong.',
          marketing: 'Your daycare command center awaits.',
          emoji: 'Emoji or cute operational status labels.',
        },
      },
      motion: {
        title: 'Motion',
        description:
          'Motion should clarify state changes. It should not become decoration in admin workflows.',
        avoid:
          'Avoid page transitions, bounce effects, decorative reveals, and scale-on-press patterns unless an existing local pattern already requires them.',
        rules: {
          fast: {
            title: 'Fast Hover And Focus',
            description:
              'Use short transitions for hover, focus, and active state feedback.',
          },
          lift: {
            title: 'Subtle Elevation',
            description:
              'A slight shadow lift is enough for cards or dropdown-like surfaces.',
          },
          easing: {
            title: 'Standard Easing',
            description:
              'Use restrained material-style easing for state changes that need motion.',
          },
          reducedMotion: {
            title: 'Respect Reduced Motion',
            description:
              'prefers-reduced-motion: reduce is clamped globally in global.sass — animation and transition durations drop automatically. No per-component opt-in needed.',
          },
        },
      },
    },
    componentPages: {
      title: 'Engine Component Catalog',
      description:
        'Shared components intended to become reusable product primitives. Start with canonical components and treat candidates as documented migration targets.',
      componentCount: '{count} components',
      canonicalCount: '{count} canonical',
      useWhen: 'Use When',
      avoidWhen: 'Avoid When',
      groups: {
        overview: {
          title: 'Overview',
          description:
            'A map of reusable engine components, maturity levels, and documentation status.',
        },
        formControls: {
          title: 'Form Controls',
          description:
            'Inputs, selects, field wrappers, validation boundaries, and form copy rules.',
        },
        actions: {
          title: 'Actions',
          description:
            'Buttons, action rows, and inline help triggers that should stay consistent across admin screens.',
        },
        surfaces: {
          title: 'Surfaces',
          description:
            'Cards and editable containers used to frame repeated product content.',
        },
        dialogs: {
          title: 'Dialogs',
          description:
            'Modal and side-panel shells for focused tasks and detail workflows.',
        },
        dataDisplay: {
          title: 'Data Display',
          description:
            'Lists, grids, metrics, and structured data display candidates.',
        },
        layout: {
          title: 'Layout',
          description:
            'Page — the top-level page wrapper — plus shared layout helpers for headers, containers, and title/body patterns.',
        },
        loading: {
          title: 'Loading States',
          description:
            'Skeletons for known-shape content and spinners for actions — driven by isLoading, never isFetching.',
        },
        pickers: {
          title: 'Pickers',
          description:
            'Date and month/range pickers used across forms, filters, and reports.',
        },
      },
      overview: {
        title: 'Component Groups',
        description:
          'Use this page to choose the closest shared primitive before creating a new component.',
      },
      status: {
        canonical: 'Canonical',
        candidate: 'Candidate',
        internal: 'Internal',
        needsReview: 'Needs Review',
        legacy: 'Legacy',
      },
      maturity: {
        title: 'Maturity Levels',
        description:
          'Maturity tells humans and AI agents whether a component is recommended, experimental, internal, or waiting for API cleanup.',
        canonical:
          'Recommended for new code when the documented use case matches the task.',
        candidate:
          'Useful and likely to become canonical, but the API or examples still need review.',
        internal:
          'Used to compose engine internals. Do not recommend directly to feature code.',
        needsReview:
          'Documented for visibility only. Do not copy into new work until the API is cleaned up.',
        legacy:
          'Superseded by a canonical component. Avoid for new work; plan migration for existing call sites.',
      },
      formControls: {
        title: 'Canonical Form Controls',
        description:
          'Use these wrappers for new or refactored forms when their behavior fits the task.',
        centerName: 'Center Name',
        status: 'Status',
        autoRenew: 'Auto-Renew',
      },
      actions: {
        title: 'Canonical Buttons',
        description:
          'BaseBtn is the standard button — sentence-case by default (global no-caps), with full slot passthrough for icons and tooltips.',
        iconOnlyTooltip: 'More actions',
      },
      surfaces: {
        title: 'Inline-Edit Card',
        description:
          'ContextualCardV2 tracks a deep-clone diff against `entity` — Save, Cancel, and Delete only appear once the copy actually changes.',
      },
      dialogs: {
        title: 'Slide-In Panels & Confirmations',
        description:
          'DialogSeamless for side panels; useConfirmDialog() for confirm/cancel prompts — sentence-case buttons, no raw $q.dialog().',
        variantDefault: 'Default (76vw)',
        variantStaffDetail: 'Staff detail (50vw)',
        variantFamilyDetail: 'Family detail (65vw)',
        openPanel: 'Open panel',
        panelTitle: 'Example detail panel',
        panelBody:
          'DialogSeamless slides in from the right — width is driven by the variant prop.',
        confirmDeleteTitle: 'Delete this record?',
        confirmDeleteMessage: 'This action cannot be undone.',
        confirmDeleteLegacyTitle: 'Legacy — ConfirmDeleteDialog',
        confirmDeleteLegacyNote:
          'Superseded by useConfirmDialog() above — kept for existing callers, not for new work.',
        confirmDeleteLegacyBoundary:
          "Its root q-dialog binds :model-value one-way with no {'@'}update:model-value listener — backdrop click and Esc do not sync back to the show prop, only the Cancel/Delete buttons do (via {'@'}update:show).",
      },
      dataDisplay: {
        title: 'Simple Listing — CustomTable',
        description:
          'Gray-50 header band, hairline gray-200 dividers, comfortable rows — the default for read-only listings.',
        tableV2Title: 'Full Data Grid — TableV2',
        tableV2Description:
          'Selection, inline edit, drag-reorder, virtual scroll, pagination — reach for it only when you need these.',
        atomsTitle: 'Display Atoms',
        atomsDescription:
          'Small read-only display primitives — person avatar, status badge, boolean icon, and label/value pair — for cards, tables, and detail panels.',
        atomsLabelFieldLabel: 'Center Name',
      },
      loading: {
        title: 'Loading States',
        description:
          'Skeleton for known-shape content, spinner for actions — both driven by isLoading, never isFetching.',
        simulateLoad: 'Simulate load',
        skeletonLabel: 'Skeleton — first load',
        spinnerLabel: 'Spinner — action',
      },
      pickers: {
        title: 'Date & Month Pickers',
        description:
          'DatePicker is a masked q-input with a q-date popup for a single calendar date; YearAndMonthPicker adds a month-grid / date-range popup for reports and filters.',
      },
      layout: {
        title: 'Top-Level Page Wrapper',
        description:
          'Page owns the tab header, scroll area, feature-flag-filtered tab panels, and archive toggle for every top-level admin route.',
      },
      boundaries: {
        title: 'Usage Boundaries',
        formControls: {
          prefer:
            'Prefer CfInput and CfSelect over raw q-input or q-select for ordinary product forms.',
          rawQuasar:
            'Use raw Quasar controls only when the wrapper cannot express the required behavior.',
          validation:
            'Keep labels, required indicators, validation, disabled states, and i18n visible in examples.',
          flatControl:
            'Keep toggles, checkboxes, and radios flat and shadowless (the Flat-Control Rule) — never add a custom box-shadow back onto CfToggle/CfCheckbox/CfRadio.',
        },
        surfaces: {
          contextualCard:
            'Use ContextualCardV2 for the "click to edit, Save/Cancel appears" pattern — dirty detection is automatic via a deep-clone diff against `entity`.',
          submitContract:
            "The {'@'}submit handler receives (entityCopy, isNew) — persist entityCopy, then let the updated entity prop resync the diff baseline.",
          readOnly:
            'For pure read-only display, use a plain q-card — do not wrap static content in a form-diffing card.',
        },
        dialogs: {
          seamless:
            'Use DialogSeamless for slide-in side panels; pick the narrowest variant that fits the content (staff-detail 50vw, family-detail 65vw, default 76vw).',
          confirm:
            'Use useConfirmDialog() for any confirm/cancel prompt — never a raw $q.dialog() call — so buttons stay sentence-case and destructive actions stay color: "negative".',
          legacy:
            'BaseDialog and SideToPopupDialog are legacy — do not start new side-panel work on them.',
        },
        dataDisplay: {
          simpleFirst:
            'Default to CustomTable (cf-markup-table) for read-only listings — gray-50 header, hairline dividers, comfortable rows, no setup cost.',
          tableV2:
            'Reach for TableV2 only when you need selection, inline edit, drag-reorder, virtual scroll, or pagination.',
          loadingState:
            "TableV2's loading state is a blank canvas, not a skeleton — pair it with a skeleton wrapper for first loads if the layout needs to stay stable.",
        },
        loading: {
          driveOffIsLoading:
            'Drive skeleton/spinner visibility off isLoading (first load), never isFetching (background refresh) — a refetch should update in place.',
          skeletonForShape:
            'Use a skeleton (q-skeleton) when the content shape is known ahead of load — cards, tables, detail panels.',
          spinnerForActions:
            'Use a spinner for actions (buttons, small inline regions) or fully indeterminate waits.',
        },
        pickers: {
          dateFormat:
            'DatePicker normalizes internally to DATE_FORMATS.dateSlash for its native q-date binding — an intentional, documented exception to the dashed-date default (CLAUDE.md); do not refactor it to dashes.',
          scope:
            'Use YearAndMonthPicker only for a coarse year+month or date-range selector (reports, filters) — for a specific calendar date, use DatePicker.',
          errorMessages:
            "DatePicker's default minDateErrorMessage/maxDateErrorMessage strings are hardcoded English, not i18n — always pass translated copy through those props.",
        },
        layout: {
          pageWrapper:
            "Wrap every top-level admin route in Page — it owns the tab header, scroll area, feature-flag filtering, and each tab's SuspenseLoader boundary; do not hand-roll tab panels.",
          subPages:
            'Pass sub for a nested sub-page inside a detail panel instead of nesting a second top-level Page.',
          labelKey:
            'label is passed straight to $t() inside Page — it must be an i18n key, not literal text.',
        },
      },
      inventory: {
        title: 'Component Inventory',
        description:
          'Each component lists its import path, maturity, usage boundary, and prop surface.',
      },
      planned: {
        description:
          'This group is mapped for visibility. Build a full live example after the component API is reviewed.',
      },
      docs: {
        cfInput: {
          purpose:
            'Canonical text and numeric input wrapper around q-input with external labels and forwarded attrs.',
          use: 'Use for ordinary form fields that need label, required state, validation, slots, and Quasar input behavior.',
          avoid:
            'Avoid when the field needs a custom control shell that does not map cleanly to q-input.',
        },
        cfSelect: {
          purpose:
            'Canonical select wrapper around q-select with external labels and forwarded attrs.',
          use: 'Use for ordinary select fields, option lists, emit-value/map-options patterns, and validation.',
          avoid:
            'Avoid when the interaction is not a select, such as a segmented control or custom picker.',
        },
        fieldWithError: {
          purpose:
            'Field wrapper candidate for pairing field content with explicit error presentation.',
          use: 'Use after confirming the wrapper matches the current validation and accessibility pattern.',
          avoid:
            'Avoid treating it as canonical until examples and prop boundaries are documented.',
        },
        cfToggle: {
          purpose:
            'Canonical flat, shadowless toggle — wraps q-toggle and strips the default 3-layer thumb box-shadow per the Flat-Control Rule.',
          use: 'Use for boolean on/off settings in forms and settings rows.',
          avoid:
            'Avoid a raw q-toggle in new or refactored forms — it ships a shadowed thumb that violates the Flat-Control Rule.',
        },
        cfCheckbox: {
          purpose:
            'Canonical checkbox wrapper around q-checkbox — dense by default, forwards all attrs and slots.',
          use: 'Use for boolean selection and multi-select list rows.',
          avoid: 'Avoid a raw q-checkbox in new or refactored forms.',
        },
        cfRadio: {
          purpose:
            'Canonical radio wrapper around q-radio — generic over string/number/boolean values, dense by default.',
          use: 'Use for mutually exclusive single-choice options sharing one v-model.',
          avoid: 'Avoid a raw q-radio in new or refactored forms.',
        },
        cfCurrencyInput: {
          purpose:
            'Canonical currency field — wraps CfInput with a $ prefix, decimal input mode, and blur/focus formatting (2-decimal display, bare number while editing).',
          use: 'Use for any dollar-amount field — fees, adjustments, ledger entries.',
          avoid:
            'Avoid for non-currency numeric fields — use CfInput with type="number" instead.',
        },
        baseBtn: {
          purpose:
            'Canonical button wrapper — forwards all Quasar button props, ships dense/unelevated defaults, and forwards every named and default slot to the underlying q-btn.',
          use: 'Use for all new and refactored buttons — dialog actions, page actions, icon-only buttons paired with a CfTooltip, close/cancel controls.',
          avoid:
            'Avoid only when a specific q-btn behavior genuinely cannot be expressed through BaseBtn — otherwise it is the default over a raw q-btn.',
        },
        baseCard: {
          purpose:
            'Simple card-like surface candidate with dense, bordered, square, and padding options.',
          use: 'Use for engine-owned repeated surfaces after confirming padding and elevation match the page.',
          avoid:
            'Avoid when Quasar q-card or the documented design-system card pattern is clearer.',
        },
        baseEditableContainer: {
          purpose: 'Editable container surface with delete affordance support.',
          use: 'Use only in flows that already depend on its delete interaction.',
          avoid:
            'Avoid for new shared surfaces until its slots, states, and action rules are documented.',
        },
        contextualCardV2: {
          purpose:
            'Canonical inline-edit card — wraps content in a q-form with automatic dirty detection (deep-clone diff against `entity`) and shows Save/Cancel/Delete only once the copy changes.',
          use: 'Use for the standard "click into edit, Save/Cancel appears" pattern — settings rows, list-item detail cards, entity editors.',
          avoid:
            'Avoid for pure read-only display (use a plain card) or multi-step flows where diffing the whole entity does not apply.',
        },
        baseDialog: {
          purpose:
            'Side-positioned dialog candidate with header, close action, and configurable width.',
          use: 'Use for engine-owned side panels where the existing API matches the task.',
          avoid:
            'Superseded by DialogSeamless for new side-panel work — avoid for new dialogs; leave existing call sites until they are migrated.',
        },
        sideToPopupDialog: {
          purpose:
            'Responsive dialog candidate that can shift from side panel to popup.',
          use: 'Use after confirming the responsive breakpoint and slots match the workflow.',
          avoid:
            'Superseded by DialogSeamless — avoid for new dialogs; leave existing call sites until they are migrated.',
        },
        dialogSeamless: {
          purpose:
            'Canonical right-side seamless dialog — full-height, position="right", with three width variants: default 76vw, staff-detail 50vw, family-detail 65vw (each with a mobile fallback).',
          use: 'Use for slide-in detail/edit panels — staff detail, family detail, and general side-panel workflows.',
          avoid:
            'Avoid for small centered confirmations — use useConfirmDialog() instead.',
        },
        useConfirmDialog: {
          purpose:
            'Canonical confirmation-dialog composable — wraps $q.dialog() with sentence-case (noCaps) buttons: flat neutral Cancel, filled colored Confirm.',
          use: "Use for any destructive or consequential confirm/cancel prompt (delete, discard, archive) — pass color: 'negative' for destructive actions.",
          avoid:
            'Avoid a raw $q.dialog() confirm/cancel call in new or refactored code — it ships ALL-CAPS buttons with no color convention.',
        },
        baseListIndex: {
          purpose:
            'List layout primitive candidate for rendering dense or comfortable repeated items.',
          use: 'Use for simple list or grid shells where the data and item slot are already shaped.',
          avoid:
            'Avoid when the list needs filtering, pagination, empty states, or table behavior.',
        },
        baseDataList: {
          purpose:
            'Higher-level list candidate with toolbar and pagination scaffolding.',
          use: 'Use as a reference for future list API design.',
          avoid:
            'Avoid copying into new features until hardcoded filters and toolbar behavior are removed.',
        },
        baseGridIndex: {
          purpose:
            'Grid candidate with typed column and toolbar configuration.',
          use: 'Use as a reference for future grid/table contract work.',
          avoid:
            'Avoid treating it as production-ready until row rendering, states, and examples are complete.',
        },
        tableV2: {
          purpose:
            'Canonical full-featured data grid — selection, inline add/edit, drag-reorder, virtual scroll, and pagination on top of q-table.',
          use: 'Use only when you need selection, inline editing, drag/reorder, virtual scroll, or pagination.',
          avoid:
            "Avoid for a simple read-only listing — use CustomTable instead; TableV2's loading state is a blank canvas, not a skeleton.",
        },
        customTable: {
          purpose:
            'Canonical simple read-only table (cf-markup-table) — gray-50 header band, hairline gray-200 row dividers, 8px frame, comfortable 44–48px rows, gray-50 row hover, no zebra.',
          use: 'Use for straightforward read-only listings with native thead/tbody markup — ledgers, summaries, static reports.',
          avoid:
            'Avoid when you need selection, inline editing, drag/reorder, virtual scroll, or pagination — use TableV2 instead.',
        },
        gaugeProgress: {
          purpose: 'Visual progress candidate for compact metric display.',
          use: 'Use when the gauge communicates a bounded numeric value better than text alone.',
          avoid:
            'Avoid if the user needs exact comparison, table sorting, or accessible text-only status.',
        },
        baseContainer: {
          purpose:
            'Minimal container shell currently used as an engine placeholder.',
          use: 'Use only where an existing engine pattern already depends on it.',
          avoid:
            'Avoid recommending for new pages until it has a clear layout responsibility.',
        },
        baseActionHeader: {
          purpose:
            'Action-header candidate for aligning left, right, and add actions.',
          use: 'Use for engine-owned list or data screens with matching toolbar structure.',
          avoid:
            'Avoid until responsive wrapping, density, and action priority are documented.',
        },
        titleAndBodyLayout: {
          purpose:
            'Non-functional stub — renders only `<div><slot /></div>`. Despite the name, it does not implement a separate title area.',
          use: 'There is no working title/body composition to use — treat it as a bare div wrapper only if you specifically need that.',
          avoid:
            'Avoid entirely for new layouts; build the title/body structure directly or use a real layout component.',
        },
        suspenseLoader: {
          purpose:
            "Canonical Suspense boundary wrapper — shows an error state, a skeleton, or a spinner fallback while the default slot's async setup resolves.",
          use: 'Use to wrap any component with async setup() that needs a loading fallback.',
          avoid:
            'Avoid for synchronous components — there is no async boundary to fill; drive isLoading state directly instead.',
        },
        skeletonPattern: {
          purpose:
            "Canonical technique for known-shape loading — mirror the real component's layout with q-skeleton blocks sized to match the content (see src/components/learn/skeletons/* for examples).",
          use: 'Use for card/table/detail-panel first loads where the shape is known ahead of time. Drive visibility off isLoading (first load), never isFetching (background refresh).',
          avoid:
            'Avoid a skeleton for actions (buttons, small inline regions) or fully indeterminate waits — use a spinner instead.',
        },
        spinnerPattern: {
          purpose:
            "Canonical technique for action loading — an indeterminate spinner via a button's :loading prop or a global q-spinner-orbit fallback.",
          use: 'Use for button actions, small inline regions, or fully indeterminate waits with no known content shape.',
          avoid:
            'Avoid a spinner for known-shape content (tables, cards, detail panels) — it causes layout reflow when content arrives; use a skeleton instead.',
        },
        cfTooltip: {
          purpose:
            'Canonical tooltip — wraps q-tooltip with dark Daylight styling (slate background, white text, 6px radius) and forwards all q-tooltip props/attrs.',
          use: 'Use for any hover/focus tooltip — icon-only buttons, truncated text, help hints.',
          avoid:
            'Avoid a raw q-tooltip in new or refactored code; CfTooltip keeps the styling centralized.',
        },
        datePicker: {
          purpose:
            'Canonical masked date input — a q-input with an "Aaa ## ####" keyboard mask, a q-date popup, and built-in min/max-date and required validators. Unhandled attrs (label, stack-label, aria-id, ...) fall through to the underlying q-input.',
          use: "Use for any single calendar-date field. Pass minDate/maxDate for range limits, quickHelp for an inline QuickHelp icon in the input's append slot, and rules for extra validators alongside the built-in ones. Exposes validate() via a template ref.",
          avoid:
            'The default minDateErrorMessage/maxDateErrorMessage strings are hardcoded English, not i18n — always pass translated copy. It internally normalizes to DATE_FORMATS.dateSlash for the native q-date binding; that is an intentional, documented exception (CLAUDE.md), not a bug to "fix" to dashes.',
        },
        yearAndMonthPicker: {
          purpose:
            'Month/year and date-range popup picker — a compact button that opens either a year+month grid or (when showRange) a q-date range picker.',
          use: 'Use for coarse period selection in reports and filters (e.g. "claim month", "statement range") — not for picking a specific calendar date.',
          avoid:
            'Bind with v-model:date — the component emits update:date and does not mutate the prop. Still marked candidate: the API is under review; prefer DatePicker where a full date fits.',
        },
        quickHelp: {
          purpose:
            'Canonical inline help trigger — a small "?" icon that opens a q-popup-proxy card with a title/hint, a list of sub-hints, or (when definitions is populated) a structured term/description legend plus an optional tip line.',
          use: 'Use next to a form label, section header, or column header for contextual help. title, hint, tip, and every definitions[].description / subHints[].title / subHints[].hint are resolved through $t() internally — pass raw i18n keys rather than pre-resolved strings.',
          avoid:
            "Avoid for a single hover-only tooltip line — that is CfTooltip's job. Reach for QuickHelp when the content needs a title, a definitions legend, or must stay open on click rather than hover.",
        },
        avatar: {
          purpose:
            'Canonical person avatar — a colored circle with an uploaded photo or initial fallback, plus an optional name label driven by the shared displayName() formatter.',
          use: 'Use anywhere a person (staff, family member, student) needs a compact avatar + name — list rows, cards, headers. Supports append and title-after slots for inline badges or secondary text next to the name.',
          avoid:
            'Fallback shows initials from the name; set showLastInitial to include the last-name initial. Provide a meaningful name — an empty name yields an empty avatar.',
        },
        statusBadge: {
          purpose:
            'Canonical small rounded status pill — maps a fixed vocabulary of status strings (active, inactive, pending, cancelled, ...) to a color via q-badge.',
          use: "Use for a compact status indicator in table rows, cards, and headers where the status is one of the component's known values.",
          avoid:
            'The color/outline mapping is a hardcoded, closed set of about a dozen status strings (case-insensitive) — anything else falls back to plain grey. Extend the component rather than passing arbitrary status text and expecting a matching color.',
        },
        yesOrNo: {
          purpose:
            'Canonical boolean-to-icon display — a green check for true, a red X for false, and (unless hideFalse) nothing for null/undefined.',
          use: 'Use for a compact yes/no or boolean column in tables and detail rows instead of raw text.',
          avoid:
            'Written with the Options API (defineComponent), not <script setup> — a pre-existing convention mismatch; do not copy this file structure for new components.',
        },
        labelField: {
          purpose:
            'Canonical static label/value pair for read-only detail displays — a grey label line above a value line.',
          use: 'Use for read-only entity detail panels and summary rows where a CfInput would be the wrong affordance (nothing to edit).',
          avoid:
            'Written with the Options API (defineComponent), not <script setup> — a pre-existing convention mismatch; do not copy this file structure for new components.',
        },
        baseChip: {
          purpose:
            'Removable, icon-capable chip built on q-chip — used across the learn/ module for filter selections and tag-style displays.',
          use: 'Use inside learn/ selector and filter UIs that already depend on it (e.g. focus-area/domain selection chips) where removable + custom chipClasses styling is needed.',
          avoid:
            'learn-local; engine promotion pending (D2 migrate-to-engine). Do not introduce it into non-learn/ modules — there is no canonical cross-app chip primitive yet.',
        },
        confirmDeleteDialog: {
          purpose:
            'Hand-rolled centered confirm/cancel dialog for delete actions — title, message, and Delete/Cancel actions.',
          use: 'New code should prefer useConfirmDialog(); this component remains for existing callers.',
          avoid:
            'Legacy — new code should use useConfirmDialog() for confirmations. This component stays for existing callers; backdrop/Esc now sync via v-model:show.',
        },
        page: {
          purpose:
            'Canonical top-level page wrapper — renders the tab header (via Tabs), a scroll area, feature-flag-filtered tab panels (each wrapped in its own SuspenseLoader), and an optional archive toggle. The backbone of the admin page pattern in CLAUDE.md.',
          use: 'Use for every top-level admin route: <Page :tabRoutes="tabRoutes" :label="label" /> inside a q-page, with each tab an async component and ITabRoute.featureFlag for flag-gated visibility. Pass sub for a nested sub-page inside a detail panel.',
          avoid:
            "label is passed straight to $t() — pass an i18n key, not literal text. Avoid nesting a second top-level Page inside another Page's tab panel; use the sub prop instead.",
        },
      },
    },
  },
  developer: 'Developer',
  deselectAll: 'Deselect All',
  preselectedCannotBeRemoved: 'Pre-selected (cannot be removed)',
  details: 'Details',
  didNotReceiveEmailPrompt: "Didn't receive the email?",
  digitalSignature: 'Digital signature',
  direct: 'Direct',
  directory: 'Directory',
  directoryHub: 'Directory Hub',
  directDepositForm: 'Direct Deposit Form',
  directMessages: 'Direct Messages',
  disabled: 'Disabled',
  disableUnauthorizedDeviceAccess: 'Disable unauthorized device access for',
  discard: 'Discard',
  discount: 'Discount',
  discounts: 'Discounts',
  displayOptions: 'Display Options',
  discoveryTopic: 'Discovery Topic',
  discoveryTopics: 'Discovery Topics',
  dismiss: 'Dismiss',
  document: 'Document',
  documents: 'Documents',
  domain: 'Domain',
  domainAuth: {
    addCnameRecords: 'Add these CNAME records to your DNS provider:',
    addCustomDomain: 'Add a Custom Domain',
    copyAllRecords: 'Copy All Records',
    customDkimHelp:
      "Most users don't need this. Only check this if you already have 's1' or 's2' records in your DNS, or if your IT team asked you to use a specific selector.",
    dnsPropagationNote:
      'Note: DNS changes can take up to 48 hours to propagate.',
    dnsRecordsVerified:
      'All DNS records verified. Emails from this domain will not be flagged as spam.',
    domainHint: 'Enter domain without www or https://',
    domainPlaceholder: 'example.com',
    emailBannerNote:
      "Emails are sent from your center's ChildFriendly address. Recipients can reply directly to your email. To send from your own domain and reduce the chance of emails landing in spam, set up Domain Authentication in Center Settings.",
    emailSentFromNote:
      'Emails will be sent from {cfAddress} with replies directed to this email. To send directly from your own domain, set up Domain Authentication below.',
    emailSentFromNoteAuthenticated:
      'Your domain is authenticated. Emails will be sent directly from this address.',
    emailSentFromNoteChecking: 'Checking domain authentication...',
    emptySubtitle: 'Add your first custom domain above',
    emptyTitle: 'No domains configured yet',
    enterDkim:
      'Enter up to 3 characters (e.g. "org") to use as the selector prefix.',
    exampleDomain: 'yourcenter.com',
    host: 'Host',
    manage: 'Manage',
    noDnsRecords: 'No DNS records available. Try refreshing.',
    pdfEmailNote:
      "The PDF will be emailed from your center's ChildFriendly address. Recipients can reply directly to your email.",
    pending: 'pending',
    pendingStatus: 'Pending',
    preventSpam:
      "Send emails from your own domain instead of your center's ChildFriendly address",
    publicDomainWarning:
      'You cannot authenticate public email domains like {domain}. Please enter a custom domain you own.',
    removeConfirmMessage:
      "Are you sure you want to remove {domain}? Emails for this domain will be sent from your center's ChildFriendly address until the domain is authenticated again.",
    removeConfirmTitle: 'Remove Domain',
    removeDomain: 'Remove Domain',
    requiresCustomDomain:
      'Requires a custom domain you own (e.g., yourcenter.com)',
    setUp: 'Set Up',
    title: 'Domain Authentication',
    useDkimLabel: 'Use custom DKIM selector',
    verified: 'verified',
    verifiedStatus: 'Verified',
    verifyDnsRecords: 'Verify DNS Records',
    whatIsDescription:
      "Domain authentication lets your center send emails directly from your custom domain (like {domain}). If your domain is not authenticated, emails will be sent from your center's ChildFriendly address instead. This feature requires you to own a custom domain and have access to its DNS settings. Public email domains (Gmail, Outlook, etc.) cannot be authenticated.",
    whatIsTitle: 'What is Domain Authentication?',
    yourDomains: 'Your Domains',
  },
  domains: 'Domains',
  dontHaveAnAccount: "Don't have an account?",
  dosage: 'Dosage',
  dose: 'Dose',
  doseAttachments: 'Dose Attachments',
  doses: 'Doses',
  download: 'Download',
  draft: 'Draft',
  dropIn: 'Drop In',
  dueAgeInMonths: 'Due (Age in Months)',
  duplicate: 'Duplicate',
  duplicateMedication: 'Duplicate medication',
  duplicateMedicationValuesNotAllowed:
    "You aren't allowed to add medications with the exact same values.",
  duration: 'Duration',
  added: 'Added',
  deleted: 'Deleted',
  edit: 'Edit',
  editAttendanceLog: 'Edit attendance log',
  editAttendanceLogHint: 'Adjust the selected value and save the correction.',
  editCalendar: 'Edit Calendar',
  edited: 'Edited',
  editEvent: 'Edit Event',
  editJournalTitle: 'Edit Journal',
  editOrApprove: 'Edit/Approve',
  editOverride: 'Edit Override',
  editRecurringDetails: 'Edit Recurring Details',
  editSeries: 'Edit Series',
  editSignOutTime: 'Edit Sign Out Time',
  editTime: 'Edit Time',
  education: 'Education',
  effectiveDate: 'Effective Date',
  effectiveDateHint: 'New adjustments will be added starting on this day',
  email: 'Email',
  emailAddress: 'Email Address',
  emailAddressLoginUsernameWarning:
    "If the personal email address has been changed, this won't change the login username until the admin approves.",
  emailAddressUserName: 'Email Address/Username',
  emailAlreadyExists: 'Email already exists in our system',
  emailCheckingAvailability: 'Checking email availability...',
  emailCopied: 'Email Copied to Clipboard',
  emailImageAltText: 'Email image',
  emailIsValid: 'Email is valid',
  emailTransfers: 'Email Transfers',
  emailSent: 'Email Sent',
  emailSentOn: 'Email Sent On',
  emailValidAndAvailable: 'Email is valid and available',
  emailShortcutTooltip: {
    familyName:
      "The family name, followed by the word 'Family'. Ex. Bancroft Family",
    recipientFirstName: 'The first name of the recipient being emailed.',
    recipientLastName:
      'The last name of the person to whom the email is being sent.',
    studentFirstName: 'The first name of the applicable student.',
    studentLastName: 'The last name of the applicable student.',
    adminPortalURL:
      'The URL link for the online portal used to sign in as a staff member.',
    familyPortalURL:
      'The URL link for the online portal used to sign in as a family member.',
    centerName: 'The name of the center the email is being sent from.',
    recipientUsername: 'The username of the recipient being emailed.',
    recipientBalanceDue:
      'The balance due for the recipient being emailed, found under their name in the ledger.',
    membersBalanceDue:
      'The sum total of the balance due for all the member <b>and unassigned</b> sponsors of the family, totaled from their names in the ledger.',
    thirdPartiesBalanceDue:
      'The sum total of the balance due for all the third party sponsors of the family, totaled from their names in the ledger.',
    totalFamilyBalanceDue:
      'The sum total of the balance due from all third party AND member/unassigned sponsors of the family combined, totaled from their names in the ledger.',
    staffCrimExpiry:
      "The <i>Criminal Record Check</i> expiry date found in the applicable staff's file.",
    staffIntervExpiry:
      "The <i>Intervention Record</i> expiry date found in the applicable staff's file.",
    staffFirstAidExpiry:
      "The <i>First AId</i> expiry date found in the applicable staff's file.",
    staffReviewDate:
      "The <i>Next Formal Review</i> expiry date found in the applicable staff's file.",
    thirdPartyName_Expiry:
      'List of all third party sponsors for the family and their respective expiry dates, separated by commas.  <b>Only shows future third parties, those without an expiry date and those with a past expiry of 90 days or less.</b>',
    tourDate: 'The date of the booked tour, e.g. Monday, July 14, 2026.',
    tourTime: 'The time of the booked tour, e.g. 9:00 AM.',
    tourTimeZone: "The center's timezone, e.g. Mountain.",
    centerAddress: "The center's full mailing address.",
    cancellationReason: 'The reason provided when the tour was cancelled.',
  },
  emailSignature: 'Email Signature',
  emailSizeWarning:
    'Total email size is {sizeMB}MB. Most email providers have a 20-25MB limit. The email may fail to deliver if the total size is too large.',
  emailTitle: 'Email Subject',
  emailType: 'Email Type',
  delayedEmailCancelled: 'Delayed email cancelled',
  embedCodePrompt: 'Embed the following code snippet:',
  embedFormButtonLabel: 'Embed or share form',
  embedFormUpdatedMessage: 'Embed form updated',
  emergencyContacts: 'Emergency Contacts',
  emergencyMeds: 'Emergency/As Needed',
  employment: 'Employment',
  emptyGradeWarning:
    'No grades for current school/program combination, please add grades in Setup -> Schools',
  emptyPodWarning:
    'No transport groups for current school/grade combination, please add group in Setup -> Transport',
  emptyResult: 'Empty',
  enableBulkMessaging: 'Enable bulk messaging',
  enabled: 'Enabled',
  enablePAD: 'Enable Pre-Authorized Debit (PAD)',
  enablePreAuthPayments: 'Enable Pre-Authorized Credit Card Payments',
  enableSpaceForDropOff: 'Enable space for drop-off',
  enableUnauthorizedDeviceAccess: 'Enable unauthorized device access for',
  endDate: 'End Date',
  endDateAndTime: 'End Date and Time',
  endDateCannotBeAfterExpiryDate: 'End date cannot be after expiry date.',
  endDateCannotBeBeforeStartDate: 'End date cannot be before start date.',
  endNap: 'End Nap',
  endOfMonth: 'End of the Month',
  endTime: 'End Time',
  endTimeMustBeEarlierThanStartTimeErrorMessage:
    'End time must be after start time.',
  enrollmentApplication: 'Enrollment Application',
  pendingToWaitlist: 'Pending to Waitlist',
  pendingToWaitlistDesc:
    'Email sent when a child is moved from Pending to the Waitlist',
  enterEmailErrorMessage: 'Please enter your email',
  enterNewPasswordMessage: 'Please enter your new password',
  enterNewPasswordPrompt: 'Enter your new password',
  enterPinCode: 'Enter PIN code',
  enterPINError: 'Unknown error logging in using PIN.',
  enterYourEmail: 'Enter your email',
  enterYourEmailToContinue: 'Enter your email to continue',
  error: { onlyNumbersAllowed: 'Only valid numbers are allowed' },
  errorDisplayingPIN: 'Error displaying PIN',
  errorLoadingReport: 'Error loading report',
  etransfer: 'E-Transfer',
  etransferFixed: 'E-Transfer Fixed',
  etransferPercentage: 'E-Transfer Percentage',
  event: 'Event',
  eventDate: 'Event Date',
  eventDescription: 'Event Description',
  events: 'Events',
  eventTitle: 'Event Title',
  excludedDates: 'Excluded Dates',
  exemptionReason: 'Exemption Reason',
  existingAdjustmentsReplacement:
    'Existing adjustments will end and be replaced with a new adjustment at the new rate.',
  existingMember: 'Existing Member',
  existingStudent: 'Existing Student',
  exitBulkMessaging: 'Exit bulk messaging',
  exitKioskCredentialsPrompt:
    'To exit Attendance Kiosk mode, please enter the credentials of an authorized user with the role of Center Admin or Org Admin.',
  exitKioskMode: 'Exit Kiosk Mode',
  expand: 'Expand',
  expandAll: 'Expand All',
  expandSidebar: 'Expand sidebar',
  expandToFullPage: 'Expand to full page',
  expandTree: 'Expand tree',
  expected: 'Expected',
  expectedAmount: 'Expected Amount',
  expectedAt: 'expected at {time}',
  expired: 'Expired',
  expiresAt: 'Expires At',
  expiryDate: 'Expiry Date',
  expiryDateCannotBeBeforeEndDate: 'Expiry date cannot be before end date.',
  explainOverrideHint:
    "Explain why you're overriding (e.g., parent was called and refused to sign)",
  export: 'Export',
  exportedOn: 'Exported on',
  exportToPdf: 'Export to PDF',
  pdfLayout: 'PDF layout',
  cardView: 'Card view',
  portrait: 'Portrait',
  landscape: 'Landscape',
  exportWithCustomQuestions: 'Export with Custom Questions',
  exportWithoutCustomQuestions: 'Export without Custom Questions',
  exportPortableRecord: 'Export Portable Record',
  exportPortableRecordDescription:
    'Download a PDF portable record for this staff member without pay information or SIN number.',
  external: 'External',
  externalBalance: 'Third Party Bal.',
  externalName: 'External Name',
  extraStaff: 'Extra staff',
  failed: 'Failed',
  failedAvatar: 'Failed to upload avatar',
  failedFee: 'Failed Fee',
  failedFeeRate: 'Failed Fee Rate',
  failedPaymentPenalty: 'Failed Payment Penalty',
  failedPhotoRemoval: 'Failed to remove photo',
  failedPhotoUpload: 'Failed to upload photo',
  failedToCancelDelayedEmail: 'Failed to cancel delayed email',
  failedToCreateTransaction: 'Failed to create transaction',
  failedToDeleteMemberMessage: 'Failed to delete member.',
  failedToDeleteStaffMessage: 'Failed to delete staff.',
  failedToDeleteStudentMessage: 'Failed to delete student.',
  failedToLoadAcknowledgments: 'Failed to load acknowledgments',
  failedToLoadEmailList: 'Failed to load email list',
  failedToOverrideJournalAcknowledgment:
    'Failed to override journal acknowledgment',
  failedToSaveSpaceLayout: 'Failed to save space layout',
  failedToRemoveSpaceFromCanvas: 'Failed to remove space from canvas',
  failedToSendTo: 'Failed to send to:',
  failedToUpdateNapTime: 'Failed to update nap time',
  failedToRemoveFile: 'Failed to remove file',
  failedToUploadFile: 'Failed to upload {fileName}',
  failedUpload: 'Upload failed',
  exemptionAttachments: 'Exemption Attachments',
  families: 'Families',
  family: 'Family',
  favouritePlansTab: 'My Favourites',
  familyAndChildren: 'Family and Children',
  familyInfo: 'Family Info',
  familyMember: 'Family Member',
  familyName: 'Family',
  familyNotFound: 'Family ID not found',
  current: 'Current',
  upcoming: 'Upcoming',
  startsOn: 'Starts',
  filterFamilies: 'Search Families',
  featureFlags: 'Feature Flags',
  autoInvoicing: 'Invoicing',
  noActiveInvoicing: 'No active invoicing',
  noAutomatedInvoicing: 'No invoicing set up',
  noDiscountsOrFees: 'No discounts or fees',
  noStudentsForFamily: 'No students for current family',
  showExpired: 'Show expired',
  fee: 'Fee',
  feeCollection: 'Fee Collection',
  feePayments: 'Fee Payments',
  merchantFeeSettings: 'Merchant Fee Settings',
  male: 'Male',
  file: 'File',
  files: 'Files',
  fileTypeImproper: 'The file has an improper file type.',
  fileTypeInvalid: 'The file must be a valid file format ({validFormats}).',
  fileTooLarge: 'Please choose a file under {fileSize} MB.',
  fileUploadFailed: 'Failed to upload file.',
  fileErrorMessage: 'Unable to load file',
  fileErrorTitle: 'File Error',
  fileExplorer: 'Files',
  fileInvalidOrMissing: 'Invalid or missing file.',
  fileName: 'File Name',
  fileRemovedSuccessfully: 'File removed successfully',
  fileNotFound: 'File not found',
  fileReadError: 'Error reading file.',
  fileSize: 'File Size',
  fileTooLarge100MB: 'Exceeds max file size of 100MB.',
  fileConversionFailedForUnknownReason:
    'There was an unexpected error while converting files to proper format.',
  fileConversionFailed: "Could not convert file of type '{fileType}'.",
  filter: 'Filter',
  filterAttendees: 'Search Attendees',
  filterByCenter: 'Filter by center',
  filterByGroup: 'Filter by group',
  filterByGroups: 'Filter by groups',
  filters: 'Filters',
  filterSearchResults: 'Filter search results',
  filterSpaces: 'Search Spaces',
  filterStaff: 'Search Staff',
  filterStudents: 'Search Students',
  finance: 'Finance',
  finances: 'Finances',
  financial: 'Financial',
  financialInfo: 'Financial Info',
  finish: 'Finish',
  finishAnyway: 'Exit Anyway',
  finishAt: 'Finish At',
  firstAid: 'First Aid',
  firstName: 'First Name',
  fixed: 'Fixed($)',
  fixedAmount: 'Fixed Amount',
  fixOverlappingSpaces: 'Fix overlapping spaces',
  flaggedMember: 'Flagged Family Member',
  focusArea: 'Focus Area',
  focusAreaGroupDescription:
    'Monitor group progress across all focus areas based on completed lessons',
  focusAreaGroupTitle: 'Focus Area Report For Groups',
  focusAreaProgress: 'Focus Area Progress',
  focusAreaReport: 'Focus Area Report',
  focusAreaReports: 'Focus Area Reports',
  focusAreaStudentDescription:
    'Monitor student progress towards focus areas based on completed lessons',
  focusAreas: 'Focus Areas',
  focusAreaStudentTitle: 'Focus Area Report For Students',
  followUp: 'Follow Up',
  forgotPasswordPrompt: 'Forgot password?',
  forMe: 'For Me',
  forms: 'Forms',
  forParents: 'For Parents',
  framework: 'Framework',
  frameworks: 'Frameworks',
  freezePayments: 'Freeze Payments',
  female: 'Female',
  frequency: 'Frequency',
  frequencyChangeEffectiveDateQuestion:
    'What day should the frequency change appear on reporting?',
  from: 'From',
  fromDate: 'From Date',
  fromDateCannotBeAfterToDate: 'From date cannot be after the To date.',
  fromMe: 'From Me',
  fullDetails: 'Full Details',
  fullName: 'Full Name',
  futureRegistrations: 'Future Registrations',
  gender: 'Gender',
  general: 'General',
  generalInformation: 'General Information',
  generalVaccinationDefaultsWarningMessage:
    'These defaults are based on general recommendations, not the vaccination schedule for your region. Verify every vaccination and dose age against your regional requirements before saving.',
  generalVaccinationDefaultsWarningTitle: 'Load general vaccination defaults?',
  goBack: 'Go back',
  goHome: 'Go Home',
  goToConfiguration: 'Go to Configuration',
  goToDirectory: 'Go to Directory',
  grade: 'Grade',
  gradeRange: 'Grade Range',
  grades: 'Grades',
  graduateRate: 'Graduate Rate',
  grandTotal: 'Grand Total',
  group: 'Group',
  groupByStaff: 'Group by Staff',
  groupCapacity: 'Group Capacity',
  groupChat: {
    addMembers: 'Add members',
    addPeopleTitle: 'Add people to this chat',
    addSelectedMembers: 'Add {count} members',
    allMembers: 'All members',
    allMembersCanManage: 'All members can add or remove people.',
    chatManager: 'Chat manager',
    chatManagerCount: '{count} chat managers',
    chatManagersHelp:
      'Chat managers can rename the chat, manage members, update history access, choose who else can manage the chat, and delete the chat. This is separate from ChildFriendly organization admins.',
    chatManagersOnly: 'Chat managers only',
    chatManagersTitle: 'Chat managers',
    confirmDeleteMessage:
      'Deleting this group permanently removes it for every member. This cannot be undone.',
    confirmDeleteTitle: 'Delete this group?',
    confirmLeaveMessage:
      'You will lose access to this group chat unless another member adds you again.',
    confirmLeaveTitle: 'Leave this group?',
    createGroup: 'Create',
    creator: 'Creator',
    customNameHint: 'Custom name shown to members',
    deleteGroup: 'Delete group',
    deleteGroupDescription:
      'Delete removes the group chat for every member and cannot be undone.',
    editName: 'Edit group name',
    fullHistory: 'Full history',
    fullHistoryHint:
      'Leave blank to let new members see the full chat history.',
    groupActions: 'Group actions',
    groupChats: 'Group Chats',
    groupName: 'Group name',
    groupNameOptional: 'Group name (optional)',
    hideFromDirectory: 'Hide from directory',
    hideHiddenChats: 'Hide hidden chats',
    historyAccess: 'History access',
    historyAccessHelp:
      'Choose the date and time when a member can start viewing past messages. Leave it blank to let them see the full chat history.',
    historyDatePastOnly: 'History access date and time cannot be in the future',
    infoSubtitle: 'Manage this chat without leaving the conversation.',
    infoTitle: 'Group info',
    lastManagerLeaveHint:
      'Assign another chat manager before you leave this group chat.',
    leaveGroup: 'Leave group',
    leaveGroupDescription:
      'Leave only removes you from this chat. Other members can continue using it.',
    makeChatManager: 'Make chat manager',
    manageGroupTooltip: 'Manage group chat',
    member: 'Member',
    memberCount: '{count} members',
    memberManagement: 'Member management',
    memberManagementDescription:
      'Decide whether only chat managers or all members can add and remove people.',
    membersDescription:
      'Chat managers and history access are managed per member.',
    newGroupChat: 'New group chat',
    noAdminsAvailable: 'No more admins are available to add.',
    noAdminsFound: 'No admins found',
    noGroupChatsYet: 'No group chats yet',
    onlyManagersCanManage: 'Only chat managers can add or remove people.',
    participantsPreview: '{names} and {count} more',
    removeFromChat: 'Remove from chat',
    removeMemberTooltip: 'Remove this member from the group chat',
    roleInChat: 'Role in this chat',
    scopeLabel: 'Group Chat',
    searchAdmins: 'Search admins by name or email',
    searchAdminsEllipsis: 'Search admins...',
    selectedCount: '{count} selected',
    showHiddenChats: 'Show hidden chats',
    showInDirectory: 'Show in directory',
    unsavedChanges: 'Unsaved group changes',
    unsavedChangesDescription:
      'Save or cancel your changes before leaving this screen.',
    unsavedMemberChanges: 'Member role or history changes are not saved yet.',
    timeline: {
      adminAdded: '{actor} made {targets} chat manager.',
      adminRecovered:
        'ChildFriendly restored chat manager access to {targets} because the group chat no longer had an active manager.',
      adminRemoved: '{actor} removed {targets} as chat manager.',
      created: '{actor} created the group chat.',
      historyFrom: '{actor} shared history with {targets} starting {date}.',
      historyFull: '{actor} shared full history with {targets}.',
      manyNames: '{names}, and {last}',
      memberAdded: '{actor} added {targets}.',
      memberLeft: '{target} left the group chat.',
      memberManagementAll:
        '{actor} allowed all members to add and remove people.',
      memberManagementManagers:
        '{actor} limited member changes to chat managers.',
      memberRemoved: '{actor} removed {targets}.',
      nameChanged: '{actor} renamed the group chat to {name}.',
      nameCleared: '{actor} cleared the group chat name.',
      someone: 'someone',
      systemActor: 'ChildFriendly',
      twoNames: '{first} and {second}',
    },
  },
  groupAsOfDate: 'Group As Of Date',
  groupEndDate: 'Group End Date',
  groupOverride: 'Group Override',
  groupStartDate: 'Group Start Date',
  groups: 'Groups',
  groupSize: 'Group Size',
  growthIndicator: 'Growth Indicator',
  growthIndicators: 'Growth Indicators',
  guardian: 'Guardian',
  guardianOne: 'Guardian One',
  guardians: 'Guardians',
  guardianSignature: 'Guardian Digital Signature of Permission',
  guardianStepInstruction:
    'Enter the legal guardian information for the family. This person will be the primary contact and responsible for the registration.',
  health: 'Health',
  healthCareNumber: 'Health Care Number',
  healthSymptoms: 'Health Symptoms',
  helpCenter: 'Help Center',
  helpVideos: 'Help Videos',
  hide: 'Hide',
  hiddenOnPortal: 'Hide Invoices on Portal',
  hideBankInfoLabel: 'Hide bank info',
  hideParentAttendanceDetails: 'Hide Parent Attendance Details',
  hideHiddenRecords: 'Hide Hidden Records',
  hidePIN: 'Hide PIN',
  highAge: 'High Age',
  highAgeMonths: 'High Age (months)',
  highAgeValidationError: 'High Age cannot be lower or equal to Low Age.',
  highGrade: 'High Grade',
  highGradeValidationError: 'High grade cannot be lower than low grade.',
  highRatio: 'High Ratio',
  hint: {
    filtering: 'Hint: Filtering for students{status}{dateRange}.',
    withStatus: " with '{status}' status",
    withDateRange: ' at some point during the period {from} to {to}',
    withoutDateRange: '',
  },
  history: 'History',
  holidays: {
    addHoliday: 'Add Holiday',
    archiveYear: 'Archive Year',
    customHolidays: 'Custom Holidays',
    customHolidaysOnly: 'Custom Holidays Only',
    copyCustomHolidaysFromYear: 'Copy Custom Holidays from Year',
    copyFromAnotherYear: 'Copy from Another Year',
    editHoliday: 'Edit Holiday',
    fromYear: 'From Year',
    holidayCalendar: 'Holiday Calendar',
    holidayHours: 'Holiday Hours',
    holidayName: 'Holiday Name',
    holidays: 'Holidays',
    loadHolidays: 'Load Holidays',
    loadPublicHolidays: 'Load Public Holidays',
    regional: 'Regional',
    selectedHolidays: 'Selected Holidays',
    statutory: 'Statutory',
    statutoryHolidayReadOnly:
      'Statutory holidays cannot be deleted, only toggled on/off',
    statutoryHolidays: 'Statutory Holidays',
  },
  homeSpace: 'Home Space',
  hour: 'Hour',
  hours: 'Hours',
  hourlyRate: 'Hourly Rate ($)',
  howToManage: 'How To Manage',
  iAm: 'I am a/an...',
  image: 'Image',
  imageConversionProgress: '{current} of {total} converted',
  immunization: 'Immunization',
  immunizationAreUpToDate: "'s immunizations are up to date",
  immunizationInformation: 'Immunization Information',
  immunizationDose: 'Immunization Dose',
  immunizationDestination: 'Immunization or Dose',
  exemptionDestination: 'Immunization exemption',
  immunizationDoseEvidenceRequired:
    'Enter the date given and attach a dose file to complete this dose.',
  immunizationExemptionEvidenceRequired:
    'Select an exemption reason and attach an exemption file to complete it.',
  immunizationRecordAttachments: 'Immunization Record Files',
  immunizationRecordEvidenceRequired:
    'Enter the date given and attach a record file to complete this vaccination.',
  immunizationDueAgesInMonths: 'Due Ages (Months)',
  immunizationDueAgesInMonthsHint:
    'Enter each vaccine milestone as an age in months, separated by commas (for example: 2, 4, 6, 12, 18, 48).',
  immunizationRecord: 'Immunization Record',
  immunizationRecordFileUrl: 'Immunization Record File',
  immunizationRecords: 'Immunization Records',
  immunizationRecordSubtitle: 'Immunization record',
  immunizationsAreCurrent: 'Immunizations Are Current?',
  immunizationsAreUpToDate: 'Immunizations are up to date',
  immunizationStatus: 'Immunization Status',
  immunizationUpdatesNeeded: 'Updates Needed',
  immunizationUploadAvailableAfterSave:
    'File uploads will be available after saving the student profile.',
  immunizationUpToDate: 'Up to Date ✓',
  importantLinks: 'Important Links',
  importData: 'Import Data',
  importDataType: 'Import Data Type',
  incident: 'Incident',
  includeAdmins: 'Include admins',
  includeAllStaffQuestion: 'Include All Staff?',
  includedPayments: 'Included Payments',
  includeDropIn: 'Include Drop In',
  includeUnreadMessages: 'Include unread messages',
  includeWaitlisted: 'Include Waitlisted',
  incorrectPasscodeMessage: 'The code entered is incorrect',
  ineffectiveExpelled: 'Ineffective / Expelled',
  info: 'Info',
  infoChanges: 'Info Changes',
  infoChangesSavedBannerMessage:
    'Recent changes are saved and are awaiting admin approval.',
  infoTags: 'Info Tags',
  initialize: 'Initialize',
  insertField: 'Insert Field',
  mergeFields: 'Merge Fields',
  focusFieldFirst: 'Focus a subject or body field to enable shortcuts',
  clickToInsert: 'Click a shortcut to insert',
  institutionNumber: 'Institution Number',
  interactions: 'Interactions',
  internal: 'Internal',
  interventionCheck: 'Intervention Check',
  inUseRates: 'In Use Rates',
  invalidCharacters: 'Only lowercase letters, numbers, -, and _ are allowed',
  invalidEmail: 'Must be a valid email address',
  invalidImmunizationDueAges: 'Enter a whole-number age of zero or greater.',
  invalidPIN: 'Invalid PIN.',
  invoice: 'Invoice',
  invoiceAmount: 'Invoice Amount',
  invoiceAmountTooltip:
    'Percentage amounts will be calculated based only on the invoiced amount for this sponsor, excluding other sponsors amounts on the billing',
  invoiceNumber: 'Invoice Number',
  invoicePeriodEnd: 'Invoice Period End',
  invoicePeriodStart: 'Invoice Period Start',
  invoiceRef: 'Invoice Ref',
  invoices: 'Invoices',
  invoicesAndCreditMemos: 'Invoices & Credit Memos',
  invoicesCreditMemosToApply: 'Invoices/Credit Memos to apply',
  invoiceStatus: 'Invoice Status',
  invoiceType: 'Invoice Type',
  lineItem: 'Line Item',
  isChildNameOnLabel: 'Name On Label',
  isDefault: 'Is Default',
  isFixed: 'Is Fixed',
  isFlagged: 'Is Flagged',
  isInOriginalContainer: 'Original Container',
  isOvernight: 'Overnight Mode',
  isPrescribedByPhysician: 'Prescribed By Physician',
  isSchoolRequired: 'School Required',
  jobInfo: 'Job Information',
  journal: 'Journal',
  journals: 'Journals',
  journalAcknowledgmentOverriddenSuccessfully:
    'Journal acknowledgment overridden successfully',
  journalChangesWarning:
    "Changes made when editing a journal of type 'Health' or 'Incident' won't appear until the admin approves.",
  journalDate: 'Journal Date',
  journalMedicationHint: 'There are no emergency/as needed medications on file',
  journalUploadedImageAltText: 'Uploaded image',
  keyImageAltText: 'Key image',
  keyOptionalForTopLevelJsonObject:
    'Optional when the value is a JSON object added at the top level',
  kinderProgram: 'Kinder Program',
  kiosk: 'Kiosk',
  kioskSignInCompleteMessage:
    'Thank you! Drop-off/pick-up is complete, you’re all set to go.',
  last: 'Last',
  lastAttempt: 'Last attempt: {time}',
  lastBillingDate: 'Last Billing',
  lastContacted: 'Last Contacted',
  lastDoseDate: 'Last Dose Date',
  lastDoseDateBeforeNextDueDate:
    'Last dose date cannot be later than next due date',
  lastName: 'Last Name',
  lastRead: 'Last Read',
  lastStatusChange: 'Last Status Change',
  layoutTools: 'Layout tools',
  learn: 'Learn',
  learnMore: 'Learn more',
  learning: 'Learning',
  learningOutcome: 'Learning Outcome',
  learningOutcomes: 'Learning Outcomes',
  ledger: 'Ledger',
  legacyImmunizationFiles: 'Legacy immunization files',
  legacyMessage: 'Legacy message',
  legacyMessageHelp:
    'This message was sent from the old system. Replies will be sent to both the room and admin conversation threads for this member.',
  legalGuardianConfirmationRequired:
    'You must confirm that you are the legal guardian.',
  legalName: 'Legal Name',
  less: 'Less',
  lesson: 'Lesson',
  lessonLibrary: 'Lesson Library',
  lessonName: 'Lesson Name',
  lessonNumber: 'Lesson #',
  lessonPlan: 'Weekly Plan',
  lessons: 'Lessons',
  license: 'License',
  licenseType: 'License Type',
  licensingInfo: 'Licensing Info',
  limitedPickupAuthorization: 'Member does not have full pickup authorization',
  linked: 'Linked',
  linkedPaymentDeleteWarning:
    'This payment is part of a linked payment group. Deleting it will affect the linked total.',
  linkedPaymentId: 'Linked Payment ID',
  liveWith: 'Lives With',
  loadDefaultVaccinations: 'Load Default Vaccinations',
  loadEarlierMessages: 'Load earlier messages',
  loadedDefaultVaccination: 'Loaded Default',
  loading: 'Loading',
  loadingMoreReports: 'Loading more reports...',
  loadingSponsorInvoices: 'Loading sponsor invoices...',
  loadingTakingLonger: 'This is taking a moment, please wait…',
  loadingTakingMuchLonger:
    'Still loading. The server is taking longer than usual — your changes are safe.',
  location: 'Location',
  locationMessagesGroup: { inUseError: 'Cannot delete location(s) in use' },
  locationNameAlreadyInUse: 'Location name is already in use',
  locationOptions: {
    classroom: 'Classroom',
    gym: 'Gym',
    outdoorSpace: 'Outdoor Space',
    offsite: 'Offsite',
    other: 'Other',
  },
  locations: 'Locations',
  lockedTo: 'Locked to',
  login: 'Login',
  loginCredentialsInvalidMessage: 'Email or password is invalid',
  loginEmail: 'Login/Reply To Email',
  logout: 'Logout',
  lowAge: 'Low Age',
  lowAgeMonths: 'Low Age (months)',
  lowAgeValidationError: 'Low Age cannot be higher or equal to High Age.',
  lowGrade: 'Low Grade',
  lowGradeValidationError: 'Low grade cannot be higher than high grade.',
  lowRatio: 'Low Ratio',
  main: 'Main',
  makePayment: 'Make payment',
  makeRecurring: 'Make Recurring',
  manuallyConfirmParentAware:
    'Manually confirm that the parent was made aware of this',
  manualOverpayment: 'Manual Overpayment',
  manualOverpaymentCredit: 'Manual Overpayment Credit',
  manualUnderpayment: 'Manual Underpayment',
  manualUnderpaymentCredit: 'Manual Underpayment Credit',
  markAllAsRead: 'Mark all as read',
  markAsUnread: 'Mark as unread',
  markAsUrgent: 'Mark as urgent',
  marketing: 'Marketing',
  materialName: 'Material Name',
  materialsNeeded: 'Materials Needed',
  maxCapacity: 'Max Capacity',
  maxChildren: 'Max Children',
  maximum: 'Maximum',
  maxTeamSize: 'Max Size',
  meal: 'Meal',
  mealAdjustments: 'Meal Adjustments',
  meals: 'Meals',
  mealsDashboard: {
    actions: {
      clearGroup: 'Clear group',
      clearMeal: 'Clear meal',
      collapseStudentDetails: 'Collapse student details',
      expandStudentDetails: 'Expand student details',
      showAllGroups: 'Show all groups',
      showFewerGroups: 'Show fewer groups',
    },
    cards: {
      prohibitedCount: '{count} prohibited',
    },
    details: {
      absenceRsvp: 'RSVP absent',
      appliedFilters: 'Applied filters',
      columns: {
        adjustments: 'Meal adjustments',
        group: 'Group',
        restrictions: 'Meal restrictions',
        student: 'Student',
      },
      filters: {
        adjustments: 'Adjustments',
        allStudents: 'All students',
        restrictions: 'Restrictions',
        showStudentsWith: 'Show students with',
      },
      matchingStudents: '{count} matching students',
      loadedStudents: '{loaded} of {total} loaded',
      noGroup: 'No group',
      noStudentsMatchFilters: 'No students match the current filters.',
      title: 'Student details',
    },
    download: {
      dateRange: '{fromDate} to {toDate}',
      prohibitedMealTypes: 'Prohibited Meal Types',
    },
    filters: {
      advancedFilters: 'Advanced filters',
      advancedFiltersDescription:
        'Optional group, restriction, and adjustment filters.',
      additionalFilters: 'Additional refinements',
      additionalFiltersDescription:
        'Optional list filters for specific groups, restrictions, or adjustments.',
      currentAttendanceOnly: 'Currently in attendance only',
      currentAttendanceOnlyDisabled:
        'Current attendance is only available for today.',
      currentAttendanceOnlyDescription:
        'Limit today to students signed in now.',
      dateRange: 'Meal date',
      description: 'Choose the students and meal restrictions to include.',
      allMealAdjustments: 'All adjustments',
      mealAdjustmentFilter: 'Meal adjustment',
      mealAdjustments: 'Meal adjustments',
      mealAdjustmentsDescription:
        'Choose specific meal adjustments, or select all to show every student with an active meal adjustment.',
      mealAdjustmentsOnly: 'Meal adjustments only',
      mealAdjustmentsOnlyDescription:
        'Only include students with active meal fees or adjustments.',
      showAbsenceRsvpStudents: 'Show absence RSVP students',
      showAbsenceRsvpStudentsDescription:
        'Keep students whose family marked them absent.',
      title: 'Dashboard filters',
    },
    groupCounts: {
      allClear: 'All clear',
      byGroup: '{label} by group',
      bySpace: '{label} by space',
      permitted: 'Permitted',
      permittedCount: '{count} permitted',
      restrictedCount: '{count} restricted',
      restrictedOfTotal: '{restricted} of {total} restricted',
      restricted: 'Restricted',
      selectedProhibited: '{count} selected prohibited',
      spaceHelp:
        "When 'Currently in attendance only' is on, students are counted in the space where they are signed in now. Otherwise, spaces are based on each group's Home Space in Setup.",
      spaceHelpTitle: 'How spaces are determined',
      spaceTitle: 'Space counts',
      students: '{count} students',
      title: 'Group counts',
      total: 'Total',
      totalCount: '{count} total',
    },
    labels: {
      allRestrictions: 'All restrictions',
      mealTypesSelected: '{count} meal types',
    },
    overview: {
      noProhibitedMealTypesFound: 'No prohibited meal types found.',
      studentsHaveRestrictions: '{count} students have restrictions',
      showRestrictionsWithNoStudents: 'Show restrictions with no students',
      title: 'Meal restriction overview',
    },
    summary: {
      permitted: '{label} permitted',
      prohibited: '{label} prohibited',
      withMealRestrictions: 'Students with meal restrictions',
      withoutMealRestrictions: 'Students without meal restrictions',
      totalStudents: 'Total students',
    },
  },
  mealService: 'Meal Service',
  mealsService: 'Meals Service',
  mediaLibrary: {
    selectedFileAlt: 'Selected file',
    changeFile: 'Change File',
    addFile: 'Add File',
    uploadYourOwnFile: 'Upload Your Own File',
    uploading: 'Uploading...',
    uploadAFile: 'Upload A File',
    chooseFromLibrary: 'Or Choose From Library',
    searchPhotos: 'Search Photos',
    addToLibrary: 'Add to library',
    fileAlt: 'File {index}',
    noFilesAvailable: 'No files available',
    photoAlt: 'Photo {index}',
    noPhotosAvailable: 'No photos available',
    dragDropOrSelectMultiple: 'Drag & drop or select multiple',
    orDragAndDrop: 'or drag & drop',
    confirmDeleteMessage:
      'Are you sure you want to delete this file? This action cannot be undone.',
    scopeHelper: 'Choose where new files will be stored',
    scopeGlobal: 'Global library',
    scopeOrg: 'Organization library',
    scopeUser: 'My library',
    currentScopePrefix: 'Destination:',
    scopeAll: 'All libraries',
    noFilesForScope: 'No files available',
  },
  medicalAndEmergencyDetails: 'Medical and Emergency Details',
  medicalPractitioner: 'Medical Practitioner',
  medicalPractitionerDetails: {
    addMedicalPractitioner: 'Add Medical Practitioner',
    assignedToThisStudent: 'Assigned to this student',
    changeMedicalPractitioner: 'Change',
    chooseMedicalPractitioner: 'Choose Medical Practitioner',
    clinic: 'Clinic',
    clinicAddress: 'Clinic Address',
    deleteMedicalPractitioner: 'Delete Medical Practitioner',
    deleteMedicalPractitionerConfirm:
      'Delete {name} from this family’s medical practitioner directory?',
    deleteMedicalPractitionerNamed: 'Delete {name}',
    editMedicalPractitioner: 'Edit Medical Practitioner',
    editMedicalPractitionerNamed: 'Edit {name}',
    familyMedicalPractitioners: 'Family medical practitioners',
    familyMedicalPractitionersHelp:
      'Practitioner details can be shared by more than one student.',
    invalidPhoneNumber: 'Enter a valid 10-digit phone number',
    medicalPractitionerAdded: 'Medical practitioner added',
    medicalPractitionerAssignedTo: 'Assigned to: {names}',
    medicalPractitionerCount: '{count} practitioners',
    medicalPractitionerDeleteAssigned:
      'Reassign or unlink every assigned student before deleting this practitioner.',
    medicalPractitionerDeleted: 'Medical practitioner deleted',
    medicalPractitionerHelp:
      'Assign a practitioner to this student or manage the practitioners shared by this family.',
    medicalPractitionerRequiredFieldsHelp:
      'Name, clinic, and phone number are required.',
    medicalPractitionerSharedWith: 'Changes also affect: {names}',
    medicalPractitionerUpdated: 'Medical practitioner updated',
    noMedicalPractitionerAssigned: 'No medical practitioner assigned',
    noMedicalPractitioners: 'No medical practitioners added',
    noMedicalPractitionersHelp:
      'Add one here, then assign them to this student.',
    notAssignedToStudents: 'Not assigned to a student',
    provinceState: 'Province / State',
    provinceStateRegion: 'Province / State / Region',
    removeMedicalPractitionerAssignment: 'Remove Assignment',
  },
  medication: 'Medication',
  requiresMedicationOrMedicalPermissionsQuestion:
    'Does this child require any medication or medical permissions?',
  medicationAdministrationDisclaimer:
    '*This medication is only to be administered according to the directions labeled on the original container.',
  medicationForm: 'Medication Form',
  medicationGivenDateTime: 'Medication Given DateTime',
  medicationName: 'Medication Name',
  medicationOutcomeTime: 'Outcome Time',
  medicationType: 'Type',
  member: 'Member',
  memberInfoChangesLabel: 'Member Info Changes',
  memberInfoChangesDescription:
    'Review guardian profile updates submitted from the family portal before applying them.',
  memberInfoUnsavedChanges: {
    title: 'Unsaved member information',
    description: 'Save or reset your changes before leaving this page.',
  },
  memberPaymentInfoChangesLabel: 'Member Payment Info Changes',
  memberPaymentInfoChangesDescription:
    'Review payment profile changes and acknowledge updates after they have been handled.',
  memberPaymentInfoChangesTypes: {
    addedBankInfo: 'Added Bank Info',
    editedBankInfo: 'Edited Bank Info',
    deletedBankInfo: 'Deleted Bank Info',
    addedCreditCard: 'Added Credit Card',
    modifiedCreditCard: 'Modified Credit Card',
    deletedCreditCard: 'Deleted Credit Card',
    addCustomEmail: 'Added Custom Email',
    modifyCustomEmail: 'Modified Custom Email',
    deletedCustomEmail: 'Deleted Custom Email',
  },
  memberPINLabel: 'Kiosk PIN',
  members: 'Members',
  memo: 'Memo',
  merchantFee: 'Merchant Fee',
  merchantFeeAmount: 'Merchant Fee Amount',
  merchantFeeDescription:
    'Indicate the merchant fee percentage you wish to charge sponsors automatically, for each transaction type.',
  merchantFeePassThroughAmount: 'Merchant Fee Pass Through Amount',
  merge: 'Merge',
  mergeFamilies: {
    addAsANewEntry: 'Add as a new entry',
    amountDue: '{amount} due',
    amountDueOf: '{due} due of {total}',
    bothHaveBillingsBlocked:
      'Both registrations already have billings. A registration can only have one billing, so these cannot be merged. Keep as a new registration instead.',
    targetHasBillingsBlocked:
      "This target registration already has billings on it. Merging into it would replace it, so we can't let you do that — keep as a new registration instead.",
    cannotSkipMemberTooltip:
      'This member has sponsored receipts, so they must be merged or carried over to keep financial records intact.',
    cannotSkipStudentTooltip:
      'This student has registrations with billings, so they must be transferred to keep financial records intact.',
    confirmDoFirst:
      'If you still need to create a journal entry, finish attendance, or copy any notes from the families being merged in, do that first and come back.',
    confirmIntro:
      'Only family and student info, registrations, and payments will be transferred to the primary family.',
    confirmNothingElse:
      'Nothing else will move over. Attendance logs, journals, forms, documents and other records stay with the soft-deleted family as historical data.',
    confirmTitle: 'Merge these families?',
    criticalDataLoadError: 'Unable to load billing and sponsorship data',
    criticalDataLoadErrorHelp:
      "We couldn't verify which members have sponsored receipts or which students have billed registrations. Merging without this data could result in lost financial records. Please retry or try again later.",
    dontTransfer: "Don't transfer",
    dontTransferCaption: "This person won't be carried over",
    dontTransferRegistration: "Don't transfer this registration",
    dontTransferRegistrationCaption: "The registration won't be carried over",
    duplicateMemberNames: 'Duplicate member names detected',
    duplicateMemberNamesHelp:
      'All member names must be unique within a family. The following names would appear more than once after the merge: {names}. Please merge the duplicate members into one, or skip one of them.',
    familiesMerged: 'Families merged',
    familyEmailHelp:
      "The family email follows the primary member's email. To change it, update the primary member's login email on the next step.",
    familyEmailLabel: 'Family email',
    familyNameLabel: 'Family name',
    fullyPaid: '{amount} paid',
    hideBillingDetails: 'Hide billing details',
    keepAsANewRegistration: 'Keep as a new registration',
    keepValue: 'Keep',
    loadingCriticalData: 'Verifying billing and sponsorship data...',
    loadingRegistrations: 'Loading registrations...',
    loginEmailBecomes: 'login email becomes',
    mapHelp:
      'For each person on the accounts being merged in, decide whether they already exist on the primary family (pick the matching person), should be carried over as a new addition, or should not be transferred at all.',
    mapPeople: 'Map people',
    mergeInto: 'Merge into {name}',
    mergeIntoRegistration: 'Replace: {name}',
    merging: 'Merging in',
    mergingInCount: 'Merging in ({count})',
    multipleSourcesNote:
      'More than one person is being merged into this record. Pick the value to keep for each field below; the choice applies to the combined record.',
    newMembersMergedSummary: '{new} new member(s), {merged} merged',
    newStudentsMergedSummary: '{new} new student(s), {merged} merged',
    noContactInfo: 'No contact info',
    noEmail: 'No email',
    noFamilyEmailOnFile: 'No family email on file',
    noMembersOrStudentsToMerge: 'No members or students to merge.',
    noRegistrationsOnThisStudent: 'No registrations on this student.',
    ongoing: 'Ongoing',
    paidOfBilled: '{paid} / {total} paid',
    pickWhichValueToKeep: 'Pick which value to keep',
    primaryAccount: 'Primary account',
    primaryFamily: 'Primary family',
    primaryFamilyDetails: 'Primary family details',
    primaryHelp:
      'Pick the account that should survive the merge. All other accounts will have their members, students and payments transferred into this one and then be soft-deleted.',
    registrationAlreadyBilled: 'already has {amount} billed',
    registrationBillingNote:
      "Registrations with billings must be transferred. They can't be skipped, and they can't be merged into another registration that already has billings (merging replaces the target chain, so we can't allow it when that target is already billed). If you need to cancel one, do it from the student's registration page after the merge.",
    registrationCannotSkipTooltip:
      'This registration has billings, so it must be transferred to keep financial records intact.',
    reviewAndMerge: 'Review and merge',
    reviewArrivingBreakdown: '{newCount} new, {mergedCount} merged in',
    reviewArrivingMembers: '{count} member(s) arriving',
    reviewArrivingStudents: '{count} student(s) arriving',
    reviewAutoAdjustmentsLost:
      '{count} auto-adjustment(s) on families being merged in will be lost. Re-create them on the surviving family after the merge if still needed.',
    reviewBeingRemoved: 'Being removed',
    reviewDispoAddedAsNew: 'Added as a new {kindLabel}',
    reviewDispoMergedInto: 'Merged into {name}',
    reviewDispoSkipped: "Won't be transferred",
    reviewEmptyValue: '(empty)',
    reviewFamilyEmailChange: 'Family email changes from {from} to {to}',
    reviewFamilyNameChange: 'Family name changes from {from} to {to}',
    reviewFamilyNameUnchanged: 'Family name stays as {name}',
    reviewFieldAdded: '{label}: set to {to} (was empty)',
    reviewFieldChange: '{label}: {from} → {to}',
    reviewFieldChangesHeader: 'Values replacing existing info on {name}:',
    reviewHelp:
      'Double-check every change below. Once you merge, the other families are deleted and this cannot be undone.',
    reviewMembersCount: '{count} member(s)',
    reviewNoArrivals: 'Nothing will transfer from this family',
    reviewNotTransferredCount: '{count} not transferred',
    reviewPrimaryHas: '{members} · {students}',
    reviewRegistrationMergeInto: 'Replaces {name}',
    reviewRegistrationMergeIntoDetail:
      'The target registration will be deleted and replaced by this one. All billings will be transferred.',
    reviewRegistrationsHeader: 'Registrations:',
    reviewRegistrationSkip: "Won't transfer",
    reviewRegistrationTransfer: 'Transferred as-is',
    reviewSoftDeleted: 'Will be deleted',
    reviewSoftDeleteHint: 'This family will be deleted after the merge.',
    reviewStudentsCount: '{count} student(s)',
    reviewSurvives: 'Survives the merge',
    reviewWhatWontMove: "What won't move over",
    reviewWhatWontMoveDetail:
      'Attendance logs, journals, forms, documents, notes and other records stay with the deleted families as historical data. Any auto-adjustments (discounts) on families being merged in will also be lost and will need to be re-created on the surviving family.',
    selectPrimaryFamilyToContinue: 'Select the primary family to continue',
    showBillingDetails: 'Show billing details',
    skippedMembersSummary: '{count} not transferred',
    skippedStudentsSummary: '{count} not transferred',
    stepIndicator: 'Step {current} of {total}: {label}',
    title: 'Merge families',
    unnamed: 'Unnamed',
    unnamedFamily: 'Unnamed family',
    useValueFrom: 'From {source}',
  },
  message: 'Message',
  messageCenter: 'Message Center',
  messages: 'Messages',
  messageSentSuccessfully: 'Message Sent Successfully!',
  addAuthorizedSponsor: 'Add Authorized Sponsor',
  addAbsenceRestricted: 'Adding absences is disabled for this portal account.',
  addingFamilyMembersRestricted:
    'Adding family members is disabled for this portal account.',
  onlyPrimaryMemberCanAddFamilyMembers:
    'Only the primary member can add new family members.',
  messagesGroup: {
    fail: 'Oops, failed',
    internalError: 'Oops! We are experiencing an error in the server',
    success: 'Success',
    unknownError: 'Oops! We are having an unknown error',
    networkError: 'Oops! Internet connection was lost',
    forbidden: "Oops! Looks like you don't have permission to do that",
    pendingRegistration: 'Available - Payment Required: ',
    pendingRegistrationNoPayment: 'Available - No Payment Required',
    waitlistedRegistration: 'Program Full - Join Waitlist: ',
  },
  messagingAs: 'Messaging as',
  messaging: 'Messaging',
  method: 'Method',
  middleName: 'Middle Name',
  milestone: 'Milestone',
  milestones: 'Milestones',
  minChildren: 'Min Children',
  minimize: 'Minimize',
  minimum: 'Minimum',
  minute: 'Minute',
  minutes: 'Minutes',
  missingCenterBankInfoWarning:
    'You have not entered banking information for your center. Without banking information you will not be able to process family payments or deposit them to your bank account.',
  missingOnboardingInformation: 'Missing Onboarding Information',
  mixedTeamRatioRules: 'Mixed Ratio',
  mobileOutdated: 'Please update your app to the latest version.',
  modifiedDates: 'Modified Dates',
  month: 'Month',
  monthly: 'Monthly',
  months: 'Months',
  more: 'more',
  moreOptions: 'More options',
  mostRecent: 'Most Recent',
  moveActivity: 'Move Activity',
  chooseWhereToCopy: 'Choose where to copy',
  chooseWhereToMove: 'Choose where to move',
  moveDown: 'Move Down',
  moveMultiplePeopleConfirmationMessage:
    'Are you sure you want to move {count} people out of the {fromSpaces} into the {toSpace} space?',
  moveOnePersonConfirmationMessage:
    'Are you sure you want to move 1 person out of the {fromSpaces} into the {toSpace} space?',
  moveTo: 'Move To',
  moveToBlob: 'Move to {blobName}',
  moveUp: 'Move Up',
  targetDay: 'Target Day',
  targetRoutine: 'Target Routine',
  multipleAccountsDetected:
    'You have accounts in multiple centers, which one would you like to access?',
  mustBePdf: 'File must be a PDF',
  mustProvideEmail: 'Must provide a personal email for username',
  mutedCalendars: 'Muted Calendars',
  muteNotifications: 'Mute Notifications',
  myCalendars: 'My Calendars',
  myGroup: 'My Group',
  myHours: 'My Hours',
  myTimeOff: 'My Time Off',
  myPlans: 'My Plans Only',
  myPlansTab: 'My Plans',
  myself: 'Myself',
  name: 'Name',
  nameOrDescription: 'Name or Description',
  nappers: 'Nappers',
  napping: 'Napping',
  needHelpContactAdmin: 'Need help? Contact your center admin',
  noPendingRequests: 'No pending requests',
  noPendingJournalFieldChanges: 'There are no pending field changes to apply.',
  failedToSaveActivity: 'Failed to save activity. Please try again.',
  failedToSaveActivityWithSelectedStudents:
    'Failed to save activity. All students must be deselected.',
  new: 'New',
  newAnnouncement: 'New Announcement',
  newDirectMessage: 'New direct message',
  newEvent: 'New Event',
  newFolder: 'New Folder',
  newItem: 'New Item',
  newMember: 'New Member',
  newMessage: 'New Message',
  newMessages: 'New Messages',
  newAmountEffectiveDateQuestion:
    'Which day would you like the new amount to take effect?',
  newPlan: 'New Plan',
  newWeeklyPlan: 'New Weekly Plan',
  newPublicRegistration: 'New Public Registration',
  newPaymentRefund: 'New Payment / Refund',
  inquiryFamilyCreatedEmail: 'Inquiry Submission',
  inquiryFamilyCreatedEmailDesc:
    'Email sent when a family submits an inquiry form',
  tourBookingConfirmedEmail: 'Tour Booking Confirmed',
  tourBookingConfirmedEmailDesc:
    'Email sent to the guardian when their tour is successfully booked',
  tourBookingCancelledEmail: 'Tour Booking Cancelled',
  tourBookingCancelledEmailDesc:
    'Email sent to the guardian when their tour is cancelled',
  tourBookingRescheduledEmail: 'Tour Booking Rescheduled',
  tourBookingRescheduledEmailDesc:
    'Email sent to the guardian when their tour is moved to a new time',
  tourReminderEmail: 'Tour Reminder',
  tourReminderEmailDesc:
    'Email sent to the guardian the evening before their scheduled tour',
  newStudent: 'New Student',
  next: 'Next',
  nextArrow: 'Next >',
  nextDueDate: 'Next Due Date',
  nextDueDateAfterLastDoseDate:
    'Next due date cannot be earlier than last dose date',
  nextFormalReview: 'Upcoming Formal Review',
  graduatingNextProgram: 'Graduating Next Program',
  no: 'No',
  noLeaveExisting: 'No, leave existing',
  noAnnouncements: 'No announcements',
  noAssessmentsRecorded: 'No assessments recorded',
  noAttendeesInTeam: 'No attendees in team',
  noAttendeesYet: 'No attendees yet',
  noOneSelectedYet: 'No one selected yet',
  noDataFound: 'No data found',
  none: 'None',
  noPlans: 'No Plans',
  addAttendeeTooltip: 'Add attendee to team',
  addAssessment: 'Add Assessment',
  addFirstAttendeeToTeam: 'Add the first attendee to {name}',
  noAbsencesToVerify: 'No absences to verify for this date.',
  noAccountsDetected:
    'No accounts found with the entered email address, please contact your center to setup an account.',
  noContactAttempts: 'No contact attempts logged yet.',
  noAllocation: 'No Allocation',
  noAvailableSpaces:
    'No spaces are currently available for drop-off. Please reach out to your center for assistance.',
  noAvailableStudents:
    'No registered students are currently available for drop-off or pick-up. Please check with your center if you need assistance.',
  noCenters: 'No Centers',
  noChangesToApplyToMember:
    'No changes to apply because the proposed changed values has already been applied to the member.',
  noChangesToApplyToStudent:
    'No changes to apply because the proposed changed values has already been applied to the student.',
  noConversations: 'No conversations',
  noConversationsMatchFilters:
    'No conversations match your current filters or search.',
  noConversationsYet: 'No conversations yet',
  noPendingInfoChanges: 'No pending info changes.',
  noCurrentActivities: 'No Current Activities',
  noCurrentRegistrations: 'No Current Registrations',
  noDirectMessages: 'No direct messages',
  noFamiliesFound: 'No families found',
  noFileAvailable: 'No File available to download',
  noFilesAvailable: 'No Files Available',
  noFilesUploaded: 'No files uploaded',
  noGroupsAssignedFamiliesNote:
    "You don't have any groups assigned to you, so no families will appear here. You can also gain temporary access by supervising students in a space. Contact your administrator to be added to a group.",
  noGroupsFound: 'No groups found',
  noImmunizationRecordsAddedYet: 'No immunization records added yet',
  noImmunizationRecordsProvided: 'No immunization records provided',
  noJournalSelectedForOverride: 'No journal selected for override',
  noMatchingProperties: 'No properties match this search',
  noMatchingReports: 'No Matching Reports',
  noMedicationAttachments: 'No files attached',
  noMemberPIN: 'No PIN',
  noMessages: 'No messages',
  noMessagesYet: 'No messages yet',
  noNotes: 'No notes',
  noNotifications: 'You have no notifications.',
  notifications: 'Notifications',
  noOfChildrenInSpace: 'No. of Children in Space',
  noOfStaffInSpace: 'No. of Staff in Space',
  noOptions: 'No Options',
  noOpenInvoicesOrCreditMemosFound: 'No open invoices or credit memos found.',
  noOutcomes: 'No Outcomes',
  noTitle: 'No title',
  signOut: 'Sign Out',
  noActiveGroupsAssigned:
    "You don't have any active groups assigned. You can also gain temporary access by supervising students in a space. Contact your administrator to be added to a group.",
  noAnnouncementsYet: 'No announcements yet',
  noOverlappingAges:
    'No groups setup that all selected students can register in',
  noPaymentRequired: 'No payment required - Registration complete!',
  noRecentActivity: 'No recent activity',
  noRegistrations: 'No registrations',
  noReportsRequireAcknowledgment:
    'No reports require acknowledgment at this time.',
  noReportsToDownload: 'No reports to download',
  noResults: 'No Results',
  noSchoolPickup: 'No School Pickup',
  noSchoolPickupDates: 'No School Pickup Dates',
  noSignatureUploaded: 'No signature uploaded',
  noSearchResults: 'No messages found',
  noSpaces: 'No spaces are allowed',
  noStudentsAssociatedWithFamily:
    'No students are associated with this family.',
  noStudentsFound: 'No Students Found',
  noStudentsSignedInTitle: 'No Students Signed In',
  noStudentsSignedInMessage:
    "You haven't signed in any students yet. Please tap on each student you want to sign in/out, then click Finish.",
  noSuitableFrequency: 'No suitable frequency',
  noSuitableProgram: 'No suitable program',
  notAcknowledged: 'Not acknowledged',
  notAnAdminPrompt: 'Not an admin or staff member?',
  notAnParentPrompt: 'Not a parent or family member?',
  notApplicable: 'Not applicable',
  notConfigured: 'Not configured',
  notAssignedToGroups: 'You are not assigned to any groups',
  notAuthorizedToExistKiosk:
    'User has insufficient permissions to exit Attendance Kiosk.  Only users with the Center Admin or Org Admin role are allowed to exit.',
  notes: 'Notes',
  notesCharacterLimit: 'Notes must be 500 characters or less',
  notFoundMessage: 'Oops. The page you are looking for does not exist.',
  notFoundTitle: 'Page Not Found',
  notificationRules: {
    none: 'Do not notify',
    atTimeOfEvent: 'At the time of the event',
    fiveMinutesBefore: '5 minutes before',
    fifteenMinutesBefore: '15 minutes before',
    thirtyMinutesBefore: '30 minutes before',
    oneHourBefore: '1 hour before',
    twoHoursBefore: '2 hours before',
    oneDayBefore: '1 day before',
  },
  learnSettings: {
    title: 'Learn Settings',
    description: 'Configure settings for the learning module',
    loading: 'Loading settings...',
    saved: 'Settings saved',
    requireApproval: 'Require Approval',
    requireApprovalDescription:
      'Require administrative approval of content made by room staff prior to it being available to parents',
    lessons: 'Lessons',
    lessonsDescription:
      'Require administrative approval of lessons made by room staff prior to them being available to parents',
    weeklyPlans: 'Weekly Plans',
    weeklyPlansDescription:
      'Require administrative approval of weekly plans made by room staff prior to them being available to parents',
    assessments: 'Assessments',
    assessmentsDescription:
      'Require administrative approval of assessments made by room staff prior to them being available to parents',
  },
  notificationSettings: {
    allCenters: 'All Centers',
    allCentersWillReceivePush: 'All centers will receive push notifications',
    centerFilter: 'Center Filter',
    centerFilterDescription:
      'Configure notification settings for all centers or select a specific center.',
    changesSavedAutomatically: 'Changes saved automatically',
    chooseWhenToBeNotified: 'Choose when and how to be notified',
    chooseWhenToBeNotifiedDescription:
      "Select push and in-app notifications you'd like to receive",
    disabledForAllCenters: 'Disabled for all centers',
    enabledForAllCenters: 'Enabled for all centers',
    enabledForCenters: 'Enabled for: {centers}',
    enabledForCount: 'Enabled for {count} centers',
    inAppNotifications: 'In-App Notifications',
    inAppNotificationsDescription: 'Notifications in the notification panel',
    listenToSound: 'Listen to sound',
    loadingPreferences: 'Loading notification preferences...',
    managePreferences: 'Manage your notification preferences',
    messagingNotifications: 'Messaging Notifications',
    messagingNotificationsDescription:
      'Configure how you receive message notifications',
    mobilePushNotifications: 'Mobile Push Notifications',
    mobilePushNotificationsDescription: 'Push alerts on your mobile devices',
    mobileApp: 'Mobile app',
    notificationTypeDisabledGlobally: 'Notification type disabled globally',
    pushDisabledForAllCenters: 'Push notifications disabled for all centers',
    pushDisabledForCenters: 'Push notifications disabled for: {centers}',
    pushEnabledForCount:
      'Push notifications enabled for {count} of {total} centers',
    pushNotificationsForCenterDescription:
      'Enable or disable push notifications for this center. When enabled, this center will receive push notifications for globally active notification types.',
    pastDueMedicationSound: 'Past due medication sound',
    pastDueMedicationSoundDescription:
      'Play the critical alert sound when an in-app medication alert is received.',
    selectCenter: 'Select Center',
    showCrossCenterToast: 'Cross-Center Message Toasts',
    showCrossCenterToastDescription:
      'Show a toast notification when you receive a message from a different center',
    showMessageBadge: 'Message Badge',
    showMessageBadgeDescription:
      'Show unread count badge on the messaging icon',
    showRegularToast: 'Regular Message Toasts',
    showRegularToastDescription:
      'Show a toast notification when you receive a new message',
    showUrgentToast: 'Urgent Message Toasts',
    showUrgentToastDescription:
      'Show an urgent toast notification for urgent messages. If disabled, urgent messages will follow regular toast settings.',
    testOnly: 'Test Only',
    urgentMessages: 'Urgent Messages',
    urgentMessagesDescription:
      'Configure urgent message toasts and the urgent message sound.',
    urgentMessageSound: 'Urgent Message Sound',
    urgentMessageSoundDescription:
      'Play the urgent message sound when an urgent message is received.',
    website: 'Website',
  },
  notifyThoseWithAccess:
    'Notify those with Calendar Access via In-App Notification',
  notOverridden: 'Not overridden',
  notProvided: 'Not provided',
  notSpecified: 'Not specified',
  noWorriesResetPasswordMessage:
    "No worries, we'll send you reset instructions.",
  number: 'Number',
  numberOfChargbackPayments: '# Chargeback Payments',
  numberOfFailedPayments: '# Failed Payments',
  numberOfPayments: 'Number Of Payments',
  occupation: 'Occupation',
  occupationOptions: 'Occupation Options',
  occurrenceDaily: 'Occurs every {interval} days until:',
  occurrenceDailySingle: 'Occurs every day until:',
  occurrenceMonthlyRanked:
    'Occurs on the {rank} {day} of every {interval} months until:',
  occurrenceMonthlyRankedSingle:
    'Occurs on the {rank} {day} of every month until:',
  occurrenceMonthlySpecific:
    'Occurs on day {day} of every {interval} months until:',
  occurrenceMonthlySpecificSingle: 'Occurs on day {day} of every month until:',
  occurrenceWeekly: 'Occurs every {interval} weeks on {days} until:',
  occurrenceWeeklySingle: 'Occurs every week on {days} until:',
  occurrenceYearlyRanked:
    'Occurs every {interval} years on the {rank} {day} of {month} until:',
  occurrenceYearlyRankedSingle:
    'Occurs every year on the {rank} {day} of {month} until:',
  occurrenceYearlySpecific:
    'Occurs every {interval} years on {month} {day} until:',
  occurrenceYearlySpecificSingle: 'Occurs every year on {month} {day} until:',
  occurrences: '{count} occurrences',
  officeStaff: 'Office Staff',
  onboarding: 'Onboarding',
  onboardingEnrollment: 'Onboarding Enrollment',
  onFileIndicators: 'On file: {items}',
  onFileMoreCount: '{count} more on file',
  onDayOfMonth: 'On day {day}',
  oneTime: 'One Time',
  oneTimePasscodeSentMessage:
    'A one time passcode has been sent to {email} if it exists.',
  onRankedDayOfMonth: 'On the {rank} {day} of {month}',
  onRankedDayOfWeek: 'On the {rank} {day}',
  onSpecificDate: 'On {date}',
  open: 'Open',
  openDate: 'Open Date',
  openDays: 'Open Days',
  openInDialog: 'Open in dialog',
  openTime: 'Open Time',
  onlineRegistration: 'Online Registration',
  onlineRegistrationDescription:
    'Configure the online registration form settings, email templates, and deposit agreements for your center.',
  opportunities: 'Opportunities',
  opportunity: 'Opportunity',
  optional: '(Optional)',
  or: 'or',
  orgAdmin: 'Org Admin',
  orgAlias: 'Org Alias',
  orgAndCenter: 'Org and Center',
  organization: 'Organization',
  orgBasic: 'Basic',
  orgLogoAltText: 'Org logo',
  original: 'Original',
  other: 'Other',
  otherContacts: 'Other Contacts',
  otherTasks: 'Other Tasks',
  outdatedHeader: 'Your version of the app is outdated',
  outsideProgram: 'Services Outside of Program',
  outstand: 'Outstand',
  outstanding: 'Outstanding',
  outstandingBalance: 'Outstanding Balance',
  outstandingInformationDueNow: 'Outstanding Information - Due Now',
  overlappingAgeRangeError:
    'The age range overlaps with an existing range: {lowAge}-{highAge} months.',
  overlappingGradeRangeError:
    'The grade range overlaps with an existing range: {lowGrade} - {highGrade}.',
  overridden: 'Overridden',
  overriddenBy: 'Overridden by',
  override: 'Override',
  overrideAcknowledgment: 'Override Acknowledgment',
  overrideDate: 'Override Date',
  overrideNotes: 'Override Notes',
  overtimeOptions: 'Overtime Options',
  overview: 'Overview',
  overwriteActiveAdjustmentsQuestion:
    'Overwrite all active {name} adjustments applied to a student ledger to the new amount of {amount}?',
  overpaymentAdjustment: 'Overpayment Adjustment',
  overpaymentDifferenceMessage:
    "There's a difference of {diff} between the amount entered and the invoices/credit memos selected. We will create an overpayment on {sponsor}'s account as shown below. To continue, please choose the “plus” sign if you would like to apply this to {sponsor}'s account as a credit for future use now. Otherwise leave it to be handled later (via credit or refund).",
  ownerInfo: 'Owner Info',
  owners: 'Owners',
  pad: 'PAD',
  padExplanation:
    "Enabling PAD allows the center to debit your account when an invoice is due, so you don't have to worry about late payments.",
  padFixed: 'Pad Fixed',
  padlockImageAltText: 'Padlock image',
  padPercentage: 'Pad Percentage',
  parentAcknowledgmentPreview: "Parent's acknowledgment preview",
  parentAgreements: 'Parent Agreements',
  parentAmount: 'Parent Amount',
  parentCap: 'Parent Cap',
  parentOrFamilyMember: 'Parent / Family',
  parents: 'Parents',
  passCodeGenerated: 'One time passcode generated, please check your email',
  password: 'Password',
  passwordDoesNotMatchErrorMessage: 'Password does not match',
  passwordErrors: {
    empty: 'Password cannot be empty.',
    length: 'Password must be between 8 and 32 characters long.',
    invalidCharacters: 'Password contains invalid characters.',
    criteria:
      'Password must contain at least three of the following: lowercase letters, uppercase letters, numbers, and symbols.',
  },
  passwordRequirements: {
    characters: 'Allowed characters:',
    criteriaTitle:
      'Password must be between 8 and 32 characters long and must contain at least three of the following:',
    lowercase: 'Lowercase letters (a-z)',
    uppercase: 'Uppercase letters (A-Z)',
    numbers: 'Numbers (0-9)',
    symbols: 'Symbols ({symbols})',
  },
  pastRegistrations: 'Past Registrations',
  payDeposit: 'Pay Deposit',
  payment: 'Payment',
  paymentAmount: 'Payment Amount',
  paymentDue: 'Payment Due',
  paymentFailed: 'Payment Failed',
  paymentFailedMessage:
    'Payment failed to process. Please contact administrator.',
  paymentInfo: 'Payment Info',
  paymentMethod: 'Method',
  paymentMethods: 'Payment Methods',
  paymentNumber: 'Payment Number',
  paymentOrRefundInfo: 'Payment or Credit/Refund Info',
  paymentOrRefundMethod: 'Payment or Refund/Credit Method',
  paymentOrRefundStatus: 'Payment or Refund/Credit Status',
  paymentProcessDate: 'Payment Process Date',
  paymentRef: 'Payment Id or Linked Payment Id',
  paymentRefundDate: 'Based on Payment/Refund Date',
  payoutAndMerchantFeeSettings: 'Payout and Merchant Fee Settings',
  payments: 'Payments',
  paymentsAndRefunds: 'Payments & Refunds/Credits',
  paymentSettleDate: 'Payment Settle Date',
  paymentStatus: 'Payment Status',
  payNow: 'Pay Now',
  payrollAndTax: 'Payroll & Tax',
  payrollPreferences: 'Payroll Preferences',
  pdfDocument: 'PDF Document',
  pin: 'Pin',
  pinAnnouncement: 'Pin Announcement',
  pinned: 'Pinned',
  pinNotification: 'Pin notification',
  unpin: 'Unpin',
  pending: 'Pending',
  pendingRegistrations: 'Pending Registrations',
  pendingToRegistered: 'Pending to Registered',
  pendingToRegisteredDesc:
    'Email sent when a child status changes from Pending to Registered',
  registrationEmailTemplateKey: 'Template key',
  registrationEmailRawHtml: 'Template editor (raw HTML)',
  registrationEmailFromEmail: 'From email',
  registrationEmailHtmlBody: 'HTML body',
  registrationEmailPreviewTitle: 'Rendered preview',
  registrationEmailNoPreview: 'No preview available',
  registrationEmailTemplateSaved: 'Registration email template updated',
  loadingTemplate: 'Loading template...',
  reloadPreview: 'Reload preview',
  per: 'Per',
  registered: 'Registered',
  registrationOptions: 'Registration Options',
  selectChildrenToRegister: 'Select Children to Register',
  clickToEditTourTime: 'Click to edit tour date/time',
  editTourDateTime: 'Edit Tour Date/Time',
  tourDateTime: 'Tour Date/Time',
  waitlistAutomaticallyPending:
    'Waitlisted registrations are automatically set to Pending status',
  percentage: 'Percentage(%)',
  percentageExplanation:
    '* The percentage-based supplemental fees shown in this report are calculated as a percentage of each child’s regular childcare fees, which vary based on age and registered hours. As a result, these fees differ for each child, and there is no single fixed amount for all families. However, we maintain detailed records of the exact charge for each child, which are available upon request.',
  periodEndDate: 'Period End Date',
  periodStartDate: 'Period Start Date',
  permittedAgeGroups:
    'Permit Age Groups (Ages allowed to physically be in this space — including for combining at days end etc.)',
  permittedAgesForEnrollment: 'Permitted Ages for Enrollment',
  permittedAgesForGroupEnrollment: 'Permitted Ages for Group Enrollment',
  permittedUses: 'Permitted Uses',
  persistentNotificationNote:
    "Action required - won't clear until completed",
  personal: 'Personal',
  personalAddress: 'Personal Address',
  personalBalance: 'Personal Bal.',
  personalContactInfo: 'Personal Contact Info',
  personalSponsors: 'Personal Sponsors ({count})',
  personWhoGaveMedication: 'Person Who Gave Medication',
  phone: 'Phone',
  phoneNumber: 'Phone Number',
  photoRemoveSuccess: 'Photo removed successfully',
  physical: 'Physical',
  pickupAuthorization: 'Pickup Authorization',
  pickupDropoff: 'Pickup/Drop Off',
  pickupNotes: 'Pickup Notes',
  pipelineName: 'Pipeline Name',
  platformPayoutAmount: 'Platform Payout Amount',
  pleaseFixTheFollowingErrors: 'Please fix the following errors:',
  pleaseRequestNewPasswordResetLink: 'Please request a new password reset link',
  pod: 'Pod',
  podMessagesGroup: {
    inUseError: 'Cannot delete transportation group(s) in use',
  },
  pods: 'Pods',
  portal: 'Portal',
  portalForm: 'Portal Form',
  portalMember: 'Portal Member',
  portalRestrictedAccess: 'Restricted Portal Access',
  portalUsername: 'Portal Username',
  portalUsernameTooltip:
    'Portal username is linked to personal email, modify the personal email to change the portal username',
  position: 'Position',
  possibleAgeGroups: 'Possible Age Groups',
  postalCode: 'Postal Code',
  preAuthorizedCCPaymentExplanation:
    "Enabling Preauthorized Credit Card Payments allows the center to charge your card when an invoice is due, so you don't have to worry about late payments.",
  preAuthorizedDebit: 'Pre Authorized Debit',
  preBuilt: 'Pre-Built',
  preBuiltForms: 'Pre-Built Forms',
  preferredName: 'Preferred Name',
  preferredStartDate: 'Preferred Start Date',
  present: 'Present',
  presentCount: '{count} present',
  preferredStartDateCannotBeEarlierErrorMessage:
    'Preferred start date cannot be earlier than date of birth',
  preRegistrations: 'Pre-Registrations',
  prev: 'Prev',
  previewBilling: 'Preview Billing',
  previousArrow: '< Prev',
  price: 'Price',
  priceInDollars: 'Price ($)',
  primaryMember: 'Primary Member',
  primaryMemberMustBeLegalGuardian: 'Primary member must be a Legal Guardian',
  primaryTask: 'Primary Task',
  privateNotes: 'Notes (Private)',
  process: 'Process',
  processDate: 'Process Date',
  processed: 'Processed',
  processId: 'Process Id',
  processing: 'Processing',
  confirmPadPayment: 'Confirm PAD Payment',
  emptyScheduleChargesAsSoonAsPossible:
    'Leave this empty to charge as soon as possible.',
  invoiceTotal: 'Invoice Total',
  noMerchantFeeWillBeAdded: 'No merchant fee will be added.',
  paymentTotal: 'Payment Total',
  cancelPadPayment: 'Cancel PAD payment',
  cancelPayment: 'Cancel payment',
  keepPayment: 'Keep payment',
  refundPayment: 'Refund payment',
  refundPaymentDescription:
    'Issue a refund against this payment. The refund is booked to the line item you select.',
  selectLineItem: 'Select line item',
  lineItemRequiredForRefund: 'Please select an item for the refund',
  refundAmountGreaterThanZero: 'Refund amount must be greater than 0',
  resetToPaymentAmount: 'Reset to payment amount',
  invalidDate: 'Please enter a valid date',
  processDateCannotBeInTheFuture: 'Process date cannot be in the future',
  checkingPaymentSubmittedToBank:
    'Checking whether this payment has already been submitted to the bank',
  padPaymentCanBeCancelled:
    'This payment has not been submitted to the bank yet. Cancelling it will delete the payment and cancel the scheduled transaction.',
  padPaymentAlreadyInitiated:
    'We can no longer cancel this payment because it has already been initiated with the bank.',
  padPaymentCannotBeCancelled:
    'We can no longer cancel this payment because it {reason}.',
  padPaymentStatusCheckFailed:
    'We could not check whether this payment has been submitted to the bank. Please try again.',
  profile: 'Profile',
  program: 'Program',
  programAsOfDate: 'Program As Of Date',
  programAvailableCloseDate: 'Program Available Close Date',
  programAvailableOpenDate: 'Program Available Start Date',
  programLearningTheme: 'Program Learning Theme',
  programOperatingDays: 'Program Operating Days',
  programOperatingDaysHint:
    '(Days this program is available for care; part-time families choose specific days based on availability)',
  programPlanCategory: 'Program Plan Category',
  programPlans: 'Program Plans',
  programRollover: 'Program Rollover',
  programs: 'Programs',
  programSchedule: 'Program Schedule',
  prospectInformation: 'Prospect Information',
  prospectRemovalReason: 'Removal Reason',
  prospectRemovalNotes: 'Removal Notes',
  prospectRemovedAt: 'Removed At',
  prospectToPending: 'Prospect to Pending',
  prospectToPendingDesc:
    'Email sent when a child is moved from Prospect to Pending',
  prospectToWaitlist: 'Prospect to Waitlist',
  prospectToWaitlistDesc:
    'Email sent when a child is moved from Prospect to the Waitlist',
  programStepInstruction:
    'Select the start date and program you want for each child. A child can be registered for multiple programs at once.',
  progress: 'Progress',
  progressGroupDescription:
    'View detailed progress reports for groups across all learning areas',
  progressGroupTitle: 'Group Progress Report',
  progressReport: 'Progress Report',
  progressReports: 'Progress Reports',
  progressStudentDescription:
    'View detailed progress reports for individual students',
  progressStudentTitle: 'Student Progress Report',
  prohibitedFood: 'Prohibited Meal Types',
  province: 'Province',
  public: 'Public',
  aiSearch: 'AI Search (ChatGPT, Perplexity, Gemini)',
  childDateOfBirth: "Child's Date of Birth",
  childName: 'Child Name',
  chooseProspectType: 'Choose prospect type',
  createInquiry: 'Create Inquiry',
  createInquirySubmission: 'Create inquiry submission',
  createInquirySubmissionDescription:
    'Add a staff-entered inquiry for a family who reached out outside the public form.',
  createTour: 'Create Tour',
  createTourSubmission: 'Create tour submission',
  createTourSubmissionDescription:
    'Add a staff-entered tour lead or request for the current center.',
  desiredStartDate: 'Desired Start Date',
  driveBySignage: 'Drive-by/Signage',
  existingFamily: 'Existing Family',
  googleSearchEngine: 'Google/Search Engine',
  inquiries: 'Inquiries',
  inquiry: 'Inquiry',
  inquiryCreatedMessage: 'Inquiry created',
  tours: 'Tours',
  interestForm: 'Interest Form',
  interestFormAtLeastOneChildError:
    'Please add at least one child before submitting.',
  interestFormChildrenDescription:
    'Add each child you are inquiring about. You can include more than one child in a single submission.',
  interestFormDescription:
    'Tell us about your family and the children you are looking to enroll. We will follow up with the next steps.',
  interestFormFamilyNeeds:
    'Tell us more about your family’s needs (e.g., specific program, schedule requirements, or questions)',
  interestFormSubmittedMessage: 'Interest form submitted',
  interestFormThankYouMessage:
    'Thank you for your interest in our center. We are reviewing your details and will be in touch as soon as possible.',
  interestFormThankYouTitle: 'We Received Your Message!',
  newFamily: 'New Family',
  newSiblings: 'New Siblings',
  parentGuardianName: 'Parent/Guardian Name',
  pleaseSpecifyReferralSource: 'Please specify referral source',
  referralSource: 'How did you hear about us?',
  removeProspect: 'Remove Prospect',
  removeProspectDescription:
    'Please provide a reason for removing this prospect.',
  archiveProspect: 'Archive Prospect',
  archiveProspectDescription:
    'Please provide a reason for archiving this prospect.',
  removedAt: 'Removed At',
  cancelTour: 'Cancel Tour',
  cancelTourDescription: 'Please provide a reason for cancelling this tour.',
  reasonForRemoval: 'Reason for Removal',
  removalReasons: {
    foundOtherCare: 'Found Other Care',
    pricingFinancial: 'Pricing/Financial',
    waitlistTooLong: 'Waitlist Too Long',
    locationCommute: 'Location/Commute',
    scheduleMismatch: 'Schedule Mismatch',
    noLongerNeedsCare: 'No Longer Needs Care',
    nonResponsive: 'Non-Responsive (Ghosted)',
    notGoodFit: 'Not a Good Fit',
    other: 'Other',
  },
  searchByNameOrEmail: 'Search by name or email',
  selectAFamilyToContinue: 'Select a family to continue',
  selectChild: 'Select Child',
  specifyReason: 'Specify Reason',
  additionalNotes: 'Additional Notes',
  selectProspectTypeDescription:
    'Choose whether you want to manually add an inquiry or a tour submission.',
  socialMediaReferralSource: 'Social Media (Facebook/Instagram)',
  submitAnotherResponse: 'Submit another response',
  submitInterestForm: 'Submit interest form',
  submitTourForm: 'Book Tour',
  tourDateAndTime: 'Requested tour date and time',
  tourDateTimeRequiredError: 'Please select a tour date and time.',
  tourTimeZoneUnavailableError:
    "We couldn't confirm the center's time zone for this slot. Please reselect a tour time and try again.",
  tourDate: 'Requested tour date',
  tourForm: 'Tour Form',
  tourFormChildrenDescription:
    'Add each child you would like to tour for. You can include more than one child in a single submission.',
  tourCreatedMessage: 'Tour created',
  tourFormSubmittedMessage: 'Tour form submitted',
  tourFormThankYouMessage:
    'Thank you for your interest in touring. Our team will review your request and follow up soon.',
  typeToSearchFamilies: 'Type at least 2 characters to search',
  whosTouring: "Who's touring?",
  tourFormThankYouTitle: 'Thanks for requesting a tour',
  tourBookingConfirmationTitle: 'Tour Booking Confirmation',
  tourBookingConfirmationIntro: 'Your tour is confirmed! Here are the details:',
  tourBookingConfirmationTimezoneNote:
    "All times shown are in the center's local time zone.",
  tourBookingConfirmationArrivalNote:
    'Please arrive a few minutes early. We look forward to meeting you and your family!',
  tourTime: 'Requested tour time',
  tourTimeMustBeInFuture:
    'Requested tour time must be later than the current time.',
  pickADate: 'Pick a date',
  pickATime: 'Pick a time',
  full: 'Full',
  tourSelectDate: 'Select a date to see available times.',
  tourNoSlotsAvailable: 'No tour times are available on this date.',
  tourTimesInZone: '{zone} time',
  tourTimesInZoneTooltip: "Times shown are the center's local time, not yours.",
  tourSlotNoLongerAvailable:
    'That tour time was just taken. Please choose another.',
  tourSettings: 'Tour Settings',
  tourAvailability: 'Availability',
  tourAvailabilityEnabled: 'Enable tour booking',
  tourTimeZone: 'Time zone',
  tourSlotDuration: 'Slot duration (minutes)',
  tourBufferMinutes: 'Buffer between slots (minutes)',
  tourCapacityPerSlot: 'Capacity per slot',
  tourBookingWindowDays: 'Booking window (days)',
  tourMinNoticeHours: 'Minimum notice (hours)',
  tourWeeklyAvailability: 'Weekly availability',
  tourAddWindow: 'Add window',
  tourDateLimitReached: 'Maximum {count} dates per section.',
  tourBlackoutDates: 'Blackout dates',
  tourAddBlackoutDate: 'Add blackout date',
  tourBlackoutReason: 'Reason (optional)',
  tourImportHolidays: 'Import from holidays',
  tourImportHolidaysConfirm: 'Import holidays',
  tourImportHolidaysFailed: 'Could not load holidays for the selected region.',
  tourImportHolidaysAdded: 'Added {count} holiday(s) as blackout dates.',
  tourImportHolidaysNoneAdded: 'No new holidays to add - they may already be imported.',
  tourRecursAnnually: 'Recurs annually',
  tourRecursAnnuallyTooltip: 'Blocks this same month and day every year. Not recommended for floating holidays (e.g. Thanksgiving, Labour Day) since their date changes each year - re-import holidays instead to keep those accurate.',
  tourBlackoutDateRequired:
    'Enter a start and end date for each blackout date entry, or remove the empty one, before saving.',
  tourSpecificDates: 'Specific dates',
  tourAddSpecificDate: 'Add specific date',
  tourSpecificDateCapacity: 'Capacity (optional)',
  tourSpecificDateRequired:
    'Enter a date for each specific date entry, or remove the empty one, before saving.',
  tourWeeklyAvailabilityTimeOrder:
    'End time must be after start time for {day}.',
  tourWeeklyAvailabilityOverlap:
    'Weekly availability windows for {day} overlap - adjust the times before saving.',
  tourSpecificDateTimeOrder: 'End time must be after start time for {date}.',
  tourSpecificDateBlackedOut:
    '{date} is also a blackout date - the specific date hours will override the blackout on that day.',
  tourRolePermissions: 'Role permissions',
  tourPermissionNone: 'None',
  tourPermissionView: 'View',
  tourPermissionEdit: 'Edit',
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  missingCenterContextMessage:
    'Select an organization and center before creating a prospect entry.',
  unspecified: 'Unspecified',
  wordOfMouthReferral: 'Word of Mouth/Referral',
  formData: 'Form Data',
  applicationData: 'Application Data',
  interestData: 'Interest Data',
  tourData: 'Tour Data',
  publicRegistration: 'Public Registration',
  publicRegistrationV2: 'Public Registration (V2)',
  publicRegistrations: 'Public Registrations',
  publicRegistrationSessionExpiredMessage:
    'Your session has expired. Please resubmit your registration.',
  publicRegistrationSuccessMessage:
    '{firstName} {lastName} has been placed into the {programName} program with the following status: {status}',
  purpose: 'Purpose',
  qtyPerChild: 'Qty per Child',
  qualifyingAgeGroups: 'Qualifying Age Groups',
  quantity: 'Quantity',
  quotesAndColonsNotAllowed: 'Quotes and colons are not allowed',
  quickBooksAutoCredit: 'Required: Disable Auto Apply Credits',
  quickBooksAutoCreditMessage:
    "QuickBooks' default behavior to reconcile credit memos against the next invoice is incompatible with the ChildFriendly system. To sync, please sign into your QuickBooks Online account and go to",
  quickBooksAutoCreditMessage2:
    'and toggle off Automatically apply credits, then refresh this page.',
  quickBooksClosed: 'QuickBooks Close Date',
  quickBooksConfig: 'QuickBooks Config',
  quickBooksInitiated:
    'Quickbooks sync has been intiated, and may take some time. You can safely navigate away from this page.',
  quickHelp: {
    orgSetup: {
      successRedirectUrl:
        'Specify a custom URL to redirect users to instead of displaying the standard success page. This is especially useful for tracking conversions with third-party marketing or analytics tools.',
      orgAlias:
        'Shortened name for your organization, will be used in the URL for parents to access their portal. Please contact support to request changes.',
      centerAlias:
        'Shortened name for your center, will be used in the URL for parents to access their portal and in syncing to accounting software. Please contact support to request changes.',
      businessName:
        'The legal name of your business. Will only be shown on legal documents such as tax receipts. Please contact support for changes after initial center creation.',
      businessNumber:
        'The unique number assigned to your organization by the government (assigned by the CRA in Canada and IRS in USA), used for tax purposes and other official interactions, such as filing taxes, managing payroll, or handling accounts. In ChildFriendly, this number will only be shown on legal documents such as tax receipts. Please contact support for changes after initial center creation.',
      setupMode:
        'As families are given access to the parent portal, a welcome email will automatically be sent to them. By enabling setup mode, ChildFriendly will temporarily pause sending these emails. This allows you to complete setup of your center before allowing parents in. When this mode is disabled, all paused welcome emails for families with parent portal access will be sent.',
      feePayments:
        'Your local jurisdiction may allow you to pass the merchant surcharge fee for processing debit or credit card transactions onto the purchaser. These toggles allow you to set the surcharge percentage for pass through to the parents. The surcharge will be added onto the invoice as a Merchant Fee line item when payments are created for Credit Cards or PAD payments.',
      allowCreditCards:
        'Your center may choose whether or not to accept Credit Cards as a method of payment for your families. If Credit Card payments are not enabled, ChildFriendly will not offer this option. The only exception is that families will still be able to pay their registration deposit via the online registration form using a credit card.',
      companyBankAccount:
        'The company bank account must be provided for the center so that ChildFriendly to act as a payment merchant on your behalf. Payments settled for pre-authorized debit (PAD) and Credit Card payments will be deposited to this bank account provided. Please contact support if you need to change your bank account information so we can ensure a smooth transition.',
      locations:
        'Locations that your organization will transport children to and from, primarily schools for before and after school care programs. These will be used later in setup to set transport groups for children to be put in.',
      sponsors:
        "Financial sponsors who are not a part of any family, but are a third party that will be paying fees on behalf of a child. These sponsors can be assigned to billings for families and invoiced automatically for an allocated percentage or amount of the child's monthly tuition. Ex: Government Subsidy Programs.",
      thirdPartySponsors:
        'Third party sponsors are external financial sponsors who pay fees on behalf of children. You can specify which centers each sponsor applies to, limiting their availability to only those centers. These sponsors can be assigned to family billings and invoiced automatically. Ex: Government Subsidy Programs.',
      adjustments:
        "Setup any discounts/fees that may be routinely applied to a student's tuition. These adjustments can be set up as either a fixed amount or percentage of the billing amount. Any sponsor in the family can be assigned an adjustment, and it will automatically be applied to their monthly invoice as a line item to reduce/increase the invoice total. Ex: Employee Discount. For one-off discounts, a catalog item is recommended instead, as discounts are primarily intended to work with auto billing for repeating processes.",
      tasks:
        'Create tasks for staff to allocate their labor hours. Staff will select the task they are performing each time they move into a space in the Attendance module. For payroll or government reporting, staff hours will be viewable by tasks. This also allows you to easily apply different pay rates based on the task being performed.',
      catalog:
        'Catalog items represent specific charges that can be added to an invoice. The system automatically applies default items during billing creation. You can create additional items, such as one-time event fees or late payment charges, to be included on invoices as needed, allowing for accurate revenue tracking.',
      users:
        'Add admin users of the platform here, enabling staff members with accounts to log into Child Friendly and access the information they have permissions for. Please note that only admin users can be added here. Regular room staff access is managed through the Staff module, while parent access to the Parent Portal is handled separately in the Families module.',
      adminStaff:
        'Administrative staff have a high level of access to the platform. They are generally able to view, edit, and manage most of the information on the platform. All administration accounts are created and managed on this page. See "Role" for the details on what each specific role can access. ',
      roomStaff:
        "Room staff have limited access to the platform, restricted to only the information necessary for their duties as early childhood educators. They can access the Attendance module, Journals, the Dashboard's RSVP, Regular Meds, and Meals tabs, as well as view-only access to essential child profile details such as allergies, medications, and contacts. The read-only table below provides an overview of who has active Room Staff access to the platform. However, to edit or create these accounts, you must do so under individual staff profiles in the Staff module.",
      role: "Roles define an administrative staff member's permission level to view and manage information within the platform. There are three types of roles available to admin staff, each with increasing levels of access:",
      roles: {
        orgAdmin:
          'Org Admins have full access to view and edit all information across all centers, including the Setup module. This role is ideal for owners and corporate executives. ',
        centerAdmin:
          'Center Admins have similar access to Org Admins but are limited to the centers they are assigned to and do not have access to the Setup module. This role is recommended for upper management staff and finance managers overseeing one or more locations.',
        officeStaff:
          "Office Staff have restricted access, excluding sensitive information such as financial reports and parents' financial details. They can only access the centers they are assigned to and have no access to the Setup module. This role is suitable for general administrative staff within a center.",
      },
      isOvernight:
        'Enabling overnight mode will disable auto signout for attendances at 11PM local time.',
      enableAttendanceKiosk:
        'Enables setting up an attendance kiosk to allow family members to easily pick up/drop off students in their family via PIN code.',
      enableReportAcknowledgment:
        'Enables report acknowledgment functionality to require acknowledgment of incident and illness reports by a family member.',
      allowParentToRoomStaffMessaging:
        'Enables the ability for room staff to view and respond to messages from parents.',
      hideParentAttendanceDetails:
        'Simplifies attendance logs in the parent portal to show only sign in and sign out times with the drop-off or pick-up member.',
      allowRoomStaffEditHours:
        'Allows room staff to edit their own attendance hours.',
      updatePastAdjustments:
        'Will bulk update the amount of any existing adjustments in the family ledger to the new amounts. Only families exisiting adjustments which are not expired and not custom will be updated.',
      mealsService:
        'Toggle this on if this type is for a meals service you offer. If toggled on, you will be able to filter for this type in the Dashboard -> Meals tab',
      outsideProgram:
        'Toggle this on if you offer a supplemental service that falls outside the scope of your licensed childcare program and should not be included in the Supplemental Fees Report.',
      frequency:
        'Typical frequency this item is applied at to be used for reporting to the government. Is a required property when the adjustment is a fee',
    },
    centerSetup: {
      averagingPeriod:
        "Overtime is averaged over the full period inputted rather than weekly. For example, if '4' is entered, overtime is based on total hours exceeded over a 4 week time span rather than on a weekly basis. If no number is inputted, it will default to a weekly calculation.",
      holidayHours:
        'Enable holidays and holiday hour tracking for staff. When enabled, you can set which days are holidays and configure how holiday hours are calculated based on regional labor standards or custom rules.',
      ageGroupDictionary:
        'Setup the age ranges you want to group students into. Generally, this should follow the regulatory guidelines in your region, as age groups are automatically assessed against the staff-to-child ratio when monitoring attendance. For example, if your Licensing regulations define Toddlers as ages 19 months to 23 months then you would set up that age group here.',
      teamRatioRules:
        'Team ratios are setup for each age group to meet government and licensing requirements for the children in the center. Staff-to-child ratios and max team (group) size will be checked every time students are moved around the attendance module, and warnings will display automatically when any of the limits are exceeded.',
      customization:
        'Customizations allow you to setup messaging and custom fields specific to the needs of your center. These include email templates for online registration, immunization requirements for student records, health symptoms to identify and record, and prohibited foods for meals being served.',
      agreementsAndPolicies:
        "Add any agreements you want the parents to sign. All agreements listed in this tab will be shown to the parents when they log into the parent portal. If the agreement type is mandatory, it will be shown with an asterisk in the portal and must be agreed to by the parent prior to being granted access to the rest of the portal features. ChildFriendly will track everyone who signed the agreements in the student's file folder, and allow you to filter for families who have not signed them through the agreements tag on the families module or on the onboarding dashboard.",
      importData:
        'This tab allows you to import family member, student, and staff data you have from your existing system into ChildFriendly. Start by importing the members using the family template which can be downloaded on the top right. Include the same family email for all members that you wish to be grouped into one family. Then import the students using the student template, using the same family email and they will be added into the existing family. Finally staff information can be imported using the staff template. Contact support during business hours if you would like to be assisted through this process.',
      ageRangeType:
        "Select if the age group should be based on the student's age or grade. Grade based age groups apply to students in out of school care, where registration will require a child's school and grade. Age based groups apply to students pre-kindergarten or younger, where registration will only require a child's birth date. ",
      sendTestEmail:
        'Enter an email address for internal testing and receive a sample email matching what will be sent to parents when they register for a program. This allows you to preview how your customizations will appear to the parents in email format.',
      viewPreview:
        'View a preview of the email that will be sent when parents register for a program. This allows you to preview how your customizations will appear.',
      webFormDepositAgreement:
        'When parents register for a program through the public registration form or parent portal, you may require them to pay a deposit, as setup in the Programs tab. The text provided in this section will be shown to the parents as they are making this payment as terms and conditions.',
      prohibitedFood:
        "As part of a child's profile, parents can specify which 'meal types' from your menu their child should not be given, allowing you to offer an alternative when applicable. This feature is distinct from allergy management, as it focuses on entire meal types rather than specific ingredients. For example, if you offer a vegetarian option for children who cannot eat pork, \"Pork\" would be included as a 'Prohibited Meal Type.' This helps you determine how many vegetarian dishes versus pork dishes are needed on a given day. You can define the prohibited meal types parents can select from, creating a dropdown menu for them to choose from when submitting this information. This data will then be accessible in the Dashboard, aiding in menu planning, grocery shopping, and ensuring the correct meal types are provided to the appropriate groups of children.",
      immunization:
        'Configure the vaccines and dose ages your center requires. Families are prompted in onboarding when a configured dose is overdue. Each recorded dose requires an attached dose file, and each exemption requires an attached exemption file.',
      healthSymptoms:
        'To standardize the reporting of health incidents, list all the symptoms you want to be able to create a journal record of. When staff draft a health journal, they will be able to select one or more of the applicable symptoms. There will be additional text fields where staff can enter more information.',
      staffPositions:
        'Define the positions available for staff members at your center. These positions will appear as dropdown options when creating or editing a staff profile, allowing you to categorize staff by their role (e.g., Early Childhood Educator, Room Supervisor, Cook). Staff positions are also used for payroll and reporting purposes.',
      staffTracking:
        'Define additional expiry dates to track on staff profiles, such as certifications or permits. Each item appears on every staff profile, and its date is included in expiry alerts, reminders, and reporting.',
      uploadTaxSignature:
        'Members are able to download a tax receipt for their yearly tuition payments in the parent portal. The electronic signature uploaded here will sign the bottom of the tax receipt provided. This signature should be provided by the owner or an authorized representative.',
      rotessa:
        "Rotessa will be used to process pre-authorized debit (PAD) payments. Submit the required business information below so we can create a client to process your transactions on ChildFriendly's platform. After submission, you will be requested to provide identification. A few days for processing will occur to verify ownership and compliance. Once approval has been provided, you will be able to begin charging parents in ChildFriendly. If you need to update any information after the initial submission, or have questions about the setup process, please reach out to support.",
      stripe:
        'Stripe will be used to process credit card payments for deposits or tuition. Use the links below to go to Stripe and create or update your Stripe connected account. After a connected account is created, you can begin charging credit cards through the platform. Please reach out to support if you require any assistance.',
    },
    spaceSetup: {
      tab: 'Spaces are physical rooms or spaces in the center which will be used for tracking attendance. Any spaces defined here will be able to have students or staff moved into them in the attendance module. Additionally, transport spaces such as buses for out of school care or field trips should be set up to fully encompass attendance tracking. For example, you may want to create a space called "Field Trip" so that when children are transported to a field trip, they will show up in the \'Field Trip\' space, where you can easily see who is on the field trip at a glance. ',
      color:
        'Color code to assist with organizing your spaces as desired. The chosen color will be shown beside the space in the attendance list and as a colored dot on the attendance map.',
      type: 'The type of activity typically performed in the space. If Walking or Bus are selected as a type, the space will be set up as a transport space.',
      abbreviation:
        'A shortened name for the space which will be used on the attendance map. By abbreviating the name, it will keep your attendance map clear. ',
      task: 'The typical task a staff member will perform in the space. When a staff member signs into the space it will default them to this task, however they can override the selection as part of the sign in process. For example, a homeroom may have a task called "Childcare" as the default assigned task, whereas the Office may have \'Admin\' as the default task. ',
      permittedUses:
        'A permitted use defines what age groups, license and how many children are permitted by the center or their licensing regulations in the space at a given time. You can have multiple permitted uses. If any students in the space do not fit into one of the permitted uses, the attendance module will indicate red a warning on the space. You should list all permitted uses a space is licensed for. ',
      licenseType: 'PLEASE REMOVE THIS "?"…it is redundant. ',
      maxCapacity: 'PLEASE REMOVE THIS "?"…it is redundant. ',
      permittedAgeGroups:
        'Ages allowed to physically be in this space — including for combining at days end, etc.',
    },
    reports: {
      payroll:
        'The average hours the employee worked based on the holiday pay calculation strategy selected in Setup > Center > Customizations under Payroll Preferences. These hours are not included in Total Hours Worked.',
    },
    groupSetup: {
      tab: 'Groups are used to organize children into classes or cohorts. They are used to determine the licensed capacity and available spaces within the center. Students can only be registered into groups if they fall within the defined age ranges specified in this section. For example, if you occasionally include Toddlers in a Preschool group, be sure to include the Toddler age range in that group; otherwise, you will not be allowed to place Toddlers in it. ',
      licenseType:
        'The type of license to apply to this group. Only student which are suitable for the license can be enrolled in the group. ',
      homeSpace:
        'The home room space the students will spend time in. This field is for your tracking purposes only, there are no restrictions where students can move based on this field.',
      maxCapacity:
        'The maximum number of students allowed to enroll in the group. This limit will drive the SMART registration system that identifies the number of current registrations against the  licensed space capacity of your center at any given point in time. When a group has the maximum number of students as of an applicable date, ChildFriendly will automatically waitlist all new registrations against the group that is full. Admins are able to override the setting and put additional children into the group if desired, but parents cannot via the online registration. If this group is listed on multiple programs, the single capacity will be shared by all programs.',
      napping:
        'A toggle to indicate if the group is set up for nap time. This allows parents to select the appropriate group during registration based on whether their child to naps or not.',
      ageGroups:
        'The age groups which are allowed to be enrolled into this group. This is used for both the SMART registration system and administrative staff, no one will be allowed to register/enroll a student in a group if they do not match an age group defined here on the start date. Children can temporarily exceed the age group if they age out before their registration ends, as long as they were allowed in the program on the start date.',
      permittedAgesForEnrollment:
        'Defines the ages of children allowed to be registered into this group.',
    },
    rateSetup: {
      tab: 'Rates are applied to registrations and determine how much a child will be automatically charged on their automatic tuition billing.',
      ageGroups:
        'The age groups this rate is meant to apply to. Parents registering through the public web form will be restricted to rates that match the age group of the child. The SMART registration system will use these age groups to recommend rates as part of the auto-generated registration proposals.',
      billing:
        'The amount the student will automatically be billed for registrations using this rate. Currently, we only support monthly billings and one off custom billings. Note: Child Friendly is actively working on the design and support for shorter and custom time periods which will be released at a later date.',
      credits:
        'Determine if the rate is for a full time or part time student. When part time is selected, identify the number of part-time days, then each registration this rate is used on will need to select which days of the week the child will be present. These are the only days the student will be considered for when determining capacity in the program.',
      rollOver:
        "Rollover provides two methods to automatically change a student's rate. Method 1: The graduate rate will apply whenever a student ages out of the age groups set on this rate, the month after that happens the student will be billed at the graduate rate (Ie. An Infant that becomes a Toddler will automatically graduate to the Toddler rate). Method 2: The change date allows you to change the rates for all children to a different rate on a specific date. Ex. yearly increases in tuition. On the change date this rate will be archived and registrations which use it will start being billed at the new rate for the next billing.",
      graduateAgeCheck:
        'Controls when a child who ages into a new age group is moved onto the graduate rate, relative to their birthday.',
      ageCheckStartOfMonth:
        "If the child's birthday falls anytime during the month, they are charged the graduate rate for that entire month.",
      ageCheckEndOfMonth:
        "If the child's birthday falls anytime during the month, they are charged the current rate for that month and the graduate rate starting the first of the next month.",
      ageCheckCustom:
        "If the child's birthday falls on or before this day of the month they will be charged the graduate rate this month, otherwise they will be charged the gradutate rate starting next month",
    },
    programSetup: {
      tab: 'Programs are the comprehensive childcare plans which combine rates, groups, and scheduling for student registration. Programs are simply what parents will register into and they drive what options are available for them via the Online Registration form. Programs let our SMART registration system know what proposals to make, when parents can enroll, and how much it costs to register.',
      registrationAges:
        'Specify the age groups eligible to register for the program. The public registration form will only allow students within these age groups to enroll. Administrative staff can register a child in any program, but the recommended programs will be based on these age groups. While you can allow multiple age ranges within a group to offer flexibility in operations, you may choose to restrict age groups more strictly within programs. This ensures that only new registrations from the online form fall within the desired age range. For example, you might have a Preschool group that includes both Preschool and Pre-K children, allowing Preschool children to transition within the group as they age. However, under programs, you may restrict new registrations to only Preschool-aged children, with a separate program for Pre-K.',
      registrationGroups:
        'What groups are able to register in the program. The public registration system will select an applicable group to give the child as a pending registration, based on the program selected. The administrative staff can override the group to any group the child is allowed into, but the recommended groups will be based on what is listed in the program.',
      rates:
        'What rates are allowed for the program. The part time/full time frequencies available to parents in the public registration form will be based on the rates listed for the selected program. The administrative staff can override the rate to any rate, but the recommended rates will be based on what is listed in the program.',
      registrationDeposit:
        'The amount you want parents to pay to reserve a spot in the program. When a parent goes through the online public registration form and there is space available, they will be prompted to pay this amount as a deposit by credit card before their registration is created.',
      waitlistDeposit:
        'The amount you want parents to pay to reserve a spot on the waitlist. When a parent goes through the public registration form and there is no space left, they will be prompted to pay this waitlist deposit amount by credit card. ',
      openDate:
        'The date the program will start being run in the center. When creating a registration at a point in time, if the start date is not between the program open and closed dates then the program will not be included in the list of available programs as recommended by the SMART registration system.',
      openDatePublic:
        'The date this program will be available for the public, generally new families, to register in this program. If a parent goes to the public registration form embedded on your website before this date, then this program will not be shown as an option they can register into. If no date is set, the program will always be available.',
      openDatePortal:
        'The date this program will be available for existing parents that have access to the parent portal to register in this program. You may choose to set this date earlier than the public registration date to give existing parents priority access to the program. On the parent portal, this program will not be shown until the portal open date. If no date is set, the program will always be available for registration on the parent portal.',
      registrationInAdvance:
        'This feature allows you to limit the number of weeks in advance parents are able to register for a program. When a parent goes to register, if the start date they select is more than this many weeks in the future from today (including 0), they will automatically be given a waitlist option instead, even if there is still space in the program. Use this feature to prevent parents from registering children years into the future.',
      rollOver:
        "The program rollover drives the SMART registration system to propose future registrations for students as they age out of their current program. When the system generates registration proposals, it will check on the change date to determine if each student still qualifies for the program and group they are registered in. This date can be specific dates or the same day recurring every year. Typically, it is recommended that you select a date like Sept 1 when students may be rolling over from daycare to out of school care programs. If the child does not qualify for the program they are currently in after the change date, then they will be proposed either the Next Program or Kinder Program indicated as their rollover program. If they do not qualify for this rollover program, it will continue to check this rollover program's following rollover program until it finds an applicable program or runs out of options. This option does not automatically change any children's registrations, it serves to set parameters for the SMART registration program to propose what following options are available in the future for your staff to accept and modify until they are happy with them. Please contact support if you have any additional questions about how the rollover feature works.",
      kinderProgram:
        'This program will be used as the rollover program for when you have a child that will move from an age based program to a grade based program I.e. when children generally begin Kindergarten. Please select the kinder program you want students to be rolled into. This option only needs to be filled out for programs that would typically have children graduating from their age based program (ie. Pre Kinder) into a kindergarten or grade based program. Otherwise, you will always use the Next Program (age to age or gr. to gr.) field to determine the rollover program. ',
    },
    transportSetup: {
      transportSpaces:
        'These are the transport spaces setup in the space tab. They are shown as a read only copy here for reference while setting up transport groups. ',
      transportGroups:
        "A transport group is used to group children who are typically transported together, ex. children that all load onto the same bus each morning, even if from different schools or maybe you transport all your Afternoon Kinders from multiple schools, altogether. The transport group will be set on the student's registration and can be filtered for in the attendance module to easily bulk select students to sign in and out. ",
    },
    schoolSetup: {
      available:
        'Sets if the school should be available to register in. If a school is set to not available, then it will not show up as an option for parents on the public registration form, or for staff when creating/editing registrations. ',
      gradesSchool:
        'All the grades that the school offers. This will be used to determine what options parents/staff can select for grades when creating registrations.',
      gradesGroup:
        'The grades which should be allowed to join this transport group. When staff are selecting what transport group a registration should be assigned, they will only be shown transport groups that the student has a matching grade for. ',
      transportGroup:
        'Which transport group set up in the transport tab will be used to transport children to the school. One transport group can be used to transport to multiple schools, so you are allowed to list the same transport group under as many schools as you wish.',
      schedule:
        'Which days the transport group will be going to the school. If you set up only specific days, then this transport group will only be shown as an option when the registration includes these days. ',
    },
    emailSendTo: {
      child: 'Email will send to the guardians of the selected child(ren).',
      member: 'Email will send to the selected members.',
      staff: 'Email will send to the selected staff.',
      group:
        'Email will send to the guardians of the children within the selected group.',
      program:
        'Email will send to the guardians of the children within the selected program.',
    },
    student: {
      mealRestrictions:
        "Meal types from the center's menu that the student cannot eat due to allergies, religious, or personal restrictions.",
      preferredName:
        'In Attendance, the Preferred Name is used for students signed into a space. If two students share the same first name, you can enter a preferred name here to distinguish between them. Any changes to this field will take effect once the student signs out or is moved.',
    },
    member: {
      primaryMember:
        'The primary member is usually the individual who registered the student. If this needs to be changed, it can only be updated by the center administrator.',
      portalMember:
        'Portal access for additional members can be granted by the center. Once enabled, members will only be able to view basic profile information for other members. They will not have access to any financial or payment details other than their own.',
      portalRestrictedAccess:
        'Restricted portal access allows sign-in and billing actions, but blocks messaging and member or student edits.',
      authorizedSponsor:
        "Enable this option for any member who will be responsible for paying all or part of the child's fees. The center can only accept payments from individuals who have been designated as authorized sponsors.",
    },
    kioskSetup: {
      enableSpaceForDropOff:
        'Enabling this setting on for the space will allow it to appear as a possible drop-off location for the authorized family member in the Attendance Kiosk.  This does not affect pickup.  Note that spaces with no defined permitted uses are not allowed for drop-off.',
    },
    feeCollection: {
      privateMemo:
        "This memo will not be shown to the centers. It is internal for ChildFriendly's use.",
      publicMemo:
        'This memo will not be visible to the centers. Indicate anything you want them to know about.',
    },
    messaging: {
      activeGroups:
        'A group is considered active if it has a staff member currently assigned to it, or a staff member signed into a room that has a student from this group in attendance.',
      includeUnread:
        'When enabled, any family with unread messages will appear in the list, even if they do not match the current filters.',
    },
    dashboard: {
      endingAction:
        "Click the 'Complete' button when you have finalized all withdrawal tasks and checklist items for that child. Note that ending enrollment entries do not leave this screen until an administrator reviews and clicks 'Complete.' Tip: If the 'Complete' button is greyed out, the child doesn't have a withdrawal date, and the system will not let you end an enrollment without such a date.",
      endingRegistrationEnd:
        "The date that a child's registration record is ending. Click the filter icon to select a date range – a handy tool when filtering through multiple entries. Tip: The Ending Enrollment tab will always display ending registrations one month in advance so administrators can plan ahead. Make sure to add a Withdraw date to confirm that the registration ending is not a mistake and that the child has indeed withdrawn. The system will not permit you to remove the child from the Ending Enrollment list until you have entered their withdraw date.",
      endingWithdraw:
        "The date the child withdraws from your center. Tip: Withdrawal dates are a second verification before a child's enrollment ends. Only fill in a withdrawal date once you receive written notice from a parent saying they are withdrawing their child from your daycare on an official date. Note that the Withdraw Date cannot be entered for a date later then the registration record end date, ensuring that no child attends your daycare without an active registration record.",
      expiryAction:
        "Use the 'Action' column to hide or unhide expiry entries. Typically, administrators would 'Hide' an entry once they have viewed the expiry, attended to it, and resolved it. If you mistakenly click 'Hide,' select the 'Show All Records' button to view all expiry records. Tip: We recommend reviewing this tab monthly to ensure no expiries are missed. Use the filters to filter by expiry types and dates.",
      onboardingAction:
        "Choose one of three actions to perform in the Onboarding Enrollment tab: Complete: Click this once all the onboarding checklist items for the child are complete. Note that once you click 'Complete,' entry is removed from the Enrollment tab. You can still find their information in the Families module. Tip: You cannot click 'Complete' without having families finalize their Licensing Info checked off (ie. emergency contacts entered, agreements signed in the portal etc). This fail-safe feature ensures that your center has all the mandatory information required to comply with government regulations. Waitlist: Click this to move a child to the waitlist tab. This action is generally used when an administrator wants to keep a child on a waitlist for a potential future spot in a specific program at that center. Deny: Click this button to deny a child's enrollment. You'll be prompted to select a removal reason, matching the same reason picker used when removing a child from the waitlist, inquiries, or tours. Once confirmed, the child's entry disappears from this tab, but their information is still available under the Families module. There, you'll see their inactive profile containing a 'Removed Prospect' tag. They can still be registered from here via the child registration tab.",
      onboardingBankInfo:
        'A checklist item showing whether a family has added their PAD (Pre-Authorized Debit) or credit card information into their parent portal.',
      onboardingDeposit:
        "This checklist item indicates whether a family has paid the registration deposit for their child. The deposit is linked specifically to the registration record displayed. If the deposit has been paid for the registration in question, it will be marked as completed. However, if an admin deletes the registration record associated with that deposit, the family will disappear from this onboarding tab. If the admin then creates a new registration record for the same child, the family will reappear, but the deposit will show as unchecked, since it's a new registration record. Once the parents pay the deposit for this new registration, it will be marked as completed.",
      onboardingLicensingInfo:
        'A mandatory checklist item tracking when a family has signed and agreed to all the required agreements and policies in their parent portal. Tip: This item must be checked before an administrator can complete an enrollment, as it confirms your center has all the information required to comply with your governmental regulations.',
      onboardingMedicalPractitioner:
        'A mandatory checklist item shown when this center requires an active child to have a medical practitioner selected.',
      onboardingMedicalConditionsAndAllergies:
        'A mandatory checklist item, shown only while a child is a new registration going through onboarding, tracking whether a family has answered the required allergy/medical condition and medication questions and added details for any "Yes" answer. Does not apply retroactively to already-active children.',
      onboardingSource:
        "A column displaying where an enrollment request was sourced from. 'Admin panel' refers to the online registration form embedded on your center's website. This means that a family filled in this form to request an enrollment for their child.",
      prohibitedMealTypes:
        "A meal type differs from an allergy in that it refers to a child's dietary or religious restrictions, requiring an alternate meal (e.g., vegetarian) when certain meals are served. Use the Meals tab to track prohibited meals by group or child. Kitchen staff can utilize this information to plan meal types, meal substitutes, and grocery lists effectively. Tip: Customize Prohibited Meal Types in the Setup module under Center Customizations.",
      staffOvertime:
        "This tab stores all unapproved staff overtime entries for your center. Overtime is calculated based on a staff member's typical start and end times, as well as their usual break duration, as entered in the Staff Module. The system automatically identifies when a staff member works beyond their allotted time, and their overtime entry will appear in this tab accordingly. Administrators can then edit a staff member's end time before approving the overtime. Tip: If a staff member forgets to sign out, they will automatically appear in this tab with a sign-out time set to one hour past the center's closing time.",
      studentSignOut:
        "If a child was accidentally left signed into the center after the closing time, the system automatically adds them to this tab one hour past the center's closing time. So, when the child returns the next day, they already have a signed-out status and are ready to sign back in. Tip: The child will remain in the Student Sign Out tab until an administrator reviews their entry, adjusts their sign-out time, adds an authorized pickup member, and clicks 'Approve.'",
      withdraw:
        "The date entered on a child's registration, on which they will be withdrawing from that program.",
    },
    email: {
      filterStudents:
        "Use date range filters in tandem with the 'Student Status As Of Date Range' filter. This allows you to filter children for specific scenarios. For example, if you want to add all children starting in September 2024, filter using a date range of 1-30 September 2024 and by a 'Current' status because those children are 'Future' today but will be 'Current' in September 2024. Tip: Typically, the 'Current' status is used most often, and 'Future,' 'Past,' or 'Pending' are used for specific scenarios.",
      filterStudentsTitle: 'Filter Students',
    },
    families: {
      infoTagsAllergies:
        'A child with an allergy or specific medical condition, e.g. asthma.',
      infoTagsFlaggedMember:
        'Any child who has a flagged member on their file. For example, one parent has restricted custody and is therefore flagged. Tip: This is a helpful tag when children are picked up to ensure they are always picked up by an authorized member for that day.',
      infoTagsHint:
        'These tags show children who have any unique and notable information on their profile, such as:',
      infoTagsMedication:
        'Any child who has medications logged in their profile. This will include dosage and administration instructions.',
      infoTagsProhibitedMeal:
        'A child who is prohibited from eating one or more of the meals that you serve on your menu.',
      infoTagsSpecialNeeds:
        'A child with a special need, e.g. hearing, learning, physical, or visual disabilities.',
      infoTagsTitle: 'Info Tags',
      infoTagsUnassignedInvoices:
        "Any child who has an outstanding invoice that isn't assigned to a family member or sponsor. Tip: Filter for unassigned invoices before doing monthly billing to ensure all invoices are accounted for.",
      onboardingAgreements:
        'Has the family read and signed all required digital agreements from your center via their parent portal?',
      onboardingAutoPayments:
        'Has the family granted your center automatic payment permission by selecting Auto Pay next to their bank account information?',
      onboardingBankInfo:
        'Has the family entered their banking information into the parent portal yet?',
      onboardingBasicInfo:
        "Have you received the child's basic information, such as their name, date of birth, etc.? This information is included in the online registration form. If any details are missing, the family will receive this tag.",
      onboardingEmergencyContact:
        "Do you have the contact information for at least one of the child's relatives or acquaintances, other than their legal guardian, who can serve as an emergency contact? The required information should align with your Licensing authority's requirements.",
      onboardingHint:
        'When a child is being enrolled, their family is required to complete several checklist items tracked in the Onboarding Enrollment Admin Dashboard. Any outstanding checklist items are tagged here for easy filtering and monitoring.',
      onboardingImmunizationInfo:
        'Has the family completed every overdue vaccination, including overdue doses with only a date or file, by providing both the required date and file or a documented exemption?',
      onboardingLegalGuardian:
        'Do you have the information for at least one legal guardian on file? The required information should meet the standards set by your Licensing authority.',
      onboardingLicensingInfo:
        "Has the family entered the child's required licensing health identifiers, such as MB Health Registration No. and PHIN?",
      onboardingMedicalPractitioner:
        'Does the child have a medical practitioner selected?',
      onboardingTip:
        'If the answer is "no" to any of these questions, an Onboarding tag will appear in the Families module.',
      onboardingTitle: 'Onboarding Tags',
      registrationStatusAsOfDate:
        "This filter will enable you to display the children that WILL have the registration status selected AS OF the date you filter for. For example, if it's January and you want to view what your registrations will look like two months from now, filter a date range of March and by 'Current' status. This will show all children that as of March WILL have a current status in your center, even if as of today's date they may not.",
      registrationStatusAsOfDateTip:
        'You can select more than one status type at a time.',
      statusCurrent:
        'As of this moment, this child is registered and, therefore, has a current registration record at your center.',
      statusFuture:
        "If a child has a registration record but the registration hasn't started yet.",
      statusHint:
        "Primary status tags depict each child's status as of today, in your center. Statuses are used for reporting, billing, attendance, etc.",
      statusInactive:
        "If a child doesn't have any registration record. Tip: This will only typically happen if a child was meant to start at your center and their parents cancelled before they enrolled.",
      statusPast:
        "If a child has a registration record but all their records have passed, and that child doesn't have a current or future record at your center.",
      statusPending:
        "If a child hasn't been given a confirmed registration record by an administrator yet, or any child currently on the waitlist for a registration. Tip: Children that are waitlisted will have both a Pending Status AND a Waitlist tag, shown in the Sub Status Tags column.",
      statusTip:
        "A child could have multiple statuses. For example, even though a child may have a 'Current' status for their registration record, they could also have a 'Pending' status as they're waitlisted for another program.",
      statusTitle: 'Status',
      subStatusEnded:
        "When a child's registration record ends but has no withdrawal date associated with it. Tip: Use the 'To End' and 'Ended' tags to filter any children with an ending registration record that doesn't contain a withdrawal date. It could be a mistake if there is no withdraw date entered, yet the registration record does not continue. Ensure you confirm the date of withdraw and verify by entering a withdraw date accordingly.",
      subStatusHint:
        'Secondary status tags used in conjunction with the primary status tags. Below are their meanings:',
      subStatusRemovedProspect:
        'When an administrator removed a child from onboarding, the waitlist, inquiries, or tours.',
      subStatusTour:
        'When a family has scheduled or completed a tour at the center.',
      subStatusInquiry:
        'When a family has submitted an inquiry form expressing interest in enrollment.',
      subStatusTip:
        'Use the Include and Exclude radio buttons for further filtering.',
      subStatusTitle: 'Sub Status Tags',
      subStatusToEnd:
        "When a child's registration record is about to end, but there is no withdrawal date associated with the record as yet.",
      subStatusToWithdraw:
        "When a child's registration record has a withdrawal date recorded, but it's a future date (it hasn't occurred yet).",
      subStatusWaitlist:
        'When a child is on the waitlist for a specific registration. They will have a Pending Status and Waitlisted Substatus.',
      subStatusWithdrawn:
        "When a child's registration record has a withdrawal date entered, but it's a past date (it has already occurred).",
    },
  },
  range: 'Range',
  rangeType: 'Range Type',
  rate: 'Rate',
  rateAsOfDate: 'Rate As Of Date',
  rates: 'Rates',
  regularTuitionRates: 'Regular Tuition Rates',
  rateType: 'Rate Type',
  ratioNapping: 'Napping Ratio',
  ratioStandard: 'Standard Ratio',
  duplicateRatioAgeLicense:
    'A ratio for this age and license type already exists. Please edit the existing ratio instead.',
  read: 'Read',
  reason: 'Reason',
  reasonForAbsence: 'Reason for Absence',
  reasonForSkipping: 'Reason for Skipping',
  reassignStudents: 'Reassign Students',
  reassignStudentsDescription:
    'The following students only live with this member. Select which remaining member each student should live with.',
  recheck: 'Recheck',
  recheckStatus: 'Recheck Status',
  recipientEmail: 'Recipient Email',
  recipientFamilyName: 'Recipient Family Name',
  recipientFirstName: 'Recipient First Name',
  recipientLastName: 'Recipient Last Name',
  recipientName: 'Recipient Name',
  recipients: 'Recipients',
  reconcile: 'Reconcile',
  reconciliationPreview: 'Reconciliation Preview',
  records: 'Records',
  recovery: 'Recovery',
  recoveryInvoice: 'Recovery Invoice',
  recurring: 'Recurring',
  recurringWeekly: 'Recurring Weekly',
  redo: 'Redo',
  refNumber: 'Ref Number',
  refresh: 'Refresh',
  refreshAttendanceList: 'Refresh attendance list',
  recentlySignedIn: 'Recently signed in',
  turnOnEditMode: 'Turn on edit mode',
  turnOffEditMode: 'Turn off edit mode',
  editOn: 'Edit On',
  editLayout: 'Edit Layout',
  editing: 'Editing',
  editingLayout: 'Editing layout',
  completeEditing: 'Complete Editing',
  done: 'Done',
  empty: 'Empty',
  attendanceDisplayMode: 'Attendance display mode',
  activityIsLinked: 'Linked to other activities',
  untitled: 'Untitled',
  saveReminderMessage:
    "You have been working for a while, would you like to save your changes so we don't lose them?",
  unlinkActivity: 'Unlink',
  updateAllLinkedActivities:
    'Update Activity and all {count} linked activities',
  linkedActivityTooltip: 'Linked activity — click to highlight its copies',
  lessonPlanDisplayMode: 'Lesson plan display mode',
  cleanDisplayMode: 'Clean view',
  cleanDisplayModeShort: 'Clean',
  detailedDisplayMode: 'Detailed view',
  detailedDisplayModeShort: 'Detail',
  canvasLayout: 'Canvas Layout',
  gridLayout: 'Grid Layout',
  noSpacesYet: 'No Spaces',
  pleaseWait: 'Please wait...',
  noResultsFound: 'No results found.',
  nap: 'Nap',
  addTeam: 'Add Team',
  addEmptyTeam: 'Add team',
  addEmptyTeamHint: 'Create an empty team you can move people into',
  removeTeam: 'Remove team',
  removeEmptyTeamHint: 'Remove this empty team',
  teamAdded: 'Team added',
  teamRemoved: 'Team removed',
  failedToAddTeam: 'Failed to add team',
  failedToRemoveTeam: 'Failed to remove team',
  removeSpaceFromCanvas: 'Remove from canvas',
  removeSpaceDisabledTooltip: 'Move everyone out before removing from canvas',
  autoArrange: 'Auto Arrange',
  autoArrangeTooltip: 'Pack all spaces in a tidy grid based on their sizes',
  autoArrangeApplied: 'Spaces auto-arranged',
  subtitleWalking: 'Walking group',
  subtitleTransport: 'Transport',
  subtitleOther: 'Other',
  subtitleStaff: 'Staff space',
  subtitleMixed: 'Mixed ages',
  statusOnTrack: 'On track',
  statusWatch: 'Watch',
  statusNeedsAttention: 'Needs attention',
  statusIdle: 'Idle',
  filterAll: 'All',
  filterActive: 'Active',
  filterEmpty: 'Empty',
  filterNeedsAttention: 'Needs attention',
  filterPinned: 'Pinned',
  sectionPinned: 'Pinned',
  reorderPinnedSpace: 'Drag to reorder pinned spaces',
  sectionActive: 'Active spaces',
  sectionEmpty: 'Empty',
  sectionIdle: 'Idle / waiting',
  noChildrenHere: 'No children currently here',
  authorizedMember: 'Authorized Member',
  assignToSchool: 'Assign to School',
  availablePeople: 'Available People',
  currentLocation: 'Current location',
  defaultTeamWillBeCreated:
    'A default team will be created automatically for this sign-in.',
  inThisSpace: 'In This Space',
  kids: 'Kids',
  moveHere: 'Move Here',
  newTeam: 'New Team',
  noAuthorizedMembersAvailable: 'No authorized members available.',
  noMatchingStaffForSpace: 'No matching staff for this space.',
  noMatchingStudentsForSpace: 'No matching students for this space.',
  noOtherStaff: 'No other staff.',
  noOtherStudents: 'No other students.',
  noRatio: 'No ratio',
  noStaffAssignedToTeam: 'No staff assigned to this team.',
  noStudentsInTeam: 'No students in this team.',
  viewStudentDetail: "View {name}'s details",
  viewStaffDetail: "View {name}'s details",
  selectPerson: 'Select {name}',
  staffProfile: 'Staff Profile',
  staffInfo: 'Staff info',
  typicalShift: 'Typical shift',
  complianceChecks: 'Compliance & clearances',
  noCertificationsOnFile: 'No certifications on file',
  expires: 'Expires',
  due: 'Due',
  expiredCountLabel: '{count} expired',
  allClearancesCurrent: 'All current',
  noTasksAvailable: 'No tasks available.',
  noTeamsInSpace: 'No teams in this space.',
  otherStaff: 'Other staff',
  otherStudents: 'Other students',
  ratio: 'Ratio',
  recommendedForThisSpace: 'Recommended for this space',
  signInToStart: 'Sign in to start',
  applyToAll: 'Apply to all',
  batchClearSelection: 'Clear',
  batchSelectedCount: '{count} selected',
  batchSignInCount: 'Sign In {count}',
  batchPeopleCount: '{count} people',
  needsAuthorizedMember: 'Needs authorized member',
  batchNeedsTask: 'Needs a task',
  batchMemberLoadFailed: "Couldn't load pickup members",
  // Trails the chosen authorized member on a batch sign-in row, so the line
  // reads "Sven Aguirre is dropping off" — it cues staff to correct the member
  // when someone else is actually doing the drop-off.
  isDroppingOff: 'is dropping off',
  batchSignInFailed: 'Some people could not be signed in: {errors}',
  batchSignInFailedGeneric:
    'Sign in failed. Please check the board and try again.',
  team: 'Team',
  teamAttendanceSummary: 'Team attendance summary',
  selectedLabel: 'Selected',
  selectedCount: '{count} selected',
  selectedOfTotal: '{selected} / {total} selected',
  studentCountLabel: '{count} student | {count} students',
  staffCountLabel: '{count} staff',
  selectionRequired: 'Selection is required',
  chooseDestinationTeam: 'Choose a destination team',
  createNewTeam: 'Create New Team',
  movingFrom: 'Moving from',
  showTeamRoster: 'Show who is in this team',
  hideTeamRoster: 'Hide who is in this team',
  noSpacesFound: 'No spaces found',
  noSpacesFoundFor: "No spaces found for '{query}'",
  pleaseSelectTeam: 'Please select a team',
  moveFailed: 'Move failed: {message}',
  bringIn: 'Bring In',
  bringInPeople: 'Bring People In',
  searchPeople: 'Search people',
  noPeopleFound: 'No people found',
  noPeopleFoundFor: "No people found for '{query}'",
  pleaseSelectPeopleToBringIn: 'Please select at least one person',
  signInFailedWithReason: 'Sign in failed: {message}',
  refundOverageAdjustmentMessage:
    'The refund amount is {diff} more than the selected credit memos. A credit memo for the overage will be created to balance the payment made, and an invoice for the difference will be added to the account so the over-refund can be tracked and collected, as shown below. ',
  refundUnderageAdjustmentMessage:
    'The refund amount is -{diff} less than the selected credit memos. We will adjust the credit memo(s) selected as shown below and create a corresponding new memo to account for the outstanding balance.',
  refundWithCreditsToAccount: 'Refund with Credits to Account',
  refused: 'Refused',
  regInAdvance: 'Reg. In Advance',
  regionSpecific: 'Region Specific',
  registeredOnly: 'Registered only',
  registration: 'Registration',
  registrationData: 'Registration data',
  registrationAgeGroups: 'Registration Age Groups',
  registrationAges: 'Registration Ages',
  registrationBillingDate: 'Based on Registration/Billing Date',
  registrationCloseDate: 'Registration Close Date (Public)',
  registrationCloseDatePortal: 'Registration Close Date (Portal)',
  registrationComplete: 'Registration Complete!',
  registrationCompleteMessage:
    'Your {childrenText} been successfully registered. No payment is required at this time.',
  registrationDate: 'Registration Date',
  registrationDeposit: 'Registration Deposit ($)',
  registrationEndDate: 'Registration End Date',
  registrationGroups: 'Registration Groups',
  registrationLocation: 'Registration Location',
  registrationOpenDate: 'Registration Open Date (Public)',
  registrationOpenDatePortal: 'Registration Open Date (Portal)',
  registrationProposals: 'Registration Proposals',
  registrations: 'Registrations',
  registrationSlots: 'Slots',
  registrationStartDate: 'Registration Start Date',
  registrationTags: 'Registration Tags',
  regularMedications: {
    showSignedOutStudents: 'Show medications for signed-out students',
    studentSignedOut: 'Signed out',
  },
  regularMeds: 'Regular',
  reject: 'Reject',
  rejectConfirmation:
    'Are you sure you want to reject this {name}? You can optionally provide feedback below.',
  rejected: 'Rejected',
  rejectedAssessments: 'Rejected Assessments',
  rejectedDate: 'Rejected Date',
  rejectInfoChangeConfirmationMessage:
    'Rejecting will discard the requested info changes. Are you sure you want to continue?',
  rejectionReason: 'Rejection Reason',
  rejectionReasonPlaceholder: 'Reason for rejection...',
  rejectLesson: 'Reject Lesson',
  rejectLessonConfirmation:
    'Are you sure you want to reject this lesson? You can optionally provide feedback below.',
  relationship: 'Relationship',
  relationshipToStudentBeingRegistered:
    'Relationship To Student Being Registered',
  rememberEmail: 'Remember email',
  reminder: 'Reminder',
  reminderBanner:
    'Please add and keep updated all student (allergies, medications etc), guardian and other contacts info via the Members and Students tabs. If another member would like to have their own Portal login, add them in the Members tab, then email your request for portal access to administration.',
  remove: 'Remove',
  removedFromImmunizationSetup: 'Removed from center',
  removedImmunizationRecordFileInstructions:
    'This vaccine record is not part of the current center setup. It may have been removed or recreated as a new record. It is being kept because it has attached files. Files can be moved directly to a current vaccine or dose. Download and reattach any other evidence that should be kept, or remove files that are no longer needed. Once no files remain, this record will be removed when the profile is saved.',
  removeFavouritePlan: 'Remove favourite plan',
  removeRecord: 'Remove record',
  removeFile: 'Remove file',
  replace: 'Replace',
  removeChild: 'Remove Child',
  removeAutomaticApplication: 'Remove automatic application',
  move: 'Move',
  rename: 'Rename',
  repeat: 'Repeat',
  repeatEvery: 'Repeat every',
  reply: 'Reply',
  report: 'Report',
  reportAcknowledgment: 'Report Acknowledgment',
  reportDate: 'Report Date',
  reportDateFrom: 'Report Date From',
  reportDateTo: 'Report Date To',
  reportDetails: 'Report Details',
  reports: 'Reports',
  reportsDescription:
    'Access comprehensive reports to track student and group learning progress',
  requestApproval: 'Request Approval',
  requestedStartDate: 'Requested Start Date',
  require: 'Require',
  required: 'Required',
  requiredForFees: 'Required for Fees',
  missingRequiredAdminInfo:
    'Birthday and full address (address, city, state/province, country, postal code) are required for anyone who can process PAD payments',
  requiredSpaceRatio: 'Required Space Ratio',
  rerollPIN: 'Reroll PIN',
  resendDepositRequest: 'Resend Deposit Request',
  resendOneTimePasscodePrompt: 'Resend one time passcode?',
  revertAllCustomJournals: 'Revert All Custom Journals',
  revertAllCustomJournalsConfirmMessage:
    'This will move every student back to the main journal and discard all custom journal groupings. Are you sure you want to continue?',
  revertAllCustomJournalsConfirmTitle: 'Revert all custom journals?',
  revertToMainJournal: 'Revert to main journal',
  reserved: 'Reserved',
  reset: 'Reset',
  resetAgreementResponse: 'Reset agreement response',
  resetAll: 'Reset All',
  resetAmount: 'Reset Amount',
  resetBy: 'Reset by',
  resetByStaff: 'Reset by staff',
  resetPasswordButtonLabel: 'Reset password',
  resetPasswordCheckboxLabel: 'Reset Password',
  resolvedJsonCopied: 'Resolved JSON copied to clipboard',
  respondedBy: 'Responded by',
  responseChanged: 'Response changed',
  restore: 'Restore',
  resultingAttendances: 'Resulting Attendance History will be:',
  retry: 'Retry',
  return: 'Return',
  returnCredit: 'Return Credit as payment',
  returningToMainMenuWarning: 'Returning to Main Menu in {timeLeft}...',
  returnToMainMenuButtonLabel: 'Return To Main Menu',
  reviewDate: 'Review Date',
  reviewSignInMessage: 'Review and confirm the selected staff and students',
  revokeAuthorizationFromDeviceLabel: 'Revoke authorization from device',
  revokeAuthorizationFromDeviceTooltip:
    'Remove authorization from this device to prevent non-admin users from using this device.',
  revokeDeviceAuthorizationErrorMessage: 'Error revoking device authorization',
  rightClickForActions: 'Right click to perform actions',
  role: 'Role',
  roleLock: 'Role Lock',
  roleLockHint: 'Users at this role level and below will not be able to edit',
  rollOver: 'Roll-Over',
  rollOverAgeGroups: 'Roll-Over Age Groups',
  roomStaff: 'Room Staff',
  rotessa: 'Rotessa',
  rotessaAccountSetup: 'Rotessa Account Setup',
  rotessaAccountSetupDescription:
    "Rotessa is the payment processor used by ChildFriendly to withdraw payments directly from your customer's bank account when they are due. Please review the details below and proceed with submission.",
  rotessaAccountSetupVerification:
    'Please verify the detail to connect with and submit below',
  rotessaAgreement: "By clicking Create Rotessa Client you agree to Rotessa's",
  rotessaBusinessInfo:
    'The following Center information will be used for the Rotessa account setup.',
  rotessaBankAccountLede:
    'Enter the bank account payments will be withdrawn from and upload the supporting documents. The account details and documents are submitted to Rotessa together.',
  rotessaBusinessInfoIncomplete:
    'Please complete the required business information before submitting.',
  rotessaBusinessInfoLede:
    'This information, along with your payment profile below, is used for your Rotessa account. You can update it at any time.',
  rotessaClientCreated: 'Rotessa client created',
  rotessaConfig: 'Rotessa Config',
  rotessaConfirmation:
    "Information cannot be edited during the verification process. Please confirm that you have included accurate information for all owners/shareholders of more than 25% equity or, if the entity is run by a board (where there is no ownership or shares), that all board members have been listed. Additionally, ensure that either a void check or a direct deposit form, along with the last month's bank statement, have been uploaded and match the bank account set under the Business Info section.",
  rotessaCreate: 'Create Rotessa Client',
  rotessaCreateClientConfirmation:
    "Create your Rotessa client with this business information? You'll add your bank account and documents in the next step.",
  rotessaSettlementConfirmation:
    'Submit your bank account details and documents to Rotessa? Please confirm they are accurate before continuing.',
  rotessaSettlementSubmitted: 'Bank account details and documents submitted',
  rotessaChangeDocuments: 'Change documents',
  rotessaDocumentsOnFile:
    'These documents are on file. Changing them clears both and requires you to re-upload and resubmit.',
  rotessaDocumentsRequired:
    'Please upload both a void check (or direct deposit form) and a recent bank statement before submitting.',
  rotessaDocumentsLede:
    "Upload either a void check or a direct deposit form, along with the last month's bank statement matching the bank account above.",
  rotessaGetVerificationLink: 'Sign agreement',
  rotessaCompleteInSandbox: 'Complete in sandbox',
  rotessaSandboxCompleted: 'Agreement completed in sandbox',
  rotessaApproveInSandbox: 'Approve client (sandbox)',
  rotessaClientApproved: 'Rotessa client approved',
  rotessaInfoOnFile: 'Information on file with Rotessa',
  rotessaModification:
    'To modify information after submission, please contact support through chat or email at',
  rotessaNoDocumentsRequired: 'No documents are currently required.',
  rotessaOpenVerification: 'Continue agreement',
  rotessaOrgAdminRequired:
    'Please have an organization admin fill out the center information.',
  rotessaOwnershipIncomplete:
    'Ownership shares must total 100% in every ownership group before you can continue.',
  rotessaNoFinishedSigner:
    'At least one person must complete the Rotessa agreement before you can submit.',
  rotessaDirectorsRequired:
    'This business type requires at least one director before you can continue.',
  rotessaDirectorPositionRequired:
    'Every director must have a position selected before you can continue.',
  rotessaOwnerInfo:
    'Please list each owner/shareholder of more than 25% equity. If the entity is run by a board, where there is no ownership or shares, list all board members.',
  rotessaSetup: 'Rotessa Setup',
  rotessaReviewSubmit: 'Review & Submit',
  rotessaReviewLede:
    'Review the information below before submitting your application to Rotessa. Use Edit to make changes to any section.',
  rotessaSubmitApplication: 'Submit Application',
  rotessaSubmitConfirmation:
    'Once submitted, your application is locked and cannot be changed. Please make sure all details are accurate before continuing.',
  rotessaApplicationSubmitted:
    'Your application has been submitted to Rotessa for review.',
  rotessaOnboardingDisabled:
    'We are currently unable to onboard new clients at this time. Please check back later.',
  rotessaAddress: {
    sectionTitle: 'Business addresses',
    lede: 'Provide both a registered and operating business address.',
    addAnother: 'Add another address',
    copyFromOperating: 'Copy from operating address',
    copyFromRegistered: 'Copy from registered address',
    remove: 'Remove address',
    label: 'Address {number}',
    typeLabel: 'Address type',
    categoryLabel: 'Address category',
    types: {
      RegisteredAddress: 'Registered address',
      OperatingAddress: 'Operating address',
    },
    categories: {
      Residential: 'Residential',
      Commercial: 'Commercial',
    },
    required: 'At least one business address is required.',
    bothRequired:
      'A registered and operating address are required before you can continue.',
  },
  rotessaPin: {
    sectionTitle: 'Payment Profile',
    lede: 'This is called a PIN — Purpose and Intended Nature — and describes why you collect payments and the expected nature of your transactions. Rotessa uses it to review your account.',
    clientPaymentDescriptionLabel: 'What do your customers pay you for?',
    clientPaymentDescriptionHint:
      'Describe what you charge your customers for (minimum 30 characters).',
    descriptionTooShort: 'Please enter at least 30 characters',
    paymentPatternLabel: 'Payment pattern',
    customerCountLabel: 'Estimated number of customers',
    typicalAmountLabel: 'Typical transaction amount',
    monthlyDebitTotalLabel: 'Estimated total monthly debit volume',
    monthlyDebitTooLarge: 'Please enter an amount of $1,000,000,000 or less',
    frequencyLabel: 'How often are payments withdrawn?',
    outlierLabel:
      'Do you ever process a transaction larger than your typical amount?',
    transactionCharacterisationLabel:
      'How would you characterise these transactions?',
    maximumSingleDebitLabel: 'Maximum single transaction amount',
    maximumSingleDebitTooLarge: 'Please enter an amount of $1,000,000 or less',
    selectAtLeastOne: 'Select at least one',
    formIncomplete:
      'Please complete the required payment profile information before submitting.',
  },
  rotessaStakeholders: {
    addEntity: 'Add a company or trust',
    createClientFirst:
      'Create the Rotessa client first — you will then list the ownership and people here.',
    sectionTitle: 'People & Ownership',
    addPerson: 'Add a person',
    addRole: '+ Add {role}',
    alreadyListed: 'Already listed — nothing to re-enter',
    alsoAuthorizedUser:
      'Also make this person an authorized user on the account',
    alsoHolds: 'Also holds:',
    alsoRole: 'Also: {role}',
    authorizedUserDescription: 'Can set up and manage payments on the account',
    authorizedUsersLede:
      'Everyone who can manage payments on this account must be listed and kept current — missing someone can block payment processing.',
    authorizedUsersTitle: 'Who can manage payments on this account?',
    categories: {
      authorizedUser: 'Authorized user',
      beneficiary: 'Beneficiary',
      director: 'Director',
      owner: 'Owner',
      settlor: 'Settlor',
      thirdParty: 'Third party',
      trustee: 'Trustee',
      unitHolder: 'Unit holder',
    },
    checkAuthorizedUsersDone: 'At least one authorized user listed',
    checkAuthorizedUsersTodo: 'Add at least one authorized user',
    checkDirectorPositionsTodo: 'Select a position for every director',
    checkDirectorsDone: 'At least one director listed, each with a position',
    checkDirectorsTodo: 'Add at least one director with their position',
    checkEntitiesTracedDone:
      'Every company or trust traces down to real people',
    checkOwnersDone: 'Owners listed and shares total 100%',
    checkOwnersOverShare: 'Owner shares total more than 100%',
    checkOwnersSharesTodo:
      'Make ownership shares total 100% in every ownership group',
    checkOwnersTodo: 'List who owns the business',
    checkOwnersUntraced:
      'Every company or trust must be traced down to real people',
    checklistTitle: 'Still needed before you can continue',
    checkSingleOwnerDone: 'The owner is listed',
    checkSingleOwnerTodo: 'List the owner of the business',
    checkSingleOwnerWarn:
      'A proprietorship has exactly one owner — this list has {count}',
    checkThirdPartyListed: 'Third-party question answered — {count} listed',
    checkThirdPartyMissing: 'Add the third party that directs transactions',
    checkThirdPartyNone: 'Third-party question answered — none',
    checkThirdPartyTodo: 'Answer the third-party question below',
    childGroupTitle: '{role} — {entity}',
    classifications: {
      corporation: 'Corporation',
      individual: 'Person',
      standardTrust: 'Standard trust',
      widelyHeldTrust: 'Widely held trust',
    },
    countryOfIncorporation: 'Country of incorporation',
    countryOfResidence: 'Country of residence',
    directorDescription: 'Sits on the board',
    directorsLede:
      'Everyone on the board, with their position. Directors need a country of residence but no address.',
    directorsTitle: 'Directors',
    entityDetails: 'Business details',
    entityNeedsPeople: 'Needs owners listed',
    entityRoleHint:
      'After saving, list who owns this company or trust — every branch must end at real people.',
    entitySaved: 'Company or trust saved',
    entityTraceHint:
      'Companies and trusts must ultimately be owned by one or more real people.',
    entityTraced: 'Fully traced to people',
    entityType: 'Type',
    homeAddress: 'Home address',
    legalName: 'Legal name',
    lockedForReview:
      'This information is locked while Rotessa reviews the application. To make changes, contact support.',
    natureOfBusiness: 'Nature of business',
    newEntity: 'New company or trust…',
    newEntityCaption: 'You will then list who owns it',
    newPerson: 'New person…',
    occupation: 'Occupation',
    otherPosition: 'Describe the position',
    ownerDescription: 'Holds a share of the business',
    ownershipLede:
      'Who owns the business? People, companies, and trusts all count — when a company or trust owns a piece, list who owns it until you reach real people.',
    ownershipLedeProprietorship:
      'A proprietorship has exactly one owner — the proprietor, at 100%.',
    ownershipFullyAllocated: 'Ownership is at 100%.',
    ownershipShare: 'Ownership share',
    ownershipTitle: 'Ownership',
    paymentAuthorityTitle: 'Payment authority',
    personDetails: 'Their details',
    personSaved: 'Person saved',
    registrationNumber: 'Registration number',
    relationshipToBusiness: 'Relationship to business',
    removeEntityMessage:
      'Remove {name}? Everyone listed under it will be removed as well.',
    removePersonMessage:
      'Remove {name} as {role}? Their other roles are kept, and they are only deleted once they hold no roles.',
    removeTitle: 'Remove from application',
    requiredFieldsHint:
      'Required fields follow the roles this person holds — Rotessa validates each role separately.',
    requirementsSubtitle: 'Based on your business type: {businessType}',
    requirementsTitle: 'What Rotessa needs',
    roleOnlyHint:
      "Only the role details are needed here — to change this person's information, use the edit button on their row.",
    rolesHint: 'One person can hold several roles — check all that apply.',
    rolesTitle: 'Roles at this business',
    sharesAllocated: '{total}% of 100%',
    sharesLabel: 'Ownership allocated',
    sharesOverLimit: "{total}% — shares can't total more than 100%",
    shareRangeError: 'Enter a share above 0 and up to 100',
    shareSiblingsError:
      "Combined shares at this level can't total more than 100%",
    thirdPartyHint:
      "A third party is any person or business that instructs this business's transactions. Listing them is required under Canada's anti-money-laundering rules (FINTRAC).",
    thirdPartyQuestion:
      "Does another person or business direct this business's transactions?",
    thirdPartyRequired: 'Add at least one third party before continuing.',
    unknownBusinessType: 'not set',
  },
  rotessaTesting: 'Rotessa (Testing)',
  rotessaVerificationApproved:
    'Your Rotessa account is approved and ready to process pre-authorized debit payments.',
  rotessaVerificationExpires: 'Expires',
  rotessaVerificationLinkFailed:
    'No verification link was returned. Please try again, or contact support if the problem continues.',
  rotessaVerificationLinkHint:
    'Open the link to complete verification. It can also be shared with the person who needs to verify and sign.',
  rotessaVerificationNoPeople:
    'No people have been listed yet. Add them in the previous step to send a verification link.',
  rotessaVerificationNoneFinished:
    'No one has completed the Rotessa agreement yet.',
  rotessaVerificationSignersLede:
    'An authorized user with signing authority must fill out the terms and conditions for Rotessa. Please select one person who meets this criteria to fill out this information.',
  rotessaVerificationStatus: {
    personal_info: 'Personal information',
    veriff: 'Identity verification',
    sign: 'Signature',
    finished: 'Finished',
  },
  rotessaVerificationStatusNotStarted: 'Not started',
  roundingOptions: 'Rounding Options',
  routine: 'Routine',
  routines: 'Routines',
  rsvpType: 'RSVP Type',
  sandboxMode: 'Sandbox Mode',
  save: 'Save',
  saveStudentBeforeUploadingFiles:
    'Please save the student first before uploading files',
  addQuestion: 'Add Question',
  untitledQuestion: 'Untitled question',
  saveChangesWarning:
    'Saving these changes will clear out excluded and modified dates.',
  schedule: 'Schedule',
  scheduleDateMustBeFuture: 'Schedule date must be later than today',
  scheduleDateMustBeWeekday: 'Schedule date must be a weekday',
  scheduleForLaterDate: 'Schedule for a later date',
  scheduledAdminTime: 'Sch. Admin Time',
  schedules: 'Schedules',
  school: 'School',
  schoolMessagesGroup: { inUseError: 'Cannot delete school(s) in use' },
  schools: 'Schools',
  schoolsAndTransport: 'Schools & Transport',
  recent: 'Recent',
  recentActivity: 'Recent Activity',
  search: 'Search',
  searchBySponsorOrChild: 'Search by sponsor or child',
  searchConversations: 'Search conversations...',
  searchProperties: 'Search properties',
  searchCurriculums: 'Search curriculums...',
  searchDirectMessages: 'Search direct messages...',
  searchFamilies: 'Search Families...',
  searchFamiliesOrStaff: 'Search families or staff...',
  searchGroups: 'Search groups...',
  searchGroupsByName: 'Search Groups By Name...',
  searchMessages: 'Search messages...',
  searchResults: 'Showing search results',
  select: 'Select',
  selectAll: 'Select All',
  selectAllStudentsHint: 'Select all students in this team',
  selectEveryoneHint: 'Select everyone (students and staff) in this team',
  selectAtLeastOneDay: 'You must select at least one day.',
  selectDate: 'Select Date',
  selectGroup: 'Select Group',
  selected: 'Selected',
  selectGroupForFAReport:
    "Monitor groups progress towards focus areas based on the lesson's they have completed",
  selectGroupForProgressReport:
    'Monitor groups progress based on assessments provided by their teachers',
  selectGroupForShoppingList: 'Select a group to view their shopping list',
  selectedSignedInAttendeeCountMessage: 'Selected Signed In Attendees: {count}',
  selectedSignedOutStaffCountMessage: 'Selected Signed Out Staff: {count}',
  selectedSignedOutStudentsCountMessage:
    'Selected Signed Out Students: {count}',
  selectedStaffCountMessage: 'Selected Staff: {count}',
  selectedStudentsCountMessage: 'Selected Students: {count}',
  selectFamilyMembersToSendBulkMessages:
    'Select family members to send bulk messages',
  selectMultiple: 'Select Multiple',
  selectOrgFirstPrompt: 'Please select an organization first',
  selectPhoto: 'Select Photo',
  selectRole: 'Select Role',
  selectOutcome: 'Select a Learning Outcome',
  selectOutcomePrompt:
    'Choose a learning outcome from the sidebar to view and manage assessments',
  selectCenter: 'Select Center',
  targetCenter: 'Target Center',
  selectCentersHint:
    'Leave empty to make this available at all centers, or select specific centers',
  selectCenterToConfigureMessage: 'Please select a center to configure',
  selectSection: 'Select Section',
  selectSchedule: 'Select schedule to check availability',
  selectStaff: 'Select Staff',
  selectStudent: 'Select a student to drop-off or pick-up',
  selectStudentForFAReport:
    "Monitor students progress towards focus areas based on the lesson's they have completed",
  selectStudentForProgressReport:
    "Monitor students progress towards  areas based on the lesson's they have completed",
  selectStudents: 'Select Students',
  selectSponsorToLoadInvoices: 'Select a sponsor to load open invoices.',
  selectTeams: 'Select Teams',
  send: 'Send',
  sendAnnouncement: 'Send Announcement',
  sending: 'Sending',
  sendingAs: 'Sending as',
  sendingBroadcast: 'Sending broadcast...',
  sendUrgent: 'Send Urgent',
  sendNow: 'Send Now',
  sendResetPasswordEmailMessage:
    'We sent a password reset link to the registered account with email if it exists.',
  sendTestEmail: 'Send Test Email',
  sendToAll: 'Send to All',
  sendVerificationEmail: 'Send Verification Email',
  sent: 'Sent',
  sentToRecipients: 'Sent to {count} recipients',
  seriesDetails: 'Series Details',
  seriesEndDate: 'Series End Date',
  seriesEndDateMustBeAfterStart: 'Series end date must be after the start date',
  seriesStartDate: 'Series Start Date',
  setNewPasswordPrompt: 'Set new password',
  settings: 'Settings',
  settleByCreatingInvoice: 'Settle By Creating Invoice',
  settlement: 'Settlement',
  settlementDate: 'Settle Date',
  settlePayment: 'Settle Payment',
  setup: 'Setup',
  setupGuide: 'Setup Guide',
  setupVersionToggleHint:
    'Switch between the classic and new Setup experience. Your choice is remembered on this browser.',
  setupGuideIntro:
    'Reference for all Setup fields and concepts. Use this page when you want a quick overview of what each setting does without leaving the current step.',
  setupMode: 'Setup Mode',
  setupNeeded: 'Setup Needed',
  shared: 'Shared',
  shareLinkPrompt: 'Or share this link:',
  shoppingList: 'Shopping List',
  shoppingListReports: 'Shopping List Reports',
  shoppingGroupTitle: 'Group Shopping List',
  shoppingGroupDescription:
    'Generate a shopping list for materials needed for upcoming plans in a group',
  shortcuts: {
    chromeTitle: 'Chrome:',
    chromeWinLin: 'Windows/Linux: Ctrl + Shift + R',
    chromeMac: 'Mac: Cmd + Option + R',
    firefoxTitle: 'Firefox:',
    firefoxWinLin: 'Windows/Linux: Ctrl + Shift + R',
    firefoxMac: 'Mac: Cmd + Option + R',
    edgeTitle: 'Edge:',
    edgeWinLin: 'Windows/Linux: Ctrl + Shift + R',
    safariTitle: 'Safari:',
    safariMac: 'Mac: Cmd + Option + R',
  },
  shortName: 'Short Name',
  showAll: 'Show all',
  showAllStaffIncludingInactive: 'Show all staff (including inactive)',
  show: 'Show',
  showAllRecords: 'Show All Records',
  showDetails: 'Show Details',
  showBankInfoLabel: 'Show bank info',
  showEnded: 'Show Ended',
  showFilteredItemsOnly: 'Show Filtered Items Only',
  showFullBreakdown: 'Show Full Breakdown',
  showing: 'Showing',
  showPIN: 'Show PIN',
  showWeekends: 'Show Weekends',
  sickOrIllness: 'Sick / Illness',
  signin: 'Sign In',
  signMultiplePeopleInConfirmationMessage:
    'Are you sure you want to sign {count} people into the {toSpace} space?',
  signMultiplePeopleOutConfirmationMessage:
    'Are you sure you want to sign {count} people out of the {fromSpaces}?',
  signOnePersonInConfirmationMessage:
    'Are you sure you want to sign 1 person into the {toSpace} space?',
  signOnePersonOutConfirmationMessage:
    'Are you sure you want to sign 1 person out of the {fromSpace}?',
  signout: 'Sign Out',
  skipped: 'Skipped',
  socialEmotional: 'Social & Emotional',
  socialInsuranceNumber: 'SIN',
  someStudentsAreNotCurrentMessage:
    'Some students selected do not have current status. New journals can only be created for current students.',
  source: 'Source',
  sourcePaymentAmount: 'Source Payment Amount',
  space: 'Space',
  spaceColor: 'Space Color',
  spaceIsEmpty: 'Space is empty',
  spaceLayoutSaved: 'Space layout saved',
  spaceNotOnCanvas: "This space isn't placed on the canvas yet",
  spacePlaceholder: 'Select a space...',
  spaces: 'Spaces',
  specialNeeds: 'Special Needs',
  sponsor: 'Sponsor',
  sponsorForRemainingAmount: 'Sponsor For Remaining Amount',
  sponsorName: 'Sponsor',
  sponsorNameLabel: 'Sponsor Name',
  sponsorNoAutoPayment: 'This sponsor does not have auto payment turned on',
  sponsorType: 'Sponsor Type',
  sponsorSelection: 'Sponsor Selection',
  sponsors: 'Sponsors',
  staff: 'Staff',
  staffId: 'Staff ID',
  staffInfoUnsavedChanges: {
    title: 'Unsaved staff information',
    description: 'Save or reset your changes before leaving this page.',
  },
  staffName: 'Staff Name',
  staffOrAdminViewOnly: 'Staff/Admin View Only',
  staffPositions: 'Staff Positions',
  staffSchedules: 'Staff Schedules',
  staffRoles: 'Staff Roles',
  templates: 'Templates',
  activeSchedule: 'Active schedule',
  requests: 'Requests',
  timeOff: 'Time off',
  staffSchedule: {
    changeColor: 'Mark as covering another room',
    markAsBreak: 'Mark as break',
    removeBreak: 'Remove break',
    flagCell: 'Flag cell',
    removeFlag: 'Remove flag',
    flaggedTooltip: 'Flagged — needs a follow-up.',
    addNote: 'Add note',
    editNote: 'Edit note',
    clearBlock: 'Clear block',
    coveringStaffLabel: 'Covering staff member',
    coveringStaffPlaceholder: 'Select who is covering',
    coveringStaffDoubleBookedWarning: 'Already working their own assignment at this time — linking them here double-books them',
    coveredByLabel: 'Covered by {name}',
    notePlaceholder: 'Add a note — no length limit',
    noCoverage: 'NO COVER',
    showExpectedCount: 'Expected',
    showExpectedCountTooltip: 'Show SMART ASSIST\'s expected child count inline on the schedule, per room per time block',
    showRegisteredCount: 'Registered',
    showRegisteredCountTooltip: 'Show the registered child count inline on the schedule, per room per time block',
    expectedChildrenTooltip: '{count} expected children (SMART ASSIST)',
    registeredChildrenTooltip: '{count} registered children',
    zoomOut: 'Zoom out',
    zoomIn: 'Zoom in',
    resetZoom: 'Reset zoom to 100%',
    save: 'Save',
    cancel: 'Cancel',
    totalHours: 'Total hours',
    licensedAbbrev: 'lic.',
    licensedLabel: 'Licensed',
    licensedCapacityLabel: 'Licensed capacity',
    exportPdf: 'Export PDF',
    generatedOn: 'Generated on',
    time: 'Time',
    capacity: 'Capacity',
    legend: 'Legend',
    break: 'Break',
    uncoveredBreak: 'Break — no coverage',
    notes: 'Notes',
    statWorking: 'staff on today’s grid',
    statOnBreak: 'on break right now',
    statUncovered: 'break with no coverage',
    legendWorking: 'Working',
    legendBreakCovered: 'On break — covered',
    legendBreakUncovered: 'On break — no coverage',
    legendOff: 'Not scheduled',
    shareSchedule: 'Share schedule',
    unshareSchedule: 'Unshare schedule',
    removeSchedule: 'Remove',
    bulkShare: 'Manage sharing',
    bulkShareDialogTitle: 'Share existing schedules across multiple days',
    bulkShareOnlyScheduledDates: 'Only days with a schedule can be shared.',
    bulkShareAlreadySharedHint: 'Dot indicates a day is already shared.',
    bulkShareRangeHint: 'Hold Shift and click to select a range of days.',
    shareSelected: 'Share selected',
    unshareSelected: 'Unshare selected',
    addSchedule: 'Add schedule',
    previousDay: 'Previous day',
    nextDay: 'Next day',
    viewSchedulesCalendar: 'View schedules calendar',
    hideControls: 'Hide controls',
    showControls: 'Show controls',
    appliedFrom: 'Applied from',
    editedForTodayOnly: 'edited for today only',
    copiedSchedule: 'Copied from another day',
    noTemplatesYetMessage:
      'No templates yet — create your first one to get started.',
    pickupWindowNote: 'Blocks narrow to 15 min during the 4–6pm pickup window',
    breakCoveredLine: '{range} break — covered by {name}',
    breakUncoveredLine: '{range} break — no coverage',
    someone: 'someone',
    noStaffScheduledToday: 'No staff scheduled today',
    filterByCategoryPlaceholder: 'Category',
    filterByRoomPlaceholder: 'Room',
    filterByStaffPlaceholder: 'Staff',
    noRoomsMatchFilters: 'No rooms match these filters.',
    noScheduleForDay: 'No schedule has been added for this day yet.',
    addScheduleDialogTitle: 'Add a schedule',
    replaceSchedule: 'Replace schedule',
    overwriteScheduleTitle: 'Replace this day’s schedule?',
    overwriteScheduleMessage:
      'This day already has a schedule. Replacing it will overwrite the current schedule for this day.',
    fromTemplate: 'From template',
    copyFromDay: 'Copy from day',
    copyFromDayHint: 'Pick a day to copy its schedule onto this date.',
    copySchedule: 'Copy schedule',
    noTemplatesYet: 'No templates yet — create one in the Templates tab first.',
    apply: 'Apply',
    applyToMultipleDates: 'Apply to multiple dates',
    selectDatesTitle: 'Select dates for "{name}"',
    backToTemplates: 'Back',
    selectedDatesCount: '{count} dates selected',
    maxDatesReached: 'You can select up to {max} dates at a time.',
    applyToDatesCount: 'Apply to {count} dates',
    bulkApplyOverwriteWarning:
      '{count} of the selected dates already have a schedule. Applying will replace them.',
    bulkApplyExistingScheduleHint:
      'Dot indicates a day already has a schedule.',
    removeConfirmMessage:
      'This removes the schedule for this day. This can’t be undone.',
    tbd: 'TBD',
    staffSortLabel: 'Sort staff list by',
    staffSortDefault: 'Default',
    staffSortPosition: 'Position',
    staffSortGroup: 'Group',
    assignStaff: 'Assign staff',
    addSlot: 'Add slot',
    removeSlot: 'Remove slot',
    alreadyScheduledDivider: 'Already scheduled today',
    alreadyScheduledTag: 'Already scheduled elsewhere',
    checkedInToday: 'Checked in today',
    staffNotStartedWarning: "This staff member's start date hasn't arrived yet as of this schedule date",
    staffTerminatedWarning: 'This staff member was no longer active as of this schedule date',
    staffOnTimeOffWarning: 'This staff member has approved time off on this schedule date',
    staffOnTimeOffWithTypeWarning: 'This staff member has approved {leaveType} on this schedule date',
    newTemplate: 'New template',
    newTemplateTitle: 'New template',
    editTemplateTitle: 'Edit template',
    templateNameLabel: 'Template name',
    blockSizeLabel: 'Block size',
    blockSize15: '15 minutes',
    blockSize30: '30 minutes',
    blockSize60: '1 hour',
    blockSizeCaption: '{minutes} min blocks',
    folderPathLabel: 'Folder',
    folderPathPlaceholder: 'e.g. 2026/November',
    folderPathCreateHint: 'Pick an existing folder, or type a new name to create one',
    templateNotesLabel: 'Notes',
    rootFolder: 'Uncategorized',
    moreActions: 'More actions',
    copyTemplate: 'Copy',
    moveTemplate: 'Move to folder',
    deleteTemplate: 'Archive template',
    deleteTemplateConfirmMessage:
      'This archives "{name}". It won’t show up in Templates, but you can restore it from Archived Templates.',
    renameFolder: 'Rename folder',
    deleteFolder: 'Archive folder',
    renameFolderTitle: 'Rename folder',
    newFolderNameLabel: 'Folder name',
    deleteFolderConfirmTitle: 'Archive folder',
    deleteFolderConfirmMessage:
      'This archives "{name}" and its {count} template(s). They won’t show up in Templates, but you can restore them from Archived Templates.',
    templateFolders: 'Folders',
    newFolder: 'New folder',
    newSubfolder: 'New subfolder',
    folderNameLabel: 'Folder name',
    moveFolder: 'Parent folder',
    viewArchivedTemplates: 'View archived templates',
    backToTemplatesList: 'Back to templates',
    archivedTemplates: 'Archived templates',
    noArchivedTemplatesMessage: 'No archived templates.',
    restoreTemplate: 'Restore',
    restoreFolder: 'Restore all in folder',
    pseudoGroupTransport: 'Transport',
    pseudoGroupFloatsSubs: 'Support',
    pseudoGroupKitchen: 'Kitchen',
    pseudoGroupAdmin: 'Admin',
    pseudoGroupOther: 'Other',
    operationsCategory: 'Operations',
    uncategorizedCategory: 'Other Rooms',
    unassignedCategory: 'Unassigned',
    renameCategoryPlaceholder: 'Category name',
    dragToReorder: 'Drag to move this group',
    moveToCategory: 'Move to category',
    scheduleLayoutConfirmTitle: 'Update schedule layout?',
    scheduleLayoutConfirmMessage:
      'This changes the layout for every active schedule and template in this center, not just this one — everyone will see the new arrangement immediately.',
    scheduleLayoutConfirmOk: 'Apply',
    interactionHint:
      'Click, or click and drag down a column, to paint blocks — right-click a filled block to change its color, mark a break, or add a note.',
    touchWarning:
      'This grid is built for a mouse or trackpad — painting blocks and the right-click menu may not work on a touch-only device.',
    smartAssist: 'SMART ASSIST',
    openSmartAssist: 'Open SMART ASSIST',
    closeSmartAssist: 'Close SMART ASSIST',
    smartAssistGroup: 'Group',
    smartAssistFilterBy: 'Filter by',
    smartAssistFilterGroup: 'Group',
    smartAssistFilterAge: 'Age',
    smartAssistFilterProgram: 'Program',
    smartAssistFilterPlaceholder: 'Select one or more',
    smartAssistNoSelection: 'Select at least one to see combined totals.',
    smartAssistNoAgeGroups: 'No age groups set up yet.',
    smartAssistNoPrograms: 'No programs set up yet.',
    smartAssistInterval: 'Interval',
    smartAssistExpected: 'Expected',
    smartAssistExpectedTooltip:
      'The typical (average) headcount based on the last 60 days of attendance history for this weekday, excluding holidays.',
    smartAssistRange: 'Min–Max',
    smartAssistRangeTooltip:
      'The lowest and highest headcount actually seen at this time across the sampled days — how much the Expected average varies day to day.',
    smartAssistRegistered: 'Reg.',
    smartAssistRegisteredTooltip: 'Children actually registered and scheduled for this group at this time.',
    smartAssistIncludePendingAndWaitlisted: 'Include pending & waitlisted',
    smartAssistIncludePendingAndWaitlistedTooltip:
      'When on, the Registered number also includes children with a pending application and children on the waitlist, not just fully registered children.',
    smartAssistRecommendedStaff: 'Staff',
    smartAssistRecommendedStaffTooltip:
      'A suggested staff count by ratio, based on the typical (average) headcount shown — Expected, or Registered when the warning above is showing. A suggestion to check against your own judgment, not a guarantee.',
    smartAssistLowSampleWarning:
      "Not enough attendance history for this group yet — showing registered counts instead of a prediction.",
    smartAssistNoGroups: 'No rooms available yet.',
    smartAssistUnavailable: "Smart Assist isn't available for this group right now. Try again shortly, or another group in the meantime.",
    smartAssistByAgeGroup: 'by age group',
    smartAssistNoActivity: 'no activity',
    smartAssistCollapse: 'Collapse',
  },
  timeOffRequests: {
    title: 'Time off',
    requestTimeOff: 'Request time off',
    addTimeOff: 'Add time off',
    staffMember: 'Staff member',
    type: 'Type',
    types: {
      Leave: 'Leave',
      Vacation: 'Vacation',
      Personal: 'Personal',
      Sick: 'Sick',
      Other: 'Other',
    },
    when: 'When',
    startDate: 'Start',
    endDate: 'End',
    selectDate: 'Select date',
    today: 'Today',
    tomorrow: 'Tomorrow',
    thisWeek: 'This week',
    duration: 'Duration',
    fullDayHint: 'Uses your typical scheduled hours each day',
    fullDay: 'Full day',
    hours: 'Hours',
    hoursPerDay: 'Hours per day',
    startTime: 'Start time',
    endTime: 'End time',
    description: 'Description',
    status: {
      Pending: 'Pending',
      Approved: 'Approved',
      Rejected: 'Rejected',
      PendingDeletion: 'Pending deletion',
      Withdrawn: 'Withdrawn',
    },
    approve: 'Approve',
    approveDeletion: 'Approve deletion',
    keepEntry: 'Keep entry',
    reject: 'Reject',
    rejectReason: 'Reason',
    withdraw: 'Withdraw',
    withdrawConfirm: 'Withdraw this time off request?',
    requestDeletion: 'Request deletion',
    requestDeletionConfirm:
      'Ask an admin to remove this approved time off? It stays active until they respond.',
    remove: 'Remove',
    removeConfirm: 'Remove this time off entry? This cannot be undone.',
    noRequests: 'No time off requests yet.',
    noHistoryForYear: 'No time off history for this year.',
    roomStaffOnlyTitle: 'This tab is for Room Staff only',
    roomStaffOnlyBody:
      'Time off requests here are submitted by Room Staff against their own staff record. Admin logins do not have one, so there is nothing to show for your account.',
    roomStaffOnlyHint: 'To log your own time off, use "{menuItem}" in the account menu at the top right.',
    noPendingRequests: 'No pending time off requests.',
    active: 'Active',
    history: 'History',
    pendingCount: '{n} pending',
    adminNotes: 'Admin notes',
    oldest: 'Oldest',
    review: 'Review',
    beforeStartDateError: 'Leave dates cannot be earlier than the staff start date ({date}).',
    afterTerminationDateError: 'Leave dates cannot be later than the staff termination date ({date}).',
  },
  scheduleConflicts: {
    bannerTitle: '{count} schedule conflict(s) need review',
    reasonInactive: 'No longer active as of this date',
    reasonTimeOff: 'Approved time off: {leaveType}',
    goToDay: 'Go to day',
    collapse: 'Collapse',
    expand: 'Expand',
  },
  standaloneFormMessage:
    'Please select your desired location below. If space is not available, you will be automatically directed to add your family to our waitlist.',
  standard: 'Standard',
  start: 'Start',
  startConversationFromComposeTab:
    'To start a conversation, head over to the Compose tab.',
  startConversationFromDirectoryTab:
    'To start a conversation, head over to the Directory tab.',
  startDate: 'Start Date',
  startDateAndTime: 'Start Date and Time',
  startDateCannotBeAfterEndDate: 'Start date cannot be after end date.',
  startDateCannotBeAfterExpiryDate: 'Start date cannot be after expiry date.',
  startDateMustBeEarlier: 'The start date must be earlier than the end date.',
  startOfMonth: 'Start of the Month',
  startingProgram: 'Starting Program',
  startingRate: 'Starting Rate',
  startNap: 'Start Nap',
  startNewConversation: 'Start new conversation',
  startTheConversation: 'Start the conversation...',
  startTime: 'Start Time',
  state: 'State',
  stateProvince: 'Province',
  status: 'Status',
  statusAsOfDate: 'Status As Of Date',
  statusUpdatedAt: 'Status updated at {date}',
  step1: 'Step 1',
  step2: 'Step 2',
  stripe: 'Stripe Account',
  stripeAccount: 'Stripe Account',
  creatingNewRegistrationFor: 'Creating a new registration for',
  register: 'Register',
  student: 'Student',
  studentFirstName: 'Student First Name',
  studentId: 'Student ID',
  studentIdNotFound: 'Student ID not found',
  studentInfoChangesLabel: 'Student Info Changes',
  studentInfoChangesDescription:
    'Review child profile, health, medication, and care information updates before approving them.',
  studentInfoUnsavedChanges: {
    title: 'Unsaved student information',
    description: 'Save or reset your changes before leaving this page.',
  },
  studentLastName: 'Student Last Name',
  studentName: 'Student',
  mbHealthRegistrationNo: ' MB Health Registration No.',
  studentPhin: "Child's PHIN",
  studentReport: 'Student Report',
  studentReportFilter: 'Student Report Filter',
  studentDetail: {
    studentProfile: 'Student Profile',
    updatePhoto: 'Update photo',
    removePhoto: 'Remove photo',
    removePhotoConfirm:
      "Are you sure you want to remove this child's profile photo?",
    studentInfo: 'Student Info',
    schoolInfo: 'School Info',
    careType: 'Care Type',
    guardiansMembers: 'Guardians / Members',
    linkedContacts:
      'No linked contacts | {n} linked contact | {n} linked contacts',
    activeMedicationItems:
      'No active/current items | {n} active/current item | {n} active/current items',
    itemsOnFile: 'No items | {n} item | {n} items',
    fieldsOnFile: 'No fields | {n} field | {n} fields',
    showEndedMedication: 'Show Ended Medication',
    noMedicationOnFile: 'No medication on file.',
    noAllergiesOnFile: 'No allergy or medical condition on file.',
    supportNeedsAndMealRestrictions: 'Support needs and meal restrictions',
    noSpecialNeedsOnFile: 'No special needs on file.',
    menuBasedMealRestrictions: 'Menu-Based Meal Restrictions',
    additionalSubmittedFormDetails: 'Additional submitted form details',
    noCustomFieldsOnFile: 'No custom fields on file.',
    birthDateWithAge: '{date} ({age})',
  },
  students: 'Students',
  studentsSignedIn: '{count} student(s) signed in',
  studentStatus: 'Student Status',
  studentStatuses: 'Student Statuses',
  studentSubStatusTags: 'Student Sub Status Tags',
  studentTags: 'Student Tags',
  style: 'Style',
  subject: 'Subject',
  subjectOverridesByStatus: 'Subject overrides by status (optional)',
  submissionStep: {
    successHeader: 'Registration Request Submitted',
    successInfo: 'Thank you for completing the intake forms',
    warningMessage: 'but please note that this does not guarantee enrollment.',
    successMessage:
      "You've successfully submitted your information to our system, {0}",
    eligibilityMessage:
      'Our administration team is currently reviewing your request to determine eligibility and space availability. We will contact you directly with your status soon. If you have been waitlisted, we will notify you immediately once a space becomes available.',
    successTitle: 'What Happens Next?',
  },
  submit: 'Submit',
  submitAll: 'Submit All',
  submitted: 'Submitted',
  submitAndCertify: 'Submit and Certify',
  submitAndReject: 'Submit and Reject',
  submitAndRequestApproval: 'Submit and Request Approval',
  submitOverride: 'Submit Override',
  submitPayment: 'Submit Payment',
  submitRefund: 'Submit Refund',
  subStatusTags: 'Sub Status Tags',
  success: 'Success',
  successfulAvatar: 'Avatar updated successfully',
  successRedirectUrl: 'Success Redirect URL',
  suffixes: { st: 'st', nd: 'nd', rd: 'rd', th: 'th' },
  superAdmin: 'Super Admin',
  superseded: 'Superseded',
  switchCenter: 'Switch Center',
  symptom: 'Symptom',
  symptoms: 'Symptoms',
  sync: 'Sync',
  syncCancelled: 'Sync Cancelled',
  syncFailed: 'Sync Failed',
  syncFrom: 'Sync From',
  syncSettings: 'Sync Settings',
  syncSucceded: 'Sync Succeded',
  syncWarning: 'Sync Completed with Errors',
  systemDefault: 'System Default',
  tabNotFoundMessage: 'This page does not exist.',
  tags: 'Tags',
  tapStudentsToSignIn: 'Tap each student below to sign them in/out',
  targetGroups: 'Target Groups',
  targetingAndOptions: 'Targeting & Options',
  targetRoles: 'Target Roles',
  task: 'Task',
  taskInfo: 'Task Info',
  tasks: 'Tasks',
  taxReceipt: 'Tax Receipt',
  taxReceipts: 'Tax Receipts',
  teamPromptTitle: 'Pick an Action for {name}',
  teamRatioRules: 'Ratios',
  template: 'Template',
  templateType: 'Template Type',
  terminationDate: 'Termination Date',
  termsAndConditions: 'Terms and Conditions',
  textColor: 'Text Color',
  textSize: 'Text Size',
  textSizeDefault: 'Default',
  textSizeExtraLarge: 'Extra large',
  textSizeLarge: 'Large',
  textSizePreviewBody:
    'Today we practiced counting with blocks and had a great time outside.',
  textSizePreviewTitle: "Emma's daily journal",
  textSizeSmall: 'Small',
  thankYou: 'Thank you!',
  thankYouForSubmission: 'Thank you for your submission.',
  theme: 'Theme',
  thisActionCannotBeUndone: 'This action cannot be undone.',
  thisEvent: 'This event',
  thirdPartySponsors: 'Third Party Sponsors',
  thirdPartySponsorsCount: 'Third Party Sponsors ({count})',
  time: 'Time',
  timeIdentified: 'Time Identified',
  timeInOutMove: 'Time In/Out/Move',
  timeOfAttempt: 'Time of Attempt',
  timeOfContact: 'Time of Contact',
  timesToBeAdministered: 'Admin Times',
  timeZone: 'Time Zone',
  title: 'Title',
  to: 'To',
  toDate: 'To Date',
  today: 'Today',
  toggleAttendancePanel: 'Toggle Attendance Panel',
  toggleInfoChangeDetails: 'Toggle info change details',
  token: 'Token',
  tokenExpired: 'Token Expired',
  total: 'Total',
  totalCount: '{count} total',
  totalBilling: 'Total Billing',
  totalChargebackAmount: 'Total Chargeback Amount',
  totalChargebackPaymentFee: 'Total Chargeback Fee',
  totalCurrentAutoBilling: 'Total Current Auto Billing',
  totalDeposit: 'Total Deposit',
  totalFailedPaymentFee: 'Total Failed Fee',
  totalPayment: 'Total Payment',
  totalPaymentAmount: 'Total Payment Amount',
  totals: 'Totals',
  totalAmountOfSelectedInvoices: 'Total amount of selected invoices',
  transactionType: 'Transaction Type',
  transitNumber: 'Transit Number',
  transport: 'Transport',
  multiple: 'Multiple',
  transportGroup: 'Transport Group',
  transportGroups: 'Transport Groups',
  transportSpaces: 'Transport Spaces',
  triggerBy: 'Trigger By',
  tryAdjustingFilters: 'Try adjusting your filters',
  tryNewLook: 'Try new look',
  type: 'Type',
  typeMessage: 'Type a message...',
  typeYourMessage: 'Type your message...',
  typicalBreak: 'Typical Break (Minutes)',
  unassignedBalance: 'Unassigned Bal.',
  unassignedImmunizationFiles: 'Unassigned Immunization Files',
  uncancelEnrollmentButtonLabel: 'Uncancel Enrollment',
  underpaymentAdjustment: 'Underpayment Adjustment',
  underpaymentAmountTooLow:
    'The underpayment amount is less than some invoices, please select fewer invoices',
  underpaymentDifferenceMessage:
    "There's a difference of -{diff} between the amount you entered and the invoices/credit memos you selected. We will adjust the invoices/credit memo(s) selected as shown below and then create a new invoice to account for the balance still owing.",
  undo: 'Undo',
  unHide: 'Unhide',
  uniqueAgeGroupError: 'Age Dictionary name must be unique.',
  unit: 'Unit',
  unmuteNotifications: 'Unmute Notifications',
  unpinNotification: 'Unpin notification',
  unverified: 'Unverified',
  unread: 'Unread',
  unsignedMedicationsBannerMessage:
    '{studentName} has one or more medication(s) that require your approval due to a staff member adding or updating their medication information.  Please review the updated medication information for your child, make changes if necessary, and save the changes to inform the center of your approval.',
  untilDate: 'until {date}',
  untilWithdraw: 'Until Withdraw',
  upcomingRegistrations: 'Upcoming Registrations',
  update: 'Update',
  updated: 'Updated',
  updateOverride: 'Update Override',
  updateOverrideNotes: 'Update the override notes for this report.',
  upload: 'Upload',
  uploadAt: 'Upload At',
  uploadedFiles: 'Uploaded Files',
  uploadEmailSignature: 'Upload Email Signature',
  uploadFiles: 'Upload File(s)',
  uploadImmunizationFile: 'Upload Immunization File',
  uploadImmunizationFiles: 'Upload Immunization Files',
  uploadingFile: 'Uploading...',
  uploadPathMissing: 'Missing upload path.',
  uploadPhotosButtonLabel: 'Upload photos/files',
  uploadTaxSignature: 'Upload Tax Receipt Signature',
  uploadUrlFailed: 'Failed to get upload URL.',
  urgent: 'Urgent',
  urgentMessage: 'Urgent Message',
  url: 'Url',
  urlCopied: 'Url Copied to Clipboard',
  useCustomEmail: 'Use Custom Email?',
  username: 'Username',
  users: 'Users',
  userTable: {
    errors: {
      minimum_one_org_admin: 'At least one organization admin is required',
    },
  },
  vacationOrHoliday: 'Vacation / Holiday',
  value: 'Value',
  variableJsonCopied: 'Variable JSON copied to clipboard',
  verification: 'Verification',
  verificationConfirmation:
    'A verification email will be sent to the provided email, please make sure this email is valid.',
  verifiedAbsent: 'Verified Absent',
  verify: 'Verify',
  verifyBusinessInformation:
    'Please ensure business information is correct before saving',
  verifyEmail: 'Please verify your email first before sending emails',
  verifyOwner: 'Verify Owner',
  verifyRotessa: 'Verify Rotessa Owner',
  verifyRotessaSandbox: 'Approve Sandbox Acount',
  versionHistory: 'Version History',
  versionNotice: 'You are viewing a past version',
  videoTooLong: 'Video exceeds maximum length of {videoLength} seconds',
  view: 'View',
  viewRegistrationData: 'View registration data',
  viewAgreementHistory: 'View agreement history',
  viewAttemptsLog: 'View attempts log',
  viewEvent: 'View Event',
  viewFile: 'View file',
  viewGroupReport: 'View Group Report',
  viewingEventInstanceMessage:
    'You are viewing an instance of an event in a series.',
  viewMemberProfile: 'View member profile',
  viewOrModifySeries: 'View/Modify Series',
  viewOutcomes: 'View Outcomes',
  viewPIN: 'View PIN',
  viewPhoto: 'View full photo',
  viewPreview: 'View Preview',
  viewRecurringDetails: 'View Recurring Details',
  viewResponsePdf: 'View response PDF',
  viewSeries: 'View Series',
  viewShoppingListForGroup: 'View shopping list for this group',
  visibility: 'Visibility',
  voidCheck: 'Void Check',
  volunteerExpiryDate: 'Volunteer Expiry Date',
  voPayAccountSetup: 'VoPay Account Setup',
  voPayAccountSetupDescription:
    'VoPay is the payment processor used by ChildFriendly to handle Interac E-Transers. Please review the details below and proceed with submission.',
  waitlist: 'Waitlist',
  waitListDeposit: 'Waitlist Deposit ($)',
  waitlistedOnly: 'Waitlisted only',
  waitlistToPending: 'Waitlist to Pending',
  waitlistToPendingDesc:
    'Email sent when a child is moved from the Waitlist to Pending',
  waitlistToRegistered: 'Waitlist to Registered',
  waitlistToRegisteredDesc:
    'Email sent when a child is moved directly from the Waitlist to Registered',
  wantToUseADifferentEmailOrCenterPrompt:
    'Want to use a different email or center?',
  wantToUseADifferentEmailPrompt: 'Want to use a different email?',
  warningEditsToSeries:
    'Any edits to the series will remove any individual event modifications.',
  weatherOrTransport: 'Weather / Transport Issue',
  webForm: 'Web Form',
  webFormDepositAgreement: 'Online Registration Payment Terms',
  webFormEmail: 'Email Confirmation',
  webFormRegistration: 'Online Registration Customization',
  customOnlineRegistrationQuestions: 'Custom Online Registration Questions',
  webOutdated:
    "Please clear your browser's cache and reload this page. You can use the following shortcuts to clear the cache and reload this page:",
  week: 'Week',
  weekOf: 'Week Of',
  weeks: 'Weeks',
  weekly: 'Weekly',
  welcomeBack: 'Welcome back',
  welcomeToChildFriendly: 'Welcome!',
  whatIsPAD: 'What is PAD?',
  whoConfirmed: 'Who Confirmed',
  whatIsPreAuthorizedCCPayment: 'What is Pre-Authorized Credit Card Payment?',
  whenToManage: 'When To Manage',
  whichUserAreYouPrompt: 'Which of the following describes you?',
  willAddMoves:
    'Will add the following entries to correct the history of moves',
  willChangeLogs: 'Will modify the following logs',
  withAvailableCredits: 'With Available Credits',
  withdrawalDate: 'Withdrawal Date',
  workAddress: 'Work Address',
  workContactInfo: 'Work Contact Info',
  workspaceViews: 'Workspace views',
  workPhone: 'Work Phone',
  writeAMessage: 'Write a message...',
  year: 'Year',
  yearEnd: 'Year End',
  yearly: 'Yearly',
  years: 'Years',
  yes: 'Yes',
  yesOverwrite: 'Yes, overwrite existing adjustments',
  yesterday: 'Yesterday',
  you: 'You',
  viewProfile: 'View Profile',
  debug: {
    formButton: 'Open form debug',
    formState: 'Form State',
    close: 'Close',
    summary: 'Summary',
    values: 'Values',
    errors: 'Errors',
    meta: 'Meta',
    isSubmitting: 'Is Submitting',
    canSubmit: 'Can Submit',
    dirtyFields: 'Dirty Fields',
    totalErrors: 'Total Errors',
    errorFields: 'Error Fields',
    none: 'None',
    refresh: 'Refresh',
  },
  actionSummary: 'Completed Actions',
  checkedInTo: 'Checked in to {space}',
  checkedOutFrom: 'Checked out from {space}',
  checkingAvailability: 'Checking availability...',
  selectStudentsToSignInOut: 'Select students to drop-off or pick-up',
  clickSignInOutButtons:
    'Click the Pick Up or Drop Off button for each student',
  studentsModified: '{count} student(s) modified',
  currentlyCheckedOut: 'Currently checked out',
  signIn: 'Sign In',
  noChangesTitle: 'No Changes Made',
  noChangesMessage:
    "You haven't signed any students in or out yet. Click the Pick Up or Drop Off button for each student you want to modify.",
  exitAnyway: 'Exit Anyway',
  pickUp: 'Pick Up',
  dropOff: 'Drop Off',
  agreementsSignedReport: 'Agreements Signed',
  agreementsToTrack: 'Agreements to Track',
  hideChildrenWithAllSelectedAgreementsSigned:
    'Hide children with all selected agreements signed',
  signed: 'Signed',
  signedOn: 'Signed on',
  attendanceEditRequestSubmitted: 'Edit submitted for approval',
  attendanceEditRequestUpdated: 'Pending edit updated',
  attendanceRecordDetails: '{type} record details',
  updateLesson: 'Update Lesson',
  updateChannel: {
    heading: 'App Updates',
    description:
      'Choose which over-the-air update channel this device receives. Use the quality-assurance channel to test pre-release builds.',
    title: 'Update Channel',
    label: 'Channel',
    current: 'Current version: {version}',
    reset: 'Reset to default channel',
    switched: 'Channel updated',
    notAllowed: 'Only super admins can change the update channel',
    loadFailed: 'Could not load update channels',
    switchFailed: 'Could not switch channel',
    resetFailed: 'Could not reset channel',
  },
  featureToggles: {
    title: 'Feature Toggles',
    addFeature: 'Add Feature',
    createTitle: 'Create Feature Toggle',
    editTitle: 'Edit Feature Toggle',
    displayName: 'Display Name',
    displayNameHint: 'Human-readable name for this feature',
    featureKey: 'Feature Key',
    featureKeyHint: 'Auto-generated from name. Edit to override.',
    featureKeyReadonlyHint: 'Feature key cannot be changed',
    description: 'Description',
    descriptionHint: 'Optional description of what this feature does',
    enabledByDefault: 'Enabled by Default',
    enabled: 'Enabled',
    createdByLabel: 'Created: {date} by {user}',
    updatedByLabel: 'Updated: {date} by {user}',
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
    close: 'Close',
    name: 'Name',
    global: 'Global',
    overrides: 'Overrides',
    override: 'override',
    overridesLower: 'overrides',
    actions: 'Actions',
    checkStatus: 'Check Status',
    checkTitle: 'Feature Check',
    organization: 'Organization',
    centerOptional: 'Center (optional)',
    noResults: 'No results',
    checking: 'Checking...',
    selectOrgPrompt: 'Select an organization to check feature status',
    enabledStatus: 'Enabled',
    disabledStatus: 'Disabled',
    resolvedFromLabel: 'Resolved from:',
    resolutionPathTitle: 'Resolution Path',
    stepGlobal: 'Global',
    stepOrg: 'Org',
    stepCenter: 'Center',
    checkFailed: 'Failed to check feature',
    edit: 'Edit',
    delete: 'Delete',
    emptyState: 'No feature toggles found. Click "Add Feature" to create one.',
    deleteTitle: 'Delete Feature Toggle',
    deleteConfirm:
      'Are you sure you want to delete "{name}" ({key})? This will also delete all overrides.',
    overridesDialogTitle: 'Feature Overrides',
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
    addOverride: 'Add Override',
    noOverridesConfigured:
      'No overrides configured. The global setting applies to all organizations and centers.',
    orgOverrideLabel: 'Org override',
    noOrgOverride: 'No org override',
    centerCountLabel: '{count} center(s)',
    organizationWide: 'Organization-Wide',
    specificCenters: 'Specific Centers',
    appliesToAllCenters: 'Applies to all centers without specific overrides',
    orgBadge: 'Org',
    centerBadge: 'Center',
    removeOrgOverride: 'Remove Org Override',
    removeCenterOverride: 'Remove Center Override',
    selectOrganization: 'Select Organization',
    selectCenters: 'Select Centers',
    overrideType: 'Override Type',
    selectAtLeastOneCenter: 'Select at least one center',
    centersSelectedLabel: '{count} center(s) selected',
    addOrgOverride: 'Add Org Override',
    addCenterOverrides: 'Add Center Overrides',
    addCenterOverridesCount: 'Add {count} Center Override(s)',
    unknownOrganization: 'Unknown Organization',
    unknownCenter: 'Unknown Center',
    removeOverrideTitle: 'Remove Override',
    removeOverrideMessageOrg:
      'Remove the override for this organization? It will inherit the global setting.',
    removeOverrideMessageCenter:
      'Remove the override for this center? It will inherit the organization or global setting.',
    validation: {
      nameRequired: 'Name is required',
      min3: 'Minimum 3 characters',
      max200: 'Maximum 200 characters',
      keyRequired: 'Feature key is required',
      keyFormat: 'Must be uppercase with underscores',
      max100: 'Maximum 100 characters',
      max1000: 'Maximum 1000 characters',
    },
  },
  unsavedWork: {
    title: 'You have unsaved changes',
    message: "Your changes haven't been saved yet.",
    planMessage: "This lesson plan has changes you haven't saved yet.",
    saveAndExit: 'Save and exit',
    discardAndExit: 'Discard and exit',
    fixErrors: 'Please fix the highlighted errors before saving.',
  },
  systemLogs: {
    typeFilter: 'Type',
    messageFilter: 'Search message',
    viewDetails: 'View full message',
    detailsTitle: 'Log Details',
    close: 'Close',
    createdAtLabel: 'Created At',
    typeLabel: 'Type',
    createdByLabel: 'Created By',
    logIdLabel: 'Log Id',
    messageLabel: 'Message',
  },
  fileFolder: 'File Folder',
  allowPopupsToViewFile: 'Please allow popups to view the file.',
  unableToPreviewFileType: 'Unable to preview this file type.',
  root: 'Root',
  emptyFolder: 'Empty folder',
  dragToMove: 'Drag to move',
  protectedBlob: 'Protected — this item cannot be moved, renamed or deleted',
  folderName: 'Folder name',
  nameCannotBeEmpty: 'Name cannot be empty',
  nameCannotContainBlockedCharacters: 'Names cannot contain / \\ or $',
  protectedNameNotAllowed: 'Cannot name a file or folder using a protected name',
  protectedFolderNotWritable: 'Files cannot be uploaded into a protected folder',
  fileExplorerHint: 'Drag items onto a folder to move them · right click for actions',
  deleteFolderTitle: 'Confirm Delete',
  deleteFolderWithContents:
    'There are still contents within this folder, are you sure you want to delete?',
}
